import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Breadcrumb,
  Tab,
  Nav,
  Form,
  Modal,
  Accordion,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { firestore as db } from "../config/Config";
import { useLocation } from "react-router-dom";
import { Collapse } from "bootstrap";
import { useSelector, useDispatch, Provider } from "react-redux";
import { fetchKitchenList } from "../redux/kitchenReducer";
import { useNavigate } from "react-router-dom";
import { auth } from "../config/Config";
import { createRooms } from "../redux/addRoomReducer";
import { updateRooms } from "../redux/updateRoomsReducer";
import { updateRooms2 } from "../redux/updateRooms2Reducer";
import { fetchProjectList } from "../redux/projectReducer";
import { fetchRoomList } from "../redux/viewRoomReducer";

import Sidebar from "./SidebarNav";
import Swal from "sweetalert2";


export default function EditRooms({ clientDataFor }) {




  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const data = location.state;
  // console.log("data for checking for edit room", data.editData.priceMode );
  console.log("data for checking for edit room", data);

  // Auto-Save Database Draft Setup
  const clientId = data?.id || data?.ID || data?.AssignedclientID || '';
  const collectionName = data?.path === 'assigneRooms' ? 'AssignedRooms' : 'Rooms';
  const designId = data?.editData?.ID || data?.editData?.id || '';
  const isEditingDraft = Boolean(
    data?.editData?.isDraft === true ||
    data?.editData?.draftTag === 'Draft Saved Copy' ||
    data?.editData?.isDraftCopy === true ||
    (designId && String(designId).startsWith('draft_'))
  );
  const targetDraftId = isEditingDraft ? designId : `draft_${designId}`;
  const localDraftKey = clientId && targetDraftId ? `draft_card_${clientId}_${targetDraftId}` : '';
  const realOriginalId = data?.editData?.draftOfId || (designId && String(designId).startsWith('draft_') ? String(designId).replace(/^draft_/, '') : designId);
  const resolvedRoomTypeName = data?.editData?.roomTypeName || data?.roomTypeName || data?.['roomName'] || data?.editData?.roomName || '';

  // Synchronous LocalStorage Cache: ensures draft is never lost on tab close or slow network
  const cachedDraft = React.useMemo(() => {
    if (!localDraftKey) return null;
    try {
      const raw = localStorage.getItem(localDraftKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && Array.isArray(parsed.title) && parsed.title.length > 0) {
          const dataTime = new Date(data?.editData?.updatedAt || 0).getTime();
          const cacheTime = new Date(parsed.updatedAt || 0).getTime();
          if (cacheTime >= dataTime || parsed.title.length >= (data?.editData?.title?.length || 0)) {
            return parsed;
          }
        }
      }
    } catch (e) { }
    return null;
  }, [localDraftKey, data]);

  const [isDraftRestored] = useState(() => isEditingDraft || Boolean(cachedDraft));
  const isExplicitSavedRef = React.useRef(false);
  const isFormDirtyRef = React.useRef(false);
  const initialSnapshotRef = React.useRef(null);
  const latestFormDataRef = React.useRef(null);
  const pendingSavePromiseRef = React.useRef(null);
  const isSavingRef = React.useRef(false);
  const latestFieldsRef = React.useRef(null);

  // Sync cached draft to Firestore if restored from LocalStorage
  useEffect(() => {
    if (cachedDraft && clientId && targetDraftId) {
      db.collection("client").doc(clientId).collection(collectionName).doc(targetDraftId).set(cachedDraft, { merge: true }).catch(() => { });
    }
  }, [cachedDraft, clientId, targetDraftId, collectionName]);

  const getRealRoomId = () => {
    if (data?.editData?.draftOfId) return data.editData.draftOfId;
    const rawId = data?.editData?.ID || data?.editData?.id || '';
    if (rawId.startsWith('draft_')) return rawId.replace(/^draft_/, '');
    return rawId;
  };

  const clearDraftInFirestore = React.useCallback(async () => {
    if (!clientId) return;
    const realId = getRealRoomId();
    try {
      if (localDraftKey) localStorage.removeItem(localDraftKey);
      localStorage.removeItem(`draft_card_${clientId}_draft_${realId}`);
      localStorage.removeItem(`draft_card_${clientId}_${designId}`);
      if (realId) {
        localStorage.removeItem(`draft_card_${clientId}_${realId}`);
      }
      const deletePromises = [];
      if (realId) {
        deletePromises.push(db.collection("client").doc(clientId).collection(collectionName).doc(`draft_${realId}`).delete().catch(() => { }));
      }
      if (designId && (designId.startsWith('draft_') || isEditingDraft)) {
        deletePromises.push(db.collection("client").doc(clientId).collection(collectionName).doc(designId).delete().catch(() => { }));
      }
      await Promise.all(deletePromises);
    } catch (e) {
      console.error("Error clearing draft in Firestore:", e);
    }
  }, [clientId, collectionName, designId, isEditingDraft, localDraftKey]);

  const editTitleToUse = (cachedDraft?.title && Array.isArray(cachedDraft.title) && cachedDraft.title.length > 0)
    ? cachedDraft.title
    : (data?.editData?.title && Array.isArray(data.editData.title) && data.editData.title.length > 0)
      ? data.editData.title
      : null;

  const editFieldsToUse = (cachedDraft?.fields && Array.isArray(cachedDraft.fields) && cachedDraft.fields.length > 0)
    ? cachedDraft.fields
    : (data?.editData?.fields && Array.isArray(data.editData.fields) && data.editData.fields.length > 0)
      ? data.editData.fields
      : [];

  const getComparableSnapshot = React.useCallback((dataArr) => {
    if (!dataArr || !Array.isArray(dataArr)) return '';
    return JSON.stringify(
      dataArr.map((item) => ({
        name: String(item?.name || '').trim(),
        label: String(item?.label || '').trim(),
        label2: String(item?.label2 || '').trim(),
        value: Number(item?.value) || 0,
        value2: Number(item?.value2) || 0,
        width: String(item?.width || '').trim(),
        height: String(item?.height || '').trim(),
        qnty: String(item?.qnty || '').trim(),
        rft: String(item?.rft || '').trim(),
        area: String(item?.area || '').trim(),
        depth: String(item?.depth || '').trim(),
        painting: String(item?.painting || '').trim(),
        price: Number(item?.price) || 0,
        remark: String(item?.remark || '').trim(),
        type: String(item?.type || '').trim(),
      }))
    );
  }, []);

  const initialBaselineSnapshot = React.useMemo(() => {
    return getComparableSnapshot(editTitleToUse);
  }, [editTitleToUse, getComparableSnapshot]);



  // const { looseThingsData } = useSelector(
  //   (state) => state.looseThings
  // );
  const { userData, userLoader, userError } = useSelector((state) => state.viewusers);
  const { updateModal } = useSelector((state) => state.updateRoom);
  // const data.priceType= data.editData.priceMode;
  // console.log("priceState",priceState);
  console.log("data", data);

  // Room Type 

  const [roomType, setRoomType] = useState(data?.['roomType'] || '');
  const [roomTypeName, setRoomTypeName] = useState(data?.['roomName'] || '');
  const [roomTypeDesign, setRoomTypeDesign] = useState("");
  const [roomTypeDescription, setRoomTypeDescription] = useState("");
  const [roomTypeModal, setRoomTypeModal] = useState(data?.editData?.roomType || '');
  const [roomTypePrice, setRoomTypePrice] = useState(data?.editData?.roomTypePrice || 0);
  const [hoveredItem, setHoveredItem] = useState(null);
  //////////////////////////

  useEffect(() => {
    initialSnapshotRef.current = null;
    sortedData();
  }, [roomTypeModal]); // Include roomTypeModal as a dependency

  const [filteredDataField, setFilteredDataField] = useState(() => (
    editFieldsToUse && Array.isArray(editFieldsToUse) && editFieldsToUse.length > 0 ? editFieldsToUse : []
  ));
  /////////////////////////
  console.log('roomTypePrice', roomTypePrice);
  console.log('filteredDataField', filteredDataField);

  const [roomTypeWoodPrice, setRoomTypeWoodPrice] = useState(0);
  const [isSaving, setIsSaving] = useState(false);

  const isItemFilled = (obj) => {
    if (!obj) return false;
    if (obj.price && Number(obj.price) > 0) return true;
    if (obj.value && Number(obj.value) > 0) return true;
    if (obj.value2 && Number(obj.value2) > 0) return true;
    if (
      obj.label &&
      String(obj.label).trim() !== '' &&
      String(obj.label).trim().toLowerCase() !== 'none' &&
      obj.label !== '0' &&
      obj.label !== 0
    ) {
      return true;
    }
    if (
      obj.label2 &&
      String(obj.label2).trim() !== '' &&
      String(obj.label2).trim().toLowerCase() !== 'none' &&
      obj.label2 !== '0' &&
      obj.label2 !== 0
    ) {
      return true;
    }
    const dimensionFields = ['area', 'height', 'qnty', 'rft', 'width', 'depth', 'length'];
    for (let i = 0; i < dimensionFields.length; i++) {
      const val = obj[dimensionFields[i]];
      if (val !== '' && val !== null && val !== undefined && val !== 0 && val !== '0') {
        return true;
      }
    }
    return false;
  };

  // Strips undefined values so Firestore never throws "Unsupported field value: undefined"
  function sanitizeForFirestore(obj) {
    if (obj === undefined) return null;
    if (obj === null || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(sanitizeForFirestore);
    const clean = {};
    for (const [k, v] of Object.entries(obj)) {
      if (v !== undefined) clean[k] = sanitizeForFirestore(v);
    }
    return clean;
  }

  const performSaveRoom = React.useCallback(async (updatedFormData, newRoomPrice, newRoomWoodPrice) => {
    if (isSavingRef.current) return;
    isSavingRef.current = true;
    setIsSaving(true);

    isExplicitSavedRef.current = true;
    isFormDirtyRef.current = false;
    const realRoomId = getRealRoomId();
    const cleanRoomTypeName = (data?.editData?.roomTypeName || '').replace(/\s*\(Draft\)/g, '').trim();
    const cleanRoomTypeDesign = (data?.editData?.roomTypeDesign || '').replace(/\s*\(Draft\)/g, '').trim();

    const savePayload = {
      title: updatedFormData,
      fields: filteredDataField,
      roomTypePrice: newRoomPrice,
      roomTypeWoodPrice: newRoomWoodPrice,
      roomTypeName: cleanRoomTypeName || undefined,
      roomTypeDesign: cleanRoomTypeDesign || undefined,
      isDraft: false,
      draftTag: null,
      draftId: designId,
      updatedAt: new Date().toISOString()
    };

    // 1. Purge LocalStorage draft items immediately
    if (localDraftKey) localStorage.removeItem(localDraftKey);
    if (clientId) {
      if (realRoomId) {
        localStorage.removeItem(`draft_card_${clientId}_draft_${realRoomId}`);
        localStorage.removeItem(`draft_card_${clientId}_${realRoomId}`);
      }
      if (designId) {
        localStorage.removeItem(`draft_card_${clientId}_${designId}`);
      }
    }

    try {
      const apiBase = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
        ? 'http://localhost:7000'
        : 'https://us-central1-fabdiz-quote.cloudfunctions.net/api';

      const targetEndpoint = data.path === 'assigneRooms'
        ? `${apiBase}/assigne-rooms/${clientId}/${realRoomId}`
        : `${apiBase}/project-rooms/${clientId}/${realRoomId}`;

      let backendSaved = false;
      try {
        const response = await fetch(targetEndpoint, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(savePayload)
        });
        if (response.ok) {
          backendSaved = true;
        }
      } catch (netErr) {
        console.warn("Backend API request failed, falling back to direct Firestore:", netErr);
      }

      // If backend was unreachable or returned an error, fallback to direct Firestore save
      if (!backendSaved && clientId && realRoomId) {
        const cleanPayload = sanitizeForFirestore(savePayload);
        await db.collection("client").doc(clientId).collection(collectionName).doc(realRoomId).set(cleanPayload, { merge: true });
        await clearDraftInFirestore();
      }

      // Refresh Redux list and navigate immediately
      dispatch(fetchRoomList({ Id: clientId }));
      const targetPath = data.path === 'assigneRooms' ? "/assigned/view-rooms" : "/projects/view-rooms";
      navigation(targetPath, { state: data });
    } catch (err) {
      console.error("Error saving room:", err);
      setIsSaving(false);
      isSavingRef.current = false;
    }
  }, [clientId, collectionName, data, filteredDataField, clearDraftInFirestore, dispatch, navigation, localDraftKey, designId]);

  const [defkey, setDefkey] = useState('room');

  const handleRoomTypeCancel = () => {
    setRoomType("");
    setRoomTypeName("");
    setRoomTypeDesign("");
    setRoomTypeDescription("");

    const returnPath = data?.path === 'assigneRooms' ? "/assigned/view-rooms" : "/projects/view-rooms";
    handleNavigateBackOrExit(returnPath, data);
  }

  const handleRoomTypeSubmit = (e) => {
    e.preventDefault();
    const roomData = [{ 'roomType': roomType }, { 'roomTypeName': roomTypeName }, { 'roomTypeDesign': roomTypeDesign }, { 'roomTypeDescription': roomTypeDescription }];
    localStorage.setItem("roomTypeData", JSON.stringify(roomData));


  }

  const [roomData, setRoomData] = useState([]);


  // Material things

  const [kitchenBaseGrandTotal, setKitchenBaseGrandTotal] = useState(0);

  const [materialType, setMaterialType] = useState("");
  const [materialLabel, setMaterialLabel] = useState(0);
  const [materialValue, setMaterialValue] = useState(0);
  const [modalTitle, setModalTitle] = useState("");
  const [modalUrl, setModalUrl] = useState("");
  const [materialWidth, setMaterialWidth] = useState(0);
  const [materialHeight, setMaterialHeight] = useState(0);
  // const [materialDepth, setMaterialDepth] = useState(2);
  const [materialQuantity, setMaterialQuantity] = useState(0);
  const [materialPrice, setMaterialPrice] = useState(0);
  const handleFistItem = (name) => {
    setModalTitle(name.label);
    setModalUrl(name.url);
  };
  const handleCalculation = (e) => {
    setMaterialPrice(
      materialType * materialWidth * materialHeight * materialQuantity
    );
  };








  const handleLogOut = () => {
    auth.signOut();
    // navigation('/login');
  }



  // Save Room types and name

  const handleSaveNameType = () => {
    // alert('everything');

    const roomDatas = {

      title: '',
      roomType: roomType,
      roomTypeName: roomTypeName,
      roomTypeDesign: roomTypeDesign,
      roomTypeDescription: roomTypeDescription,
      roomTypePrice: 0,
      roomTypeWoodPrice: 0,
      id: data.ID,
    };


    dispatch(createRooms(roomDatas));
    navigation("/projects/view-rooms", { state: data });
  }

  // Save Everything Calculation & Headings

  const handleSaveEverything = () => {
    // alert('everything');

    const roomDatas = {

      // title : [{'accordin' : [modalTitle, modalUrl, kitchenBaseGrandTotal]},{'material' : [materialType, materialWidth, materialHeight, materialQuantity, materialPrice]},{'baseHandleType' : [accessoriesBaseHandleType, accessoriesBaseHandleQuantity, accessoriesBaseHandlePrice]},{'thaliBasket' : [accessoriesThaliBasketType, accessoriesThaliBasketQuantity, accessoriesThaliBasketPrice]},{'thaliInlet' : [accessoriesThaliInletType, accessoriesThaliInletQuantity, accessoriesThaliInletPrice]},{'dustbinBasic' : [accessoriesDustbinBasicType, accessoriesDustbinBasicQuantity, accessoriesDustbinBasicPrice]},{'wickerBasket' : [accessoriesWickerBasketBasicType, accessoriesWickerBasketBasicQuantity, accessoriesWickerBasketBasicPrice]},{'detergentHolder' : [accessoriesDetergentHolderBasicType, accessoriesDetergentHolderBasicQuantity, accessoriesDetergentHolderBasicPrice]}],
      title: roomData,
      roomType: roomType,
      roomTypeName: roomTypeName,
      roomTypeDesign: roomTypeDesign,
      roomTypeDescription: roomTypeDescription,
      roomTypePrice: kitchenBaseGrandTotal,
      id: data.ID,
    };


    dispatch(createRooms(roomDatas));
    navigation("/projects/view-rooms", { state: data });
  }





  // dynamic for kitchen furniture 

  const { kitchenThingsData } = useSelector(
    (state) => state.kitchenThings
  );

  //dynamic for extra items in every room
  const [extraItemMeasure, setExtraItemMeasure] = useState('');
  const [extraItemName, setExtraItemName] = useState('');
  const [extraItemMaterialName, setExtraItemMaterialName] = useState('');
  const [extraItemMaterialValue, setExtraItemMaterialValue] = useState(0);
  // console.log('extraItemMaterialValue',kitchenThingsData);

  const [isChecked, setIsChecked] = useState(false);
  const [extraItemType, setExtraItemType] = useState('');

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    // You can set the data based on the checkbox state here
    setExtraItemType(event.target.checked ? 'woodwork' : '');
  };



  // 🧩 Validation logic




  const [kitchenThingsDataCopy, setKitchenThingsDataCopy] = useState(
    editFieldsToUse && editFieldsToUse.length > 0
      ? editFieldsToUse.map((item) =>
        !item.table ? { ...item, table: "kitchen" } : item
      )
      : kitchenThingsData
  );



  // const someVariable = data.editData.hasOwnProperty("fields") && data.editData.fields !== "" ? data.editData.fields : kitchenThingsData;

  // const [kitchenThingsDataCopy, setKitchenThingsDataCopy] = useState(data.editData.hasOwnProperty("fields") ? data.editData.fields !== "" ? data.editData.fields : kitchenThingsData);


  const [kitchenFormData, setKitchenFormData] = useState(
    editTitleToUse && editTitleToUse.length > 0
      ? editTitleToUse.map((item) => ({
        name: item.name || "",
        label: item.label || "",
        value: item.value || 0,
        valueIncresed: item.valueIncresed || 0,
        width: item.width || "",
        height: item.height || "",
        qnty: item.qnty || "",
        rft: item.rft || "",
        area: item.area || "",
        price: item.price || 0,
        remark: item.remark || "",
        type: item.type || "",
      }))
      : kitchenThingsDataCopy.map((item) => ({
        name: item.name,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: item.type,
      }))

  );

  console.log("kitchenFormData", kitchenFormData);

  console.log("kitchenThingsDataCopy", kitchenThingsDataCopy);

  const addNewKitchenItem = () => {

    const nameExists = kitchenFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }

    setFilteredDataField([
      ...filteredDataField,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        table: "kitchen",
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setKitchenFormData([
      ...kitchenFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };




  const handleKitchenChange = (e, index, field) => {
    console.log(e);
    console.log("newValue", index);
    console.log(field);

    const newValue = parseFloat(e.target.value) || 0;
    console.log('newValue', newValue);
    // console.log('newValue',kitchenThingsDataCopy);

    // const newValue = e.target.value;
    const updatedKitchenFormData = [...kitchenFormData];

    console.log('updatedKitchenFormData', updatedKitchenFormData);

    const item = updatedKitchenFormData[index];

    const incrementPercentage = data['increment'] / 100;

    if (filteredDataField[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
        // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

      } else {
        item.price = Math.round(item.value * newValue);

      }
    } else if (filteredDataField[index].measurement === "width") {
      const rr = item[field] = newValue;
      // console.log('newValue',rr);
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        // roomTypeWoodPrice += item.price;
        // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);

      }
    } else if (filteredDataField[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
        // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

      } else {
        item.price = Math.round(item.value * newValue);

      }
    } else if (filteredDataField[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

      } else {
        item.price = Math.round(item.value * item.height * item.width);

      }
    } else if (filteredDataField[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
        // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

      } else {
        item.price = Math.round(item.value * newValue);

      }
    }

    // Update the state with the modified data
    updatedKitchenFormData[index] = item;
    setKitchenFormData(updatedKitchenFormData);
    console.log("newValue ", filteredDataField);
    console.log("newValue ", updatedKitchenFormData);
  };


  const handleKitchenPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedKitchenFormData = [...kitchenFormData];
    const item = updatedKitchenFormData[index];
    item[field] = newValue;
    // Update the state with the modified data
    updatedKitchenFormData[index] = item;
    setKitchenFormData(updatedKitchenFormData);
    // console.log("price checking", kitchenFormData);
  };


  const handleKitchenRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedKitchenFormData = [...kitchenFormData];
    const item = updatedKitchenFormData[index];
    item[field] = newValue;
    // Update the state with the modified data
    updatedKitchenFormData[index] = item;
    setKitchenFormData(updatedKitchenFormData);
    // console.log("price checking", kitchenFormData);
  };

  const handleKitchenOptionChange = (e, index) => {
    const value = e.target.value;
    const selectedLabel = e.target.label;
    console.log(value);
    console.log(selectedLabel);

    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const incrementPercentage = data['increment'] / 100;
    setKitchenFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));
      newData[index]['label'] = selectedLabel;

      // console.log(newData);
      // Recalculate the price based on the selected value
      const item = newData[index];
      if (filteredDataField[index].measurement === "area") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
          // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

        } else {
          item.price = Math.round(value * item.area);

        }
      } else if (filteredDataField[index].measurement === "width") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
          // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);

        }
      } else if (filteredDataField[index].measurement === "qty") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
          // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

        } else {
          item.price = Math.round(value * item.qnty);

        }
      } else if (filteredDataField[index].measurement === "length") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
          // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

        } else {
          item.price = Math.round(value * item.height * item.width);

        }
      } else if (filteredDataField[index].measurement === "rft") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
          // setRoomTypeWoodPrice(prevPrice => prevPrice + item.price);

        } else {
          item.price = Math.round(value * item.rft);

        }
      }

      return newData;
    });
  };

  const calculateKitchenTotal = () => {
    let newTotal = 0;
    // console.log('newTotal',newTotal);

    for (let i = 0; i < kitchenFormData.length; i++) {
      // console.log('length',kitchenFormData.length );
      // console.log('inside',kitchenFormData[i].price );

      const price = parseFloat(kitchenFormData[i].price) || 0;
      newTotal += price;

    }


    return Math.round(newTotal);;
  };

  useEffect(() => {
    const newKitchenTotal = calculateKitchenTotal();
    // console.log("kitchenPrice", newKitchenTotal);
    setRoomTypePrice(newKitchenTotal);
    // console.log('kitchenFormData',kitchenFormData);
  }, [kitchenFormData]); // This will update the total whenever formData changes.


  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = kitchenFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [kitchenFormData]);

  const saveKitchenData = async () => {
    if (isSavingRef.current) return;
    isExplicitSavedRef.current = true;
    isFormDirtyRef.current = false;

    // Recalculate prices
    const updatedKitchenFormData = kitchenFormData.map(item => {
      const incrementPercentage = data['increment'] / 100;
      let newPrice = 0;

      if (item.type === "woodwork") {
        if (item.area) {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        }
      } else {
        if (item.area) {
          newPrice = Math.round(item.value * item.area);
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty);
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width);
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft);
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedKitchenFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedKitchenFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);

    await performSaveRoom(updatedKitchenFormData, newRoomTypePrice, newRoomTypeWoodPrice);
  };



  const deleteUserAddedKitchenItem = (index) => {
    // Only delete if the item is user-added
    if (filteredDataField[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...filteredDataField];
      const updatedKitchenFormData = [...kitchenFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setFilteredDataField(updatedKitchenThingsDataCopy);
      setKitchenFormData(updatedKitchenFormData);
    }
  };


  // dynamic for Bedroom furniture 

  const { bedroomThingsData } = useSelector(
    (state) => state.bedroomThings
  );

  const [bedroomThingsDataCopy, setBedroomThingsDataCopy] = useState(
    editFieldsToUse && editFieldsToUse.length > 0
      ? editFieldsToUse.map((item) =>
        !item.table ? { ...item, table: "Bedroom" } : item
      )
      : bedroomThingsData
  );

  const [bedroomFormData, setBedroomFormData] = useState(
    editTitleToUse && editTitleToUse.length > 0
      ? editTitleToUse.map((item) => ({
        name: item.name || "",
        label: item.label || "",
        value: item.value || 0,
        valueIncresed: item.valueIncresed || 0,
        label2: item.label2 || "",
        value2: item.value2 || 0,
        valueIncresed2: item.valueIncresed2 || 0,
        width: item.width || "",
        height: item.height || "",
        depth: item.depth || "",
        qnty: item.qnty || "",
        rft: item.rft || "",
        area: item.area || "",
        price: item.price || 0,
        remark: item.remark || "",
        type: item.type || "",
      }))
      : bedroomThingsDataCopy.map((item) => ({
        name: item.name,
        label: "",
        value: 0,
        valueIncresed: 0,
        label2: "",
        value2: 0,
        valueIncresed2: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: item.type,
      }))
  );
  // console.log("bedroomFormData", bedroomFormData);
  // console.log("bedroomThingsDataCopy",bedroomThingsDataCopy);

  const addNewBedroomItem = () => {

    const nameExists = bedroomFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }

    setFilteredDataField([
      ...filteredDataField,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        table: "Bedroom",
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",bedroomThingsDataCopy);

    setBedroomFormData([
      ...bedroomFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        label2: "",
        value2: 0,
        valueIncresed2: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };



  const handleBedroomChange = (e, index, field) => {
    console.log(e);
    console.log(index);
    console.log(field);

    const newValue = parseFloat(e.target.value) || 0;
    console.log("newValue", newValue);

    // const newValue = e.target.value;
    const updatedBedroomFormData = [...bedroomFormData];
    const item = updatedBedroomFormData[index];
    const incrementPercentage = data['increment'] / 100;


    if (filteredDataField[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (filteredDataField[index].measurement === "width") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);
      }
    } else if (filteredDataField[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (filteredDataField[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.height * item.width);
      }
    } else if (filteredDataField[index].measurement === "depth") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
      }
    } else if (filteredDataField[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (filteredDataField[index].measurement === "door") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)) * (1 + incrementPercentage));
      } else {
        item.price = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)));
      }
    }



    // Update the state with the modified data
    updatedBedroomFormData[index] = item;
    setBedroomFormData(updatedBedroomFormData);
    // console.log("price checking", bedroomFormData);
  };


  const handleBedroomPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedBedroomFormData = [...bedroomFormData];
    const item = updatedBedroomFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedBedroomFormData[index] = item;
    setBedroomFormData(updatedBedroomFormData);
    // console.log("price checking", bedroomFormData);
  };


  const handleBedroomRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedBedroomFormData = [...bedroomFormData];
    const item = updatedBedroomFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedBedroomFormData[index] = item;
    setBedroomFormData(updatedBedroomFormData);
    // console.log("price checking", bedroomFormData);
  };

  const handleBedroomOptionChange = (e, index) => {
    const value = e.target.value;
    const selectedLabel = e.target.label;
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;


    setBedroomFormData((prevData) => {
      const newData = [...prevData];
      const incrementPercentage = data['increment'] / 100;
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));
      newData[index]['label'] = selectedLabel;


      // Recalculate the price based on the selected value
      const item = newData[index];
      if (filteredDataField[index].measurement === "area") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.area);
        }
      } else if (filteredDataField[index].measurement === "width") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);
        }
      } else if (filteredDataField[index].measurement === "qty") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.qnty);
        }
      } else if (filteredDataField[index].measurement === "length") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.height * item.width);
        }
      } else if (filteredDataField[index].measurement === "depth") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
        }
      } else if (filteredDataField[index].measurement === "rft") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.rft);
        }
      } else if (filteredDataField[index].measurement === "door") {
        if (item.type === "woodwork") {
          item.price = Math.round(((value * item.width * item.height * item.qnty) + parseFloat(item.value2)) * (1 + incrementPercentage));
        } else {
          item.price = Math.round(((value * item.width * item.height * item.qnty) + parseFloat(item.value2)));
        }
      }

      return newData;
    });
  };

  const handleBedroomOption2Change = (e, index) => {
    const value = e.target.value;
    console.log('value', value);

    const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const incrementPercentage = data['increment'] / 100;

    setBedroomFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value2'] = value;
      newData[index]['valueIncresed2'] = Math.round(value * (1 + incrementPercentage));
      newData[index]['label2'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (filteredDataField[index].measurement === "door") {
        // Parse value as a floating-point number (assuming it's a decimal number)
        const valueAsNumber = parseFloat(value);
        if (!isNaN(valueAsNumber)) {
          item.price = Math.round(((item.value * item.width * item.height * item.qnty) + valueAsNumber) * (1 + incrementPercentage));
        }
      }


      return newData;
    });
  };

  const calculateBedroomTotal = () => {
    let newTotal = 0;

    for (let i = 0; i < bedroomFormData.length; i++) {
      const price = parseFloat(bedroomFormData[i].price) || 0;
      newTotal += price;
    }
    return Math.round(newTotal);;
  };

  useEffect(() => {
    const newBedroomTotal = calculateBedroomTotal();

    setRoomTypePrice(newBedroomTotal);
  }, [bedroomFormData]); // This will update the total whenever formData changes.


  useEffect(() => {
    // Calculate total price
    const totalPrice = bedroomFormData.reduce((total, item) => {
      return total + parseInt(item.price);
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypePrice(totalPrice);
  }, [bedroomFormData]);



  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = bedroomFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [bedroomFormData]);




  const saveBedroomData = async () => {
    if (isSavingRef.current) return;
    isExplicitSavedRef.current = true;
    isFormDirtyRef.current = false;

    const incrementPercentage = data['increment'] / 100;

    // Recalculate prices
    const updatedBedroomFormData = bedroomFormData.map((item, index) => {
      let newPrice = 0;

      if (filteredDataField[index].measurement === "area") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.area);
        }
      } else if (filteredDataField[index].measurement === "width") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        }
      } else if (filteredDataField[index].measurement === "qty") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.qnty);
        }
      } else if (filteredDataField[index].measurement === "length") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.height * item.width);
        }
      } else if (filteredDataField[index].measurement === "depth") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
        }
      } else if (filteredDataField[index].measurement === "rft") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.rft);
        }
      } else if (filteredDataField[index].measurement === "door") {
        if (item.type === "woodwork") {
          newPrice = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)) * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)));
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedBedroomFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedBedroomFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);

    await performSaveRoom(updatedBedroomFormData, newRoomTypePrice, newRoomTypeWoodPrice);
  };


  const deleteUserAddedBedroomItem = (index) => {
    // Only delete if the item is user-added
    if (filteredDataField[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...filteredDataField];
      const updatedKitchenFormData = [...bedroomFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setFilteredDataField(updatedKitchenThingsDataCopy);
      setBedroomFormData(updatedKitchenFormData);
    }
  };

  // dynamic for foyer furniture 

  const { foyerThingsData } = useSelector(
    (state) => state.foyerThings
  );

  const [foyerThingsDataCopy, setFoyerThingsDataCopy] = useState(
    editFieldsToUse && editFieldsToUse.length > 0
      ? editFieldsToUse.map((item) =>
        !item.table ? { ...item, table: 'Foyer' } : item
      )
      : foyerThingsData
  );

  const [foyerFormData, setFoyerFormData] = useState(
    editTitleToUse && editTitleToUse.length > 0
      ? editTitleToUse.map((item) => ({
        name: item.name || "",
        label: item.label || "",
        value: item.value || 0,
        valueIncresed: item.valueIncresed || 0,
        width: item.width || "",
        height: item.height || "",
        depth: item.depth || "",
        qnty: item.qnty || "",
        rft: item.rft || "",
        area: item.area || "",
        price: item.price || 0,
        remark: item.remark || "",
        type: item.type || "",
      }))
      : foyerThingsDataCopy.map((item) => ({
        name: item.name,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: item.type,
      }))
  );

  const addNewFoyerItem = () => {


    const nameExists = foyerFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }


    setFilteredDataField([
      ...filteredDataField,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        table: "Foyer",
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setFoyerFormData([
      ...foyerFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };


  const handleFoyerChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedFoyerFormData = [...foyerFormData];
    const item = updatedFoyerFormData[index];
    const incrementPercentage = data['increment'] / 100;

    if (filteredDataField[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (filteredDataField[index].measurement === "width") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);
      }
    } else if (filteredDataField[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (filteredDataField[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.height * item.width);
      }
    } else if (filteredDataField[index].measurement === "depth") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
      }
    } else if (filteredDataField[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    }

    // Update the state with the modified data
    updatedFoyerFormData[index] = item;
    setFoyerFormData(updatedFoyerFormData);
    // console.log("price checking", foyerFormData);
  };


  const handleFoyerPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedFoyerFormData = [...foyerFormData];
    const item = updatedFoyerFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedFoyerFormData[index] = item;
    setFoyerFormData(updatedFoyerFormData);
    // console.log("price checking", foyerFormData);
  };


  const handleFoyerRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedFoyerFormData = [...foyerFormData];
    const item = updatedFoyerFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedFoyerFormData[index] = item;
    setFoyerFormData(updatedFoyerFormData);
    // console.log("price checking", foyerFormData);
  };

  const handleFoyerOptionChange = (e, index) => {
    const value = e.target.value || 0;
    console.log("value", value);

    const selectedLabel = e.target.label;
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const incrementPercentage = data['increment'] / 100;

    setFoyerFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (filteredDataField[index].measurement === "area") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.area);
        }
      } else if (filteredDataField[index].measurement === "width") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);
        }
      } else if (filteredDataField[index].measurement === "qty") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.qnty);
        }
      } else if (filteredDataField[index].measurement === "length") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.height * item.width);
        }
      } else if (filteredDataField[index].measurement === "depth") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
        }
      } else if (filteredDataField[index].measurement === "rft") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.rft);
        }
      }

      return newData;
    });
  };

  const calculateFoyerTotal = () => {
    let newTotal = 0;
    for (let i = 0; i < foyerFormData.length; i++) {
      const price = parseFloat(foyerFormData[i].price) || 0;
      newTotal += price;
    }
    return newTotal;
  };

  useEffect(() => {
    const newFoyerTotal = calculateFoyerTotal();

    setRoomTypePrice(newFoyerTotal);
  }, [foyerFormData]); // This will update the total whenever formData changes.


  useEffect(() => {
    // Calculate total price
    const totalPrice = foyerFormData.reduce((total, item) => {
      return total + parseInt(item.price);
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypePrice(totalPrice);
  }, [foyerFormData]);



  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = foyerFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [foyerFormData]);



  const saveFoyerData = async () => {
    if (isSavingRef.current) return;
    isExplicitSavedRef.current = true;
    isFormDirtyRef.current = false;

    // Recalculate prices
    const updatedKitchenFormData = foyerFormData.map(item => {
      const incrementPercentage = data['increment'] / 100;
      let newPrice = 0;

      if (item.type === "woodwork") {
        if (item.area) {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else if (item.depth) {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        }
      } else {
        if (item.area) {
          newPrice = Math.round(item.value * item.area);
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty);
        } else if (item.depth) {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width);
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft);
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedKitchenFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedKitchenFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);

    await performSaveRoom(updatedKitchenFormData, newRoomTypePrice, newRoomTypeWoodPrice);
  };

  const deleteUserAddedFoyerItem = (index) => {
    // Only delete if the item is user-added
    if (filteredDataField[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...filteredDataField];
      const updatedKitchenFormData = [...foyerFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setFilteredDataField(updatedKitchenThingsDataCopy);
      setFoyerFormData(updatedKitchenFormData);
    }
  };


  // dynamic for living furniture 

  const { livingThingsData } = useSelector(
    (state) => state.livingThings
  );

  const [livingThingsDataCopy, setLivingThingsDataCopy] = useState(
    editFieldsToUse && editFieldsToUse.length > 0
      ? editFieldsToUse.map((item) =>
        !item.table ? { ...item, table: 'LivingRoom' } : item
      )
      : livingThingsData
  );

  const [livingFormData, setLivingFormData] = useState(
    editTitleToUse && editTitleToUse.length > 0
      ? editTitleToUse.map((item) => ({
        name: item.name || "",
        label: item.label || "",
        value: item.value || 0,
        valueIncresed: item.valueIncresed || 0,
        width: item.width || "",
        height: item.height || "",
        depth: item.depth || "",
        qnty: item.qnty || "",
        rft: item.rft || "",
        area: item.area || "",
        price: item.price || 0,
        remark: item.remark || "",
        type: item.type || "",
      }))
      : livingThingsDataCopy.map((item) => ({
        name: item.name,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: item.type,
      }))
  );

  const addNewLivingItem = () => {


    const nameExists = livingFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }

    setFilteredDataField([
      ...filteredDataField,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        table: "LivingRoom",
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setLivingFormData([
      ...livingFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };

  const handleLivingChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLivingFormData = [...livingFormData];
    const item = updatedLivingFormData[index];
    const incrementPercentage = data['increment'] / 100;

    if (filteredDataField[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (filteredDataField[index].measurement === "width") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);
      }
    } else if (filteredDataField[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (filteredDataField[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.height * item.width);
      }
    } else if (filteredDataField[index].measurement === "depth") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
      }
    } else if (filteredDataField[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    }

    // Update the state with the modified data
    updatedLivingFormData[index] = item;
    setLivingFormData(updatedLivingFormData);
    // console.log("price checking", livingFormData);
  };


  const handleLivingPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLivingFormData = [...livingFormData];
    const item = updatedLivingFormData[index];

    item[field] = newValue;

    // Update the state with the modified data
    updatedLivingFormData[index] = item;
    setLivingFormData(updatedLivingFormData);
    // console.log("price checking", livingFormData);
  };

  const handleLivingRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedLivingFormData = [...livingFormData];
    const item = updatedLivingFormData[index];

    item[field] = newValue;

    // Update the state with the modified data
    updatedLivingFormData[index] = item;
    setLivingFormData(updatedLivingFormData);
    // console.log("price checking", livingFormData);
  };

  const handleLivingOptionChange = (e, index) => {
    const value = e.target.value || 0;
    console.log('value', value);

    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const incrementPercentage = data['increment'] / 100;
    const selectedLabel = e.target.label;
    setLivingFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (filteredDataField[index].measurement === "area") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.area);
        }
      } else if (filteredDataField[index].measurement === "width") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);
        }
      } else if (filteredDataField[index].measurement === "qty") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.qnty);
        }
      } else if (filteredDataField[index].measurement === "length") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.height * item.width);
        }
      } else if (filteredDataField[index].measurement === "depth") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
        }
      } else if (filteredDataField[index].measurement === "rft") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.rft);
        }
      }

      return newData;
    });
  };

  const calculateLivingTotal = () => {
    let newTotal = 0;
    for (let i = 0; i < livingFormData.length; i++) {
      const price = parseFloat(livingFormData[i].price) || 0;
      newTotal += price;
    }
    return newTotal;
  };

  useEffect(() => {
    const newlivingTotal = calculateLivingTotal();

    setRoomTypePrice(newlivingTotal);
  }, [livingFormData]); // This will update the total whenever formData changes.

  useEffect(() => {
    // Calculate total price
    const totalPrice = livingFormData.reduce((total, item) => {
      return total + parseInt(item.price);
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypePrice(totalPrice);
  }, [livingFormData]);




  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = livingFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [livingFormData]);



  const saveLivingData = async () => {
    if (isSavingRef.current) return;
    isExplicitSavedRef.current = true;
    isFormDirtyRef.current = false;

    // Recalculate prices
    const updatedKitchenFormData = livingFormData.map(item => {
      const incrementPercentage = data['increment'] / 100;
      let newPrice = 0;

      if (item.type === "woodwork") {
        if (item.area) {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else if (item.depth) {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        }
      } else {
        if (item.area) {
          newPrice = Math.round(item.value * item.area);
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty);
        } else if (item.depth) {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width);
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft);
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedKitchenFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedKitchenFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);

    await performSaveRoom(updatedKitchenFormData, newRoomTypePrice, newRoomTypeWoodPrice);
  };


  const deleteUserAddedLivingItem = (index) => {
    // Only delete if the item is user-added
    if (filteredDataField[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...filteredDataField];
      const updatedKitchenFormData = [...livingFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setFilteredDataField(updatedKitchenThingsDataCopy);
      setLivingFormData(updatedKitchenFormData);
    }
  };


  // dynamic for other furniture 

  const { otherWorkThingsData } = useSelector(
    (state) => state.OtherWorkThings
  );


  console.log("otherWorkThingsData", otherWorkThingsData);


  const [otherFormData, setOtherFormData] = useState(
    editTitleToUse && editTitleToUse.length > 0
      ? editTitleToUse.map((item) => ({
        name: item.name || "",
        label: item.label || "",
        value: item.value || 0,
        valueIncresed: item.valueIncresed || 0,
        width: item.width || "",
        height: item.height || "",
        qnty: item.qnty || "",
        rft: item.rft || "",
        area: item.area || '',
        painting: item.painting || "",
        price: item.price || 0,
        remark: item.remark || "",
      }))
      : otherWorkThingsData.map((item) => ({
        name: item.name,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        painting: "",
        price: 0,
        remark: "",
      }))
  );
  // console.log("otherWorkThingsData",otherWorkThingsData);
  console.log("otherFormData", otherFormData);



  //// other works save data 

  const saveOtherData = async () => {
    if (isSavingRef.current) return;
    isExplicitSavedRef.current = true;
    console.log("filteredDataField:", filteredDataField);
    console.log("otherFormData:", otherFormData);
    console.log("data:", data);

    // ✅ Safely recalculate prices
    const updatedLooseFormData = otherFormData
      .map((item, index) => {
        const field = filteredDataField?.[index];
        const measurement = field?.measurement;

        if (!measurement) {
          console.warn(`⚠️ Skipping item at index ${index} — missing or invalid measurement`);
          return null;
        }

        let newPrice = 0;

        switch (measurement) {
          case "area":
            newPrice = Math.round(item.value * item.area);
            break;
          case "width":
            newPrice = Math.round(item.value * item.width * item.height * item.qnty);
            break;
          case "qty":
            newPrice = Math.round(item.value * item.qnty);
            break;
          case "length":
            newPrice = Math.round(item.value * item.height * item.width);
            break;
          case "rft":
            newPrice = Math.round(item.value * item.rft);
            break;
          case "painting":
            newPrice = Math.round(item.value * 3.5 * item.painting);
            break;
          default:
            console.warn(`⚠️ Unknown measurement type "${measurement}" at index ${index}`);
            return null;
        }

        return { ...item, price: newPrice };
      })
      .filter(Boolean); // Removes null items

    // ✅ Safely calculate total
    const newRoomTypePrice = updatedLooseFormData.reduce(
      (total, item) => total + (item.price || 0),
      0
    );

    await performSaveRoom(updatedLooseFormData, newRoomTypePrice, 0);
  };


  const addNewOtherWorkItem = () => {


    const nameExists = otherFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }


    setFilteredDataField([
      ...filteredDataField,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        table: "OtherWorks",
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setOtherFormData([
      ...otherFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };


  const deleteUserAddedOtherWorks = (index) => {
    // Only delete if the item is user-added
    if (filteredDataField[index].isUserAdded) {
      const updatedAccessoriesThingsDataCopy = [...filteredDataField];
      const updatedAccessoriesFormData = [...otherFormData];

      // Remove the item from the list and the form data
      updatedAccessoriesThingsDataCopy.splice(index, 1);
      updatedAccessoriesFormData.splice(index, 1);

      // Update the state
      setFilteredDataField(updatedAccessoriesThingsDataCopy);
      setOtherFormData(updatedAccessoriesFormData);
    }
  };


  const handleOtherChange = (e, index, field) => {

    const newValue = parseFloat(e.target.value) || 0;
    // const newValue = e.target.value;
    const updatedOtherFormData = [...otherFormData];
    const item = updatedOtherFormData[index];
    console.log(item);

    if (filteredDataField[index].measurement === "area") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (filteredDataField[index].measurement === "width") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.width * item.height * item.qnty);
    } else if (filteredDataField[index].measurement === "qty") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (filteredDataField[index].measurement === "length") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.height * item.width);
    } else if (filteredDataField[index].measurement === "rft") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (filteredDataField[index].measurement === "painting") {
      item[field] = newValue;
      item.price = Math.round(item.value * 3.5 * newValue);
    }

    // Update the state with the modified data
    updatedOtherFormData[index] = item;
    setOtherFormData(updatedOtherFormData);
    // console.log("price checking", otherFormData);
  };

  const handleOtherPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedOtherFormData = [...otherFormData];
    const item = updatedOtherFormData[index];

    item[field] = newValue;

    // Update the state with the modified data
    updatedOtherFormData[index] = item;
    setOtherFormData(updatedOtherFormData);
    // console.log("price checking", otherFormData);
  };


  const handleOtherRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedOtherFormData = [...otherFormData];
    const item = updatedOtherFormData[index];

    item[field] = newValue;

    // Update the state with the modified data
    updatedOtherFormData[index] = item;
    setOtherFormData(updatedOtherFormData);
    // console.log("price checking", otherFormData);
  };



  const handleOtherOptionChange = (e, index) => {
    const value = e.target.value;
    const selectedLabel = e.target.label;
    console.log("valueselectdlabel", value);
    console.log("valueselectdlabel", selectedLabel);
    console.log("valueselectdlabel", index);

    // const selectedLabel = e.target.options[e.target.selectedIndex].text;

    setOtherFormData((prevData) => {
      console.log("valueselectdlabel", prevData);
      console.log("valueselectdlabel", otherWorkThingsData);

      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = value;
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (filteredDataField[index].measurement === "area") {
        item.price = Math.round(value * item.area);
      } else if (filteredDataField[index].measurement === "width") {
        item.price = Math.round(value * item.width * item.height * item.qnty);
      } else if (filteredDataField[index].measurement === "qty") {
        item.price = Math.round(value * item.qnty);
      } else if (filteredDataField[index].measurement === "length") {
        item.price = Math.round(value * item.height * item.width);
      } else if (filteredDataField[index].measurement === "rft") {
        item.price = Math.round(value * item.rft);
      } else if (filteredDataField[index].measurement === "painting") {
        item.price = Math.round(value * 3.5 * item.painting);
      }
      console.log("valueselectdlabel", item);

      return newData;
    });
  };

  const calculateOtherTotal = () => {
    let newTotal = 0;
    for (let i = 0; i < otherFormData.length; i++) {
      const price = parseFloat(otherFormData[i].price) || 0;
      newTotal += price;
    }
    return newTotal;
  };

  useEffect(() => {
    const newOtherTotal = calculateOtherTotal();

    setRoomTypePrice(newOtherTotal);
  }, [otherFormData]); // This will update the total whenever formData changes.





  // dynamic for loose furniture 

  const { looseThingsData } = useSelector(
    (state) => state.looseThings
  );

  const [looseFormData, setLooseFormData] = useState(
    editTitleToUse && editTitleToUse.length > 0
      ? editTitleToUse.map((item) => ({
        name: item.name || "",
        label: item.label || "",
        value: item.value || 0,
        valueIncresed: item.valueIncresed || 0,
        width: item.width || "",
        height: item.height || "",
        qnty: item.qnty || "",
        rft: item.rft || "",
        area: item.area || "",
        price: item.price || 0,
        remark: item.remark || "",
      }))
      : looseThingsData.map((item) => ({
        name: item.name,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
      }))
  );

  const handleLooseChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLooseFormData = [...looseFormData];
    const item = updatedLooseFormData[index];

    if (looseThingsData[index].measurement === "area") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (looseThingsData[index].measurement === "width") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.width * item.height * item.qnty);
    } else if (looseThingsData[index].measurement === "qty") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (looseThingsData[index].measurement === "length") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.height * item.width);
    } else if (looseThingsData[index].measurement === "rft") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    }

    // Update the state with the modified data
    updatedLooseFormData[index] = item;
    setLooseFormData(updatedLooseFormData);
    // console.log("price checking", looseFormData);
  };


  const handleLoosePriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLooseFormData = [...looseFormData];
    const item = updatedLooseFormData[index];

    item[field] = newValue;

    // Update the state with the modified data
    updatedLooseFormData[index] = item;
    setLooseFormData(updatedLooseFormData);
  };


  const handleLooseRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedLooseFormData = [...looseFormData];
    const item = updatedLooseFormData[index];

    item[field] = newValue;

    // Update the state with the modified data
    updatedLooseFormData[index] = item;
    setLooseFormData(updatedLooseFormData);
  };

  const handleLooseOptionChange = (e, index) => {
    const value = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;

    setLooseFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = value;
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (looseThingsData[index].measurement === "area") {
        item.price = Math.round(value * item.area);
      } else if (looseThingsData[index].measurement === "width") {
        item.price = Math.round(value * item.width * item.height * item.qnty);
      } else if (looseThingsData[index].measurement === "qty") {
        item.price = Math.round(value * item.qnty);
      } else if (looseThingsData[index].measurement === "length") {
        item.price = Math.round(value * item.height * item.width);
      } else if (looseThingsData[index].measurement === "rft") {
        item.price = Math.round(value * item.rft);
      }

      return newData;
    });
  };

  const calculateLooseTotal = () => {
    let newTotal = 0;
    for (let i = 0; i < looseFormData.length; i++) {
      const price = parseFloat(looseFormData[i].price) || 0;
      newTotal += price;
    }
    return newTotal;
  };

  useEffect(() => {
    const newLooseTotal = calculateLooseTotal();

    setRoomTypePrice(newLooseTotal);
  }, [looseFormData]); // This will update the total whenever formData changes.

  const saveLooseData = async () => {
    if (isSavingRef.current) return;
    isExplicitSavedRef.current = true;
    isFormDirtyRef.current = false;

    // Recalculate prices
    const updatedLooseFormData = looseFormData.map((item, index) => {
      let newPrice = 0;

      if (looseThingsData[index].measurement === "area") {
        newPrice = Math.round(item.value * item.area);
      } else if (looseThingsData[index].measurement === "width") {
        newPrice = Math.round(item.value * item.width * item.height * item.qnty);
      } else if (looseThingsData[index].measurement === "qty") {
        newPrice = Math.round(item.value * item.qnty);
      } else if (looseThingsData[index].measurement === "length") {
        newPrice = Math.round(item.value * item.height * item.width);
      } else if (looseThingsData[index].measurement === "rft") {
        newPrice = Math.round(item.value * item.rft);
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedLooseFormData.reduce((total, item) => total + item.price, 0);

    await performSaveRoom(updatedLooseFormData, newRoomTypePrice, 0);
  };



  // dynamic for Accessories

  const { accessoriesThingsData } = useSelector(
    (state) => state.accessories
  );

  console.log("accessoriesThingsData", accessoriesThingsData);


  const [accessoriesFormData, setAccessoriesFormData] = useState(
    editTitleToUse && editTitleToUse.length > 0
      ? editTitleToUse.map((item) => ({
        name: item.name || "",
        label: item.label || "",
        value: item.value || 0,
        valueIncresed: item.valueIncresed || 0,
        width: item.width || "",
        height: item.height || "",
        depth: item.depth || "",
        qnty: item.qnty || "",
        rft: item.rft || "",
        area: item.area || "",
        price: item.price || 0,
        remark: item.remark || "",
        type: item.type || "",
      }))
      : accessoriesThingsData.map((item) => ({
        name: item.name,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: item.type,
      }))
  );
  console.log("ee", accessoriesFormData);




  const handleAccessoriesChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value) || 0;
    console.log('eee', newValue);
    console.log('eee', index);

    // const newValue = e.target.value;
    const updatedAccessoriesFormData = [...accessoriesFormData];
    const item = updatedAccessoriesFormData[index];
    console.log('eee', item);

    if (filteredDataField[index].measurement === "area") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (filteredDataField[index].measurement === "width") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.width * item.height * item.qnty);
    } else if (filteredDataField[index].measurement === "qty") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (filteredDataField[index].measurement === "length") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.height * item.width);
    } else if (filteredDataField[index].measurement === "depth") {
      item[field] = newValue;
      item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
    } else if (filteredDataField[index].measurement === "rft") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    }

    // Update the state with the modified data
    updatedAccessoriesFormData[index] = item;
    setAccessoriesFormData(updatedAccessoriesFormData);
    // console.log("price checking", accessoriesFormData);
  };


  const handleAccessoriesPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedAccessoriesFormData = [...accessoriesFormData];
    const item = updatedAccessoriesFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedAccessoriesFormData[index] = item;
    setAccessoriesFormData(updatedAccessoriesFormData);
    // console.log("price checking", accessoriesFormData);
  };


  const handleAccessoriesRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedAccessoriesFormData = [...accessoriesFormData];
    const item = updatedAccessoriesFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedAccessoriesFormData[index] = item;
    setAccessoriesFormData(updatedAccessoriesFormData);
    // console.log("price checking", accessoriesFormData);
  };

  const deleteUserAddedAccessories = (index) => {
    // Only delete if the item is user-added
    if (filteredDataField[index].isUserAdded) {
      const updatedAccessoriesThingsDataCopy = [...filteredDataField];
      const updatedAccessoriesFormData = [...accessoriesFormData];

      // Remove the item from the list and the form data
      updatedAccessoriesThingsDataCopy.splice(index, 1);
      updatedAccessoriesFormData.splice(index, 1);

      // Update the state
      setFilteredDataField(updatedAccessoriesThingsDataCopy);
      setAccessoriesFormData(updatedAccessoriesFormData);
    }
  };

  const handleAccessoriesOptionChange = (e, index) => {
    const value = e.target.value || 0;
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const selectedLabel = e.target.label || 0;
    console.log("eee", value);
    console.log("eee", selectedLabel);
    console.log("eee", index);


    setAccessoriesFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = value;
      newData[index]['label'] = selectedLabel;

      // console.log("eee", newData);
      // Recalculate the price based on the selected value
      const item = newData[index];
      if (filteredDataField[index].measurement === "area") {
        item.price = Math.round(value * item.area);
      } else if (filteredDataField[index].measurement === "width") {
        item.price = Math.round(value * item.width * item.height * item.qnty);
      } else if (filteredDataField[index].measurement === "qty") {
        item.price = Math.round(value * item.qnty);
      } else if (filteredDataField[index].measurement === "length") {
        item.price = Math.round(value * item.height * item.width);
      } else if (filteredDataField[index].measurement === "depth") {
        item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
      } else if (filteredDataField[index].measurement === "rft") {
        item.price = Math.round(value * item.rft);
      }


      return newData;
    });
  };

  const addNewAccessoriesItem = () => {


    const nameExists = accessoriesFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }


    setFilteredDataField([
      ...filteredDataField,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        table: "Accessories",
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setAccessoriesFormData([
      ...accessoriesFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        depth: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };


  const calculateAccessoriesTotal = () => {
    let newTotal = 0;
    for (let i = 0; i < accessoriesFormData.length; i++) {
      const price = parseFloat(accessoriesFormData[i].price) || 0;
      newTotal += price;
    }
    return newTotal;
  };

  useEffect(() => {
    const newAccessoriesTotal = calculateAccessoriesTotal();
    setRoomTypePrice(newAccessoriesTotal);
  }, [accessoriesFormData]); // This will update the total whenever formData changes.







  // adding dynamic fields for extra items


  const saveAccessoriesData = async () => {
    if (isSavingRef.current) return;
    isExplicitSavedRef.current = true;
    isFormDirtyRef.current = false;

    const updatedLooseFormData = accessoriesFormData
      .map((item, index) => {
        const field = filteredDataField?.[index]; // Safe optional access
        const measurement = field?.measurement;   // Safe chaining

        if (!measurement) {
          console.warn(`⚠️Skipping item at index ${index} — no measurement found`);
          return null;
        }

        const incrementPercentage = data['increment'] / 100;
        let newPrice = 0;

        switch (measurement) {
          case "area":
            newPrice = Math.round(item.value * item.area);
            break;
          case "depth":
            newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
            break;
          case "width":
            newPrice = Math.round(item.value * item.width * item.height * item.qnty);
            break;
          case "qty":
            newPrice = Math.round(item.value * item.qnty);
            break;
          case "length":
            newPrice = Math.round(item.value * item.height * item.width);
            break;
          case "rft":
            newPrice = Math.round(item.value * item.rft);
            break;
          case "painting":
            newPrice = Math.round(item.value * 3.5 * item.painting);
            break;


          default:
            console.warn(`⚠️ Unknown measurement type "${measurement}" at index ${index}`);
            return null;
        }

        return { ...item, price: newPrice };
      })
      .filter(Boolean); // Removes null items

    // ✅ Safely calculate total
    const newRoomTypePrice = updatedLooseFormData.reduce(
      (total, item) => total + (item.price || 0),
      0
    );

    await performSaveRoom(updatedLooseFormData, newRoomTypePrice, 0);
  };



  const [materialFields, setMaterialFields] = useState(

    data.editData.title !== ""
      ? data.editData.title.map((item) => ({
        label: item.label || "",
        qnty: item.qnty || 1,
        value: item.value || 0,
        remark: item.remark || "",
      }))
      : [{ label: '', value: 0, qnty: 1, remark: '' }]
  );
  const [materialFieldsTotal, setMaterialFieldsTotal] = useState(0);

  const handleAddField = () => {
    setMaterialFields([...materialFields, { label: '', value: 0, qnty: 1, remark: '' }]);
  };

  const handleRemoveField = (index) => {
    const updatedFields = [...materialFields];
    updatedFields.splice(index, 1);
    setMaterialFields(updatedFields);
  };

  const handleFieldChange = (value, index, fieldName) => {
    const updatedFields = [...materialFields];
    updatedFields[index][fieldName] = value;
    setMaterialFields(updatedFields);
  };

  const values = materialFields.map(items => {
    return items.value;
  });
  // reducing the qty in  a single value
  const reducerOfValues = (accumulator, currentValue) =>
    accumulator + parseFloat(currentValue || 0);

  // const totalValues = values.reduce(reducerOfValues, 0);
  const totalValues = () => {
    return values.reduce(reducerOfValues, 0);
  }

  //  useEffect(() => {
  //    const newAccessoriesTotal = totalValues;

  //    setMaterialFieldsTotal(newAccessoriesTotal);
  //    setRoomTypePrice(newAccessoriesTotal);
  //  }, [materialFields]);


  const saveExtraItemsData = async () => {
    if (isSavingRef.current) return;
    isExplicitSavedRef.current = true;
    isFormDirtyRef.current = false;

    // Recalculate prices
    const updatedMaterialFields = materialFields.map(item => {
      const newValue = parseFloat(item.value) || 0;
      const newQnty = parseFloat(item.qnty) || 1;
      const newPrice = Math.round(newValue * newQnty);

      return { ...item, value: newValue, qnty: newQnty, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedMaterialFields.reduce((total, item) => total + item.price, 0);

    await performSaveRoom(updatedMaterialFields, newRoomTypePrice, 0);
  };


  const [search, setSearch] = useState('');

  console.log('search', search);
  console.log('filteredDataFieldddddd', filteredDataField);


  useEffect(() => {
    dispatch(fetchKitchenList());
  }, [search]);


  const sortedData = () => {
    let shotData = [];
    let setFormFn = null;
    let fields = [];

    switch (roomTypeModal) {
      case 'Kitchen':
        shotData = kitchenFormData;
        setFormFn = setKitchenFormData;
        fields = kitchenThingsDataCopy;
        break;
      case 'Bedroom':
        shotData = bedroomFormData;
        setFormFn = setBedroomFormData;
        fields = bedroomThingsDataCopy;
        break;
      case 'Foyer':
        shotData = foyerFormData;
        setFormFn = setFoyerFormData;
        fields = foyerThingsDataCopy;
        break;
      case 'Living Room':
        shotData = livingFormData;
        setFormFn = setLivingFormData;
        fields = livingThingsDataCopy;
        break;
      case 'Other Works':
        shotData = otherFormData;
        setFormFn = setOtherFormData;
        fields = data?.editData?.fields || otherWorkThingsData;
        break;
      case 'Loose Furniture':
        shotData = looseFormData;
        setFormFn = setLooseFormData;
        fields = looseThingsData;
        break;
      case 'Accessories':
        shotData = accessoriesFormData;
        setFormFn = setAccessoriesFormData;
        fields = editFieldsToUse.length > 0 ? editFieldsToUse : (data?.editData?.fields || accessoriesThingsData);
        break;
      default:
        return;
    }

    const activeFields = (editFieldsToUse && Array.isArray(editFieldsToUse) && editFieldsToUse.length > 0)
      ? editFieldsToUse
      : (data?.editData?.fields && Array.isArray(data.editData.fields) && data.editData.fields.length > 0)
        ? data.editData.fields
        : (fields || []);

    // Pair form data and field items 1-to-1 by index so duplicate items are preserved accurately
    const paired = (shotData || []).map((formItem, idx) => ({
      formItem,
      fieldItem: activeFields[idx] || (filteredDataField && filteredDataField[idx]) || { name: formItem?.name || 'item', measurement: 'area' }
    }));

    paired.sort((a, b) => {
      const aFilled = isItemFilled(a.formItem);
      const bFilled = isItemFilled(b.formItem);
      if (aFilled === bFilled) return 0;
      return aFilled ? -1 : 1;
    });

    const sortedForms = paired.map(p => p.formItem);
    const sortedFields = paired.map(p => p.fieldItem);

    if (setFormFn) {
      setFormFn(sortedForms);
    }
    setFilteredDataField(sortedFields);
  };

  const getCurrentFormData = React.useCallback(() => {
    const type = (roomTypeModal || data?.editData?.roomType || '').trim().toLowerCase();
    if (type === 'kitchen') return kitchenFormData;
    if (type === 'bedroom') return bedroomFormData;
    if (type === 'foyer') return foyerFormData;
    if (type.includes('living')) return livingFormData;
    if (type.includes('other')) return otherFormData;
    if (type.includes('loose')) return looseFormData;
    if (type.includes('accessor')) return accessoriesFormData;
    if (type.includes('extra')) return materialFields;
    return otherFormData || kitchenFormData;
  }, [roomTypeModal, data?.editData?.roomType, kitchenFormData, bedroomFormData, foyerFormData, livingFormData, otherFormData, looseFormData, accessoriesFormData, materialFields]);

  const saveDraftToLocalStorage = React.useCallback((explicitFormData = null, explicitFields = null) => {
    if (isExplicitSavedRef.current || !clientId || !targetDraftId || !localDraftKey) return null;
    const currentData = explicitFormData || latestFormDataRef.current || getCurrentFormData();
    const currentFields = explicitFields || latestFieldsRef.current || filteredDataField;
    if (!currentData || currentData.length === 0) return null;

    const origName = data?.editData?.roomTypeDesign || 'Design Option';
    const draftDesignName = (origName.toLowerCase().includes('draft') || isEditingDraft) ? origName : `${origName} (Draft Copy)`;

    const newRoomTypePrice = Array.isArray(currentData)
      ? currentData.reduce((total, item) => total + (Number(item?.price) || 0), 0)
      : 0;
    const newRoomTypeWoodPrice = Array.isArray(currentData)
      ? currentData.reduce((total, item) => (item?.type === "woodwork" ? total + (Number(item?.price) || 0) : total), 0)
      : 0;

    const draftDataPayload = {
      ID: targetDraftId,
      id: targetDraftId,
      draftOfId: realOriginalId,
      isDraft: true,
      draftTag: 'Draft Saved Copy',
      roomType: roomTypeModal || data?.editData?.roomType || '',
      roomTypeName: resolvedRoomTypeName || roomTypeName || '',
      roomTypeDesign: draftDesignName,
      roomTypePrice: newRoomTypePrice,
      roomTypeWoodPrice: newRoomTypeWoodPrice,
      title: currentData,
      fields: currentFields || [],
      priceMode: data?.editData?.priceMode || 'value',
      updatedAt: new Date().toISOString()
    };

    try {
      localStorage.setItem(localDraftKey, JSON.stringify(draftDataPayload));
      localStorage.setItem(`draft_card_${clientId}_${targetDraftId}`, JSON.stringify(draftDataPayload));
      console.log("💾 Synchronously saved draft card to LocalStorage:", targetDraftId);
    } catch (e) {
      console.error("Failed to write draft to LocalStorage:", e);
    }
    return draftDataPayload;
  }, [clientId, targetDraftId, localDraftKey, realOriginalId, roomTypeModal, data?.editData?.roomType, data?.editData?.roomTypeDesign, data?.editData?.priceMode, isEditingDraft, resolvedRoomTypeName, roomTypeName, filteredDataField, getCurrentFormData]);

  const sanitizeFirestorePayload = (obj) => {
    if (obj === undefined) return null;
    if (obj === null || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(sanitizeFirestorePayload);
    const clean = {};
    for (const [k, v] of Object.entries(obj)) {
      if (v !== undefined) {
        clean[k] = sanitizeFirestorePayload(v);
      }
    }
    return clean;
  };

  const saveDraftToFirestore = React.useCallback(async (explicitFormData = null, explicitFields = null) => {
    if (isExplicitSavedRef.current || !clientId || !targetDraftId) return;
    const currentData = explicitFormData || latestFormDataRef.current || getCurrentFormData();
    const currentFields = explicitFields || latestFieldsRef.current || filteredDataField;
    if (!currentData || currentData.length === 0) return;

    // 1. Immediately sync to LocalStorage so no network drop or tab close loses data
    const draftPayload = saveDraftToLocalStorage(currentData, currentFields);
    if (!draftPayload) return;

    try {
      const cleanPayload = sanitizeFirestorePayload(draftPayload);
      const savePromise = db.collection("client").doc(clientId).collection(collectionName).doc(targetDraftId).set(cleanPayload, { merge: true });
      pendingSavePromiseRef.current = savePromise;
      await savePromise;
      console.log("✅ Saved draft card to Firestore immediately:", targetDraftId);
    } catch (err) {
      console.error("❌ Error saving draft card to Firestore:", err);
    }
  }, [clientId, targetDraftId, collectionName, saveDraftToLocalStorage, filteredDataField, getCurrentFormData]);

  // Track form mutations passively, immediately save to LocalStorage (0ms) and Firestore database (immediate) on actual changes
  useEffect(() => {
    const current = getCurrentFormData();
    if (current) latestFormDataRef.current = current;
    latestFieldsRef.current = filteredDataField;

    if (!current || !Array.isArray(current) || current.length === 0) return;

    const currentSnapshot = getComparableSnapshot(current);

    // Initialize baseline snapshot on initial form load
    if (initialSnapshotRef.current === null) {
      initialSnapshotRef.current = currentSnapshot;
      return;
    }

    // Check if current form state matches original baseline (or initial load snapshot)
    const isAtBaseline = (
      currentSnapshot === initialSnapshotRef.current ||
      (initialBaselineSnapshot && currentSnapshot === initialBaselineSnapshot)
    );

    if (isAtBaseline) {
      // If form was previously marked dirty (e.g. 0 -> 1 -> 0), clear draft in database & LocalStorage
      if (isFormDirtyRef.current) {
        console.log("🔄 Form values reverted back to original baseline state. Clearing draft...");
        isFormDirtyRef.current = false;
        clearDraftInFirestore();
      }
      return;
    }

    // A real mutation occurred!
    isFormDirtyRef.current = true;

    // 1. Synchronously write to LocalStorage so any close tab / exit is instantly safe
    saveDraftToLocalStorage(current, filteredDataField);

    // 2. Immediately sync to Firestore database
    saveDraftToFirestore(current, filteredDataField);
  }, [kitchenFormData, bedroomFormData, foyerFormData, livingFormData, otherFormData, looseFormData, accessoriesFormData, materialFields, filteredDataField, getCurrentFormData, getComparableSnapshot, initialBaselineSnapshot, saveDraftToLocalStorage, saveDraftToFirestore, clearDraftInFirestore]);

  const handleNavigateBackOrExit = React.useCallback(async (targetPath = "/projects/view-rooms", customState = null) => {
    if (pendingSavePromiseRef.current) {
      try {
        await pendingSavePromiseRef.current;
      } catch (e) { }
    }
    if (isFormDirtyRef.current && !isExplicitSavedRef.current && clientId && targetDraftId) {
      console.log("💾 Form modified. Auto-saving draft before navigating away...");
      saveDraftToLocalStorage(latestFormDataRef.current, latestFieldsRef.current);
      await saveDraftToFirestore(latestFormDataRef.current, latestFieldsRef.current);
    }
    navigation(targetPath, { state: customState || data });
  }, [saveDraftToLocalStorage, saveDraftToFirestore, clientId, targetDraftId, data, navigation]);

  useEffect(() => {
    const handleExitOrUnload = () => {
      if (isFormDirtyRef.current && !isExplicitSavedRef.current && clientId && targetDraftId) {
        saveDraftToLocalStorage(latestFormDataRef.current, latestFieldsRef.current);
        saveDraftToFirestore(latestFormDataRef.current, latestFieldsRef.current);
      }
    };

    window.addEventListener('beforeunload', handleExitOrUnload);
    window.addEventListener('pagehide', handleExitOrUnload);
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        handleExitOrUnload();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('beforeunload', handleExitOrUnload);
      window.removeEventListener('pagehide', handleExitOrUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (isFormDirtyRef.current && !isExplicitSavedRef.current && clientId && targetDraftId) {
        console.log("💾 Unmounting EditRooms with unsaved changes. Auto-saving draft...");
        saveDraftToLocalStorage(latestFormDataRef.current, latestFieldsRef.current);
        saveDraftToFirestore(latestFormDataRef.current, latestFieldsRef.current);
      }
    };
  }, [saveDraftToLocalStorage, saveDraftToFirestore, clientId, targetDraftId]);

  const handleAddNewItem = async (item, name, index) => {
    console.log(item);
    console.log(index);

    const anotherItem = filteredDataField.find(i => i.name);
    console.log('anotherItem', anotherItem);
    const anothername = anotherItem ? anotherItem.table : null;
    console.log('anotherItem', anothername);

    const material = item.material;
    console.log(material);
    const ShapeOfKitchen = item.name === "Shape Of Kitchen";
    console.log("ShapeOfKitchen", ShapeOfKitchen);

    const swalHtml = ShapeOfKitchen
      ? '<input id="swal-input1" class="swal2-input" placeholder="Label">'
      : '<input id="swal-input1" class="swal2-input" placeholder="Label">' +
      '<input id="swal-input2" class="swal2-input" placeholder="Value (numbers only)">';

    const { value: formValues } = await Swal.fire({
      title: `Add New Material (${item.name})`,
      html: swalHtml,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Add',
      preConfirm: () => {
        const label = document.getElementById('swal-input1')?.value.trim();
        const value = !ShapeOfKitchen ? document.getElementById('swal-input2')?.value.trim() : null;

        const labelRegex = /^[a-zA-Z\s]+$/; // Only letters and spaces
        const valueRegex = /^[0-9]+(\.[0-9]+)?$/; // Numbers only (allowing decimals)

        if (!label) {
          Swal.showValidationMessage('Label is required');
          return false;
        }

        // if (!labelRegex.test(label)) {
        //   Swal.showValidationMessage('Label must contain only letters and spaces');
        //   return false;
        // }

        if (!ShapeOfKitchen) {
          if (!value) {
            Swal.showValidationMessage('Value is required');
            return false;
          }

          if (!valueRegex.test(value)) {
            Swal.showValidationMessage('Value must contain only numbers');
            return false;
          }
        }

        return ShapeOfKitchen
          ? { label, value: null, oldvalue: null }
          : { label, value, oldvalue: value };
      }
    });

    if (formValues) {
      console.log('New Item:', formValues);

      let updatedFormData;
      let setDataFn;

      switch (item.table || anothername) {

        case "kitchen":
          updatedFormData = [...filteredDataField];
          setDataFn = setFilteredDataField;
          break;


        case "Bedroom":
          updatedFormData = [...filteredDataField];
          setDataFn = setFilteredDataField;
          break;

        case "Foyer":
          updatedFormData = [...filteredDataField];
          setDataFn = setFilteredDataField;
          break;

        case "LivingRoom":
          updatedFormData = [...filteredDataField];
          setDataFn = setFilteredDataField;
          break;

        case "OtherWorks":
          updatedFormData = [...filteredDataField];
          setDataFn = setFilteredDataField;
          break;

        case "Accessories":
          updatedFormData = [...filteredDataField];
          setDataFn = setFilteredDataField;
          break;

        default:
          console.error("Unknown table type:", item.table);
          return;
      }

      const current = {
        ...updatedFormData[index],
        material: [...(material || []), formValues],
      };

      console.log("current", current);
      updatedFormData[index] = current;
      setDataFn(updatedFormData);
      console.log("updatedFormData", updatedFormData);
    }
  };



  const handleDragKitchenEnd = (result) => {
    console.log('sssssssss', result);

    if (!result.destination) return;

    const items = Array.from(filteredDataField);
    const forms = Array.from(kitchenFormData);

    const [movedItem] = items.splice(result.source.index, 1);
    const [movedForm] = forms.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, movedItem);
    forms.splice(result.destination.index, 0, movedForm);


    console.log('sssssssss', forms);
    console.log('sssssssss', items);
    setFilteredDataField(items);
    setKitchenFormData(forms);
  };

  const handleDragBedroomEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(filteredDataField);
    const forms = Array.from(bedroomFormData);

    const [movedItem] = items.splice(result.source.index, 1);
    const [movedForm] = forms.splice(result.source.index, 1);


    console.log('sssssssss', items);
    console.log('sssssssss', forms);

    items.splice(result.destination.index, 0, movedItem);
    forms.splice(result.destination.index, 0, movedForm);

    setFilteredDataField(items);
    setBedroomFormData(forms);
  };

  const handleDragFoyerEnd = (result) => {
    if (!result.destination) return;

    if (!result.destination) return;

    const items = Array.from(filteredDataField);
    const forms = Array.from(foyerFormData);

    const [movedItem] = items.splice(result.source.index, 1);
    const [movedForm] = forms.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, movedItem);
    forms.splice(result.destination.index, 0, movedForm);

    setFilteredDataField(items);
    setFoyerFormData(forms);
  }
  const handleDragLivingEnd = (result) => {
    if (!result.destination) return;

    if (!result.destination) return;

    const items = Array.from(filteredDataField);
    const forms = Array.from(livingFormData);

    const [movedItem] = items.splice(result.source.index, 1);
    const [movedForm] = forms.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, movedItem);
    forms.splice(result.destination.index, 0, movedForm);

    setFilteredDataField(items);
    setLivingFormData(forms);
  }
  const handleDragOtherEnd = (result) => {
    if (!result.destination) return;

    if (!result.destination) return;

    const items = Array.from(filteredDataField);
    const forms = Array.from(otherFormData);

    const [movedItem] = items.splice(result.source.index, 1);
    const [movedForm] = forms.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, movedItem);
    forms.splice(result.destination.index, 0, movedForm);
    console.log('forms', items);
    console.log('forms', forms);


    setFilteredDataField(items);
    setOtherFormData(forms);
  }
  const handleDragLooseEnd = (result) => {
    if (!result.destination) return;

    if (!result.destination) return;

    const items = Array.from(filteredDataField);
    const forms = Array.from(looseFormData);

    const [movedItem] = items.splice(result.source.index, 1);
    const [movedForm] = forms.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, movedItem);
    forms.splice(result.destination.index, 0, movedForm);
    console.log('forms', items);
    console.log('forms', forms);


    setFilteredDataField(items);
    setLooseFormData(forms);
  }
  const handleDragAccessoriesEnd = (result) => {
    if (!result.destination) return;

    if (!result.destination) return;

    const items = Array.from(filteredDataField);
    const forms = Array.from(accessoriesFormData);

    const [movedItem] = items.splice(result.source.index, 1);
    const [movedForm] = forms.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, movedItem);
    forms.splice(result.destination.index, 0, movedForm);
    console.log('forms', items);
    console.log('forms', forms);


    setFilteredDataField(items);
    setAccessoriesFormData(forms);
  }

  const setFormDataForRoomType = (type, updatedForm) => {
    switch (type) {
      case 'Kitchen':
        setKitchenFormData(updatedForm);
        break;
      case 'Bedroom':
        setBedroomFormData(updatedForm);
        break;
      case 'Foyer':
        setFoyerFormData(updatedForm);
        break;
      case 'Living Room':
        setLivingFormData(updatedForm);
        break;
      case 'Other Works':
      case 'Others works':
        setOtherFormData(updatedForm);
        break;
      case 'Loose Furniture':
        setLooseFormData(updatedForm);
        break;
      case 'Accessories':
        setAccessoriesFormData(updatedForm);
        break;
      default:
        break;
    }
  };

  const duplicateRoomItem = (index) => {
    if (index < 0 || index >= filteredDataField.length) return;

    const originalField = filteredDataField[index];
    const clonedField = {
      ...originalField,
      id: originalField?.id
        ? `${originalField.id}_dup_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`
        : `${originalField?.name || 'item'}_dup_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`,
      isUserAdded: true,
      isDuplicated: true,
    };

    const updatedFields = [...filteredDataField];
    updatedFields.splice(index + 1, 0, clonedField);

    let currentFormData = getCurrentFormData() || [];
    const originalForm = currentFormData[index] || {};
    const clonedForm = {
      ...JSON.parse(JSON.stringify(originalForm)),
      label: "",
      label2: "",
      value: 0,
      valueIncresed: 0,
      value2: 0,
      valueIncresed2: 0,
      width: "",
      height: "",
      qnty: "",
      rft: "",
      area: "",
      depth: "",
      painting: "",
      price: 0,
      remark: "",
    };

    const updatedForm = [...currentFormData];
    updatedForm.splice(index + 1, 0, clonedForm);

    // 1. Synchronously update refs FIRST so any immediate exit or unmount has the latest data
    latestFormDataRef.current = updatedForm;
    latestFieldsRef.current = updatedFields;
    isFormDirtyRef.current = true;

    // 2. Update React states
    setFormDataForRoomType(roomTypeModal, updatedForm);
    setFilteredDataField(updatedFields);

    // 3. Immediately persist synchronously to LocalStorage
    saveDraftToLocalStorage(updatedForm, updatedFields);

    // 4. Immediately persist draft to Firestore in background
    saveDraftToFirestore(updatedForm, updatedFields);
  };

  const deleteRoomItem = (index) => {
    if (index < 0 || index >= filteredDataField.length) return;

    const updatedFields = [...filteredDataField];
    updatedFields.splice(index, 1);

    let currentFormData = getCurrentFormData() || [];
    const updatedForm = [...currentFormData];
    if (index < updatedForm.length) {
      updatedForm.splice(index, 1);
    }

    // 1. Synchronously update refs FIRST
    latestFormDataRef.current = updatedForm;
    latestFieldsRef.current = updatedFields;
    isFormDirtyRef.current = true;

    // 2. Update React states
    setFormDataForRoomType(roomTypeModal, updatedForm);
    setFilteredDataField(updatedFields);

    // 3. Immediately persist draft to Firestore in background
    saveDraftToFirestore(updatedForm, updatedFields);
  };

  const renderRowActions = (item, index) => (
    <Col
      xs="auto"
      className="hover-row-action-col ms-auto"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '6px',
        paddingLeft: '4px',
        paddingRight: '4px',
        flexShrink: 0,
        whiteSpace: 'nowrap'
      }}
    >
      <Button
        variant="outline-primary"
        size="sm"
        style={{
          borderRadius: "50%",
          width: "34px",
          height: "34px",
          minWidth: "34px",
          minHeight: "34px",
          maxWidth: "34px",
          maxHeight: "34px",
          padding: 0,
          margin: 0,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid #0d6efd",
          color: "#0d6efd",
          backgroundColor: "#fff",
          cursor: "pointer",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          flexShrink: 0,
          boxSizing: "border-box",
          lineHeight: 1
        }}
        title="Duplicate item below"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          duplicateRoomItem(index);
        }}
      >
        <i className="bi bi-files" style={{ fontSize: "14px", lineHeight: 1 }}></i>
      </Button>
      {(item.isUserAdded || item.isDuplicated) && (
        <Button
          variant="outline-danger"
          size="sm"
          style={{
            borderRadius: "50%",
            width: "34px",
            height: "34px",
            minWidth: "34px",
            minHeight: "34px",
            maxWidth: "34px",
            maxHeight: "34px",
            padding: 0,
            margin: 0,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid #dc3545",
            color: "#dc3545",
            backgroundColor: "#fff",
            cursor: "pointer",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            flexShrink: 0,
            boxSizing: "border-box",
            lineHeight: 1
          }}
          title="Delete item"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            deleteRoomItem(index);
          }}
        >
          <i className="bi bi-x-lg" style={{ fontSize: "14px", lineHeight: 1 }}></i>
        </Button>
      )}
    </Col>
  );

  const getDraggableId = (item, index) => item.id || `${item.name || 'item'}-${index}`;


  return (
    <Container fluid>
      <Row className='m-0' >
        <Col sm={1} >
          <Tab.Container  >
            <Row>
            </Row>
          </Tab.Container>
        </Col>
        <Col sm={11}>
          <Row>

          </Row>
          <hr style={{
            color: 'white'
          }} />
          <Row className="px-5 py-2">
            <Row className="d-flex justify-content-end col-sm-5 w-auto">
              <Breadcrumb>
                <Breadcrumb.Item

                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#e85d13",
                    textTransform: "uppercase",
                    letterSpacing: "-0.5px",

                    marginLeft: "20px", // Space between elements
                    textDecoration: 'none',
                    backgroundColor: "#ea6e2b",
                    borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Subtle shadow
                    height: 30,
                    width: 120,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer", // Pointer on hover
                    padding: '1rem',
                    marginLeft: "10px",

                    // Hover effect
                    ":hover": {
                      backgroundColor: "#FFA500", // Change background color on hover
                      transform: "scale(1.1)", // Slightly increase the size on hover
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                    }
                  }}
                  onClick={() => handleNavigateBackOrExit("/projects")}
                >Projects</Breadcrumb.Item>
                <Breadcrumb.Item
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#e85d13",
                    textTransform: "uppercase",
                    letterSpacing: "-0.5px",

                    marginLeft: "20px", // Space between elements
                    textDecoration: "none",
                    backgroundColor: "#ea6e2b",
                    borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Subtle shadow
                    height: 30,
                    width: 'auto',
                    padding: '0 5px 0 5px',
                    display: "flex",
                    padding: '1rem',
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer", // Pointer on hover

                    marginLeft: "10px",

                    // Hover effect
                    ":hover": {
                      backgroundColor: "#FFA500", // Change background color on hover
                      transform: "scale(1.1)", // Slightly increase the size on hover
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                    }
                  }}
                  onClick={() =>
                    handleNavigateBackOrExit("/projects/view-rooms", data)
                  }
                >
                  {data.pname}
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#333",
                    textTransform: "uppercase",
                    letterSpacing: "-0.5px",

                    marginLeft: "20px", // Space between elements
                    textDecoration: "none",
                    backgroundColor: "#ea6e2b",
                    borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Subtle shadow
                    height: 30,
                    width: 'auto',
                    padding: '1rem',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer", // Pointer on hover

                    marginLeft: "10px",

                    // Hover effect
                    ":hover": {
                      backgroundColor: "#FFA500", // Change background color on hover
                      transform: "scale(1.1)", // Slightly increase the size on hover
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                    }
                  }} active>Edit Room ({data.editData.roomTypeDesign})</Breadcrumb.Item>
              </Breadcrumb>
              <hr style={{
                color: 'white'
              }} />
            </Row>

            {isDraftRestored && (
              <Row className="px-5 mb-2 mt-2">
                <div className="alert alert-warning d-flex justify-content-between align-items-center w-100" style={{ borderRadius: '8px', padding: '10px 20px', marginBottom: 0 }}>
                  <div>
                    <i className="bi bi-clock-history me-2" style={{ fontSize: '1.2rem', color: '#856404' }}></i>
                    <strong>Editing Draft Copy Card:</strong> This is an auto-saved draft copy stored in the database. Click <strong>Save</strong> to convert to a permanent saved design option or <strong>Discard Draft</strong> to delete this draft.
                  </div>
                  <div>
                    <Button variant="outline-danger" size="sm" onClick={async () => {
                      isExplicitSavedRef.current = true;
                      const targetId = isEditingDraft ? designId : `draft_${designId}`;
                      if (clientId && targetId) {
                        try {
                          if (localDraftKey) localStorage.removeItem(localDraftKey);
                          localStorage.removeItem(`draft_card_${clientId}_${targetId}`);
                          await db.collection("client").doc(clientId).collection("Rooms").doc(targetId).delete();
                        } catch (e) { }
                      }
                      dispatch(fetchRoomList({ Id: clientId }));
                      navigation("/projects/view-rooms", { state: data });
                    }}>
                      Discard Draft
                    </Button>
                  </div>
                </div>
              </Row>
            )}

            {/* Room name and type modal */}


            {roomTypeModal == 'Kitchen' ?
              <Row
                style={{
                  // marginBottom: '50px',
                  // height:'auto',

                  padding: '20px',
                  // marginLeft: '20px',
                  borderRadius: '15px',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                  backgroundColor: '#ffff', // Light background color

                }} >
                <div style={{
                  display: "flex",
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  borderRadius: '15px',
                  padding: '0.5rem'
                }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Kitchen -- </h5><h6 style={{ color: '#e85d13' }}>{data.priceType === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                  {/* <h4>Kitchen --{data.priceType=== "oldvalue" ? ('Old Price') : ('New Price')}</h4>  */}
                  <Form>
                    <InputGroup>
                      <Form.Control
                        style={{
                          borderRadius: "15px",
                          padding: "12px 15px",
                          border: "1px solid #d1d5db",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                          background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                          transition: "all 0.3s ease",
                          width: "20vw",
                        }}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search Labels"
                      />
                    </InputGroup>
                  </Form>

                </div>

                <Row style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>
                  <Col style={{ minHeight: 380, maxHeight: 480 }}>

                    <Form>

                      <Form.Group>
                        <DragDropContext onDragEnd={handleDragKitchenEnd} >
                          <Droppable droppableId="droppable-kitchen">

                            {(provided) => (
                              <div ref={provided.innerRef} {...provided.droppableProps}>
                                {filteredDataField
                                  .map((item, index) => {
                                    // Find the matching form data by name (or id if available)
                                    // const formData = kitchenFormData.find(f => f.name === item.name) || {};

                                    return { item, formData: (kitchenFormData && kitchenFormData[index]) || {}, index };
                                  })
                                  .filter(({ item }) => {
                                    const searchQuery = search.toLowerCase();
                                    return searchQuery === '' || item.name?.toLowerCase().includes(searchQuery);
                                  })
                                  .map(({ item, formData, index }) => {


                                    console.log("ssss item:", item);
                                    console.log("ssss kitchenFormData:", kitchenFormData);
                                    console.log("ssss formData:", formData);
                                    console.log("ssss index:", index);

                                    return (<Draggable key={item.id || `temp-${index}`}
                                      draggableId={getDraggableId(item, index)}
                                      index={index}>
                                      {(provided) => (
                                        <div className={isItemFilled(formData) ? "selected-row-container" : ""} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >

                                          {item.measurement == "area" ?
                                            <Row className="hover-row">
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}><h6 style={{ color: '#e85d13' }}>{item.name}</h6></h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>

                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData?.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => {
                                                      const childList = item2.subMaterials;
                                                      const hasChild = childList && childList.length > 0;

                                                      return (
                                                        <div
                                                          key={index2}
                                                          style={{ position: "relative" }}
                                                          onMouseEnter={() => setHoveredItem(item2.label)}
                                                          onMouseLeave={() => setHoveredItem(null)}
                                                        >
                                                          <Dropdown.Item
                                                            onClick={() => {
                                                              if (!hasChild) {
                                                                handleKitchenOptionChange(
                                                                  {
                                                                    target: {
                                                                      value:
                                                                        data.priceType === "oldvalue"
                                                                          ? item2.oldvalue
                                                                          : item2.value,
                                                                      label: item2.label,
                                                                    },
                                                                  },
                                                                  index
                                                                );
                                                              }
                                                            }}
                                                            style={{
                                                              display: "flex",
                                                              justifyContent: "space-between",
                                                            }}
                                                          >
                                                            {item2.label}
                                                            {hasChild && <span>▶</span>}
                                                          </Dropdown.Item>

                                                          {/* ✅ Child Dropdown */}
                                                          {hasChild && hoveredItem === item2.label && (
                                                            <div
                                                              style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: "100%",
                                                                background: "white",
                                                                border: "1px solid #ddd",
                                                                minWidth: "180px",
                                                                zIndex: 1050,
                                                              }}
                                                            >
                                                              {item2.subMaterials.map((child, childIndex) => (
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    handleKitchenOptionChange(
                                                                      {
                                                                        target: {
                                                                          value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                          // value: child.subValue,
                                                                          label: `${item2.label} (${child.subLabel})`,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }}
                                                                >
                                                                  {child.subLabel}
                                                                </Dropdown.Item>
                                                              ))}
                                                            </div>
                                                          )}
                                                        </div>
                                                      );
                                                    })}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item, 'kitchen', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={formData.area === 0 ? "" : formData.area}
                                                    onChange={(e) => handleKitchenChange(e, index, "area")}
                                                    placeholder="Area"

                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={formData.price}
                                                    // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={formData.value ? false : true}
                                                    readOnly
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control

                                                    value={formData.remark}
                                                    onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              {renderRowActions(item, index)}
                                            </Row>
                                            : item.measurement == "width" ?
                                              <Row className="hover-row">
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData?.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => {
                                                        const childList = item2.subMaterials;
                                                        const hasChild = childList && childList.length > 0;

                                                        return (
                                                          <div
                                                            key={index2}
                                                            style={{ position: "relative" }}
                                                            onMouseEnter={() => setHoveredItem(item2.label)}
                                                            onMouseLeave={() => setHoveredItem(null)}
                                                          >
                                                            <Dropdown.Item
                                                              onClick={() => {
                                                                if (!hasChild) {
                                                                  handleKitchenOptionChange(
                                                                    {
                                                                      target: {
                                                                        value:
                                                                          data.priceType === "oldvalue"
                                                                            ? item2.oldvalue
                                                                            : item2.value,
                                                                        label: item2.label,
                                                                      },
                                                                    },
                                                                    index
                                                                  );
                                                                }
                                                              }}
                                                              style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                              }}
                                                            >
                                                              {item2.label}
                                                              {hasChild && <span>▶</span>}
                                                            </Dropdown.Item>

                                                            {/* ✅ Child Dropdown */}
                                                            {hasChild && hoveredItem === item2.label && (
                                                              <div
                                                                style={{
                                                                  position: "absolute",
                                                                  top: 0,
                                                                  left: "100%",
                                                                  background: "white",
                                                                  border: "1px solid #ddd",
                                                                  minWidth: "180px",
                                                                  zIndex: 1050,
                                                                }}
                                                              >
                                                                {item2.subMaterials.map((child, childIndex) => (
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      handleKitchenOptionChange(
                                                                        {
                                                                          target: {
                                                                            value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                            // value: child.subValue,
                                                                            label: `${item2.label} (${child.subLabel})`,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }}
                                                                  >
                                                                    {child.subLabel}
                                                                  </Dropdown.Item>
                                                                ))}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                      })}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item, 'kitchen', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>
                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={formData.width === 0 ? "" : formData.width}
                                                      onChange={(e) => handleKitchenChange(e, index, "width")}
                                                      placeholder="Width"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={formData.height === 0 ? "" : formData.height}
                                                      onChange={(e) => handleKitchenChange(e, index, "height")}
                                                      placeholder="Height"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={formData.qnty === 0 ? "" : formData.qnty}
                                                      onChange={(e) => handleKitchenChange(e, index, "qnty")}
                                                      placeholder="Qty"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={formData.price}
                                                      // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={formData.value ? false : true}
                                                    readOnly
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={formData.remark}
                                                      onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                {renderRowActions(item, index)}
                                              </Row>
                                              : item.measurement == "qty" ?
                                                <Row className="hover-row">
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData?.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => {
                                                          const childList = item2.subMaterials;
                                                          const hasChild = childList && childList.length > 0;

                                                          return (
                                                            <div
                                                              key={index2}
                                                              style={{ position: "relative" }}
                                                              onMouseEnter={() => setHoveredItem(item2.label)}
                                                              onMouseLeave={() => setHoveredItem(null)}
                                                            >
                                                              <Dropdown.Item
                                                                onClick={() => {
                                                                  if (!hasChild) {
                                                                    handleKitchenOptionChange(
                                                                      {
                                                                        target: {
                                                                          value:
                                                                            data.priceType === "oldvalue"
                                                                              ? item2.oldvalue
                                                                              : item2.value,
                                                                          label: item2.label,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }
                                                                }}
                                                                style={{
                                                                  display: "flex",
                                                                  justifyContent: "space-between",
                                                                }}
                                                              >
                                                                {item2.label}
                                                                {hasChild && <span>▶</span>}
                                                              </Dropdown.Item>

                                                              {/* ✅ Child Dropdown */}
                                                              {hasChild && hoveredItem === item2.label && (
                                                                <div
                                                                  style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: "100%",
                                                                    background: "white",
                                                                    border: "1px solid #ddd",
                                                                    minWidth: "180px",
                                                                    zIndex: 1050,
                                                                  }}
                                                                >
                                                                  {item2.subMaterials.map((child, childIndex) => (
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        handleKitchenOptionChange(
                                                                          {
                                                                            target: {
                                                                              value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                              // value: child.subValue,
                                                                              label: `${item2.label} (${child.subLabel})`,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }}
                                                                    >
                                                                      {child.subLabel}
                                                                    </Dropdown.Item>
                                                                  ))}
                                                                </div>
                                                              )}
                                                            </div>
                                                          );
                                                        })}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item, 'kitchen', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={formData.qnty === 0 ? "" : formData.qnty}
                                                        onChange={(e) => handleKitchenChange(e, index, "qnty")}
                                                        placeholder="Qty"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={formData.price}
                                                        // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={formData.value ? false : true}
                                                    readOnly
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={formData.remark}
                                                        onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  {renderRowActions(item, index)}
                                                </Row>
                                                : item.measurement == "length" ?
                                                  <Row className="hover-row">
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                    {/* add label option */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData?.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => {
                                                            const childList = item2.subMaterials;
                                                            const hasChild = childList && childList.length > 0;

                                                            return (
                                                              <div
                                                                key={index2}
                                                                style={{ position: "relative" }}
                                                                onMouseEnter={() => setHoveredItem(item2.label)}
                                                                onMouseLeave={() => setHoveredItem(null)}
                                                              >
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    if (!hasChild) {
                                                                      handleKitchenOptionChange(
                                                                        {
                                                                          target: {
                                                                            value:
                                                                              data.priceType === "oldvalue"
                                                                                ? item2.oldvalue
                                                                                : item2.value,
                                                                            label: item2.label,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }
                                                                  }}
                                                                  style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                  }}
                                                                >
                                                                  {item2.label}
                                                                  {hasChild && <span>▶</span>}
                                                                </Dropdown.Item>

                                                                {/* ✅ Child Dropdown */}
                                                                {hasChild && hoveredItem === item2.label && (
                                                                  <div
                                                                    style={{
                                                                      position: "absolute",
                                                                      top: 0,
                                                                      left: "100%",
                                                                      background: "white",
                                                                      border: "1px solid #ddd",
                                                                      minWidth: "180px",
                                                                      zIndex: 1050,
                                                                    }}
                                                                  >
                                                                    {item2.subMaterials.map((child, childIndex) => (
                                                                      <Dropdown.Item
                                                                        onClick={() => {
                                                                          handleKitchenOptionChange(
                                                                            {
                                                                              target: {
                                                                                value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                // value: child.subValue,
                                                                                label: `${item2.label} (${child.subLabel})`,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }}
                                                                      >
                                                                        {child.subLabel}
                                                                      </Dropdown.Item>
                                                                    ))}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            );
                                                          })}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item, 'kitchen', index);
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={formData.height === 0 ? "" : formData.height}
                                                          onChange={(e) => handleKitchenChange(e, index, "height")}
                                                          placeholder="Length"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={formData.width === 0 ? "" : formData.width}
                                                          onChange={(e) => handleKitchenChange(e, index, "width")}
                                                          placeholder="Width"
                                                        />
                                                      </Form.Group>
                                                    </Col>

                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={formData.price}
                                                          // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={kitchenFormData[index].value ? false : true}
                                                    readOnly
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={formData.remark}
                                                          onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    {renderRowActions(item, index)}
                                                  </Row> : item.measurement == "rft" ?
                                                    <Row className="hover-row">
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                      {/* add label option */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData?.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => {
                                                              const childList = item2.subMaterials;
                                                              const hasChild = childList && childList.length > 0;

                                                              return (
                                                                <div
                                                                  key={index2}
                                                                  style={{ position: "relative" }}
                                                                  onMouseEnter={() => setHoveredItem(item2.label)}
                                                                  onMouseLeave={() => setHoveredItem(null)}
                                                                >
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!hasChild) {
                                                                        handleKitchenOptionChange(
                                                                          {
                                                                            target: {
                                                                              value:
                                                                                data.priceType === "oldvalue"
                                                                                  ? item2.oldvalue
                                                                                  : item2.value,
                                                                              label: item2.label,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }
                                                                    }}
                                                                    style={{
                                                                      display: "flex",
                                                                      justifyContent: "space-between",
                                                                    }}
                                                                  >
                                                                    {item2.label}
                                                                    {hasChild && <span>▶</span>}
                                                                  </Dropdown.Item>

                                                                  {/* ✅ Child Dropdown */}
                                                                  {hasChild && hoveredItem === item2.label && (
                                                                    <div
                                                                      style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: "100%",
                                                                        background: "white",
                                                                        border: "1px solid #ddd",
                                                                        minWidth: "180px",
                                                                        zIndex: 1050,
                                                                      }}
                                                                    >
                                                                      {item2.subMaterials.map((child, childIndex) => (
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            handleKitchenOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                  // value: child.subValue,
                                                                                  label: `${item2.label} (${child.subLabel})`,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }}
                                                                        >
                                                                          {child.subLabel}
                                                                        </Dropdown.Item>
                                                                      ))}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              );
                                                            })}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item, 'kitchen', index);
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.rft === 0 ? "" : formData.rft}
                                                            onChange={(e) => handleKitchenChange(e, index, "rft")}
                                                            placeholder="RFT"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.price}
                                                            // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={formData.value ? false : true}
                                                    readOnly
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={formData.remark}
                                                            onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      {renderRowActions(item, index)}
                                                    </Row> : item.measurement == "selection" ?
                                                      <Row className="hover-row">
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                        {/* add label option */}
                                                        <Col sm={2} style={{ display: 'flex' }}>
                                                          <Dropdown>
                                                            <Dropdown.Toggle
                                                              variant="outline-secondary"
                                                              style={{
                                                                width: '12vw',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                whiteSpace: 'normal',        // Allows text to wrap
                                                                wordBreak: 'break-word',     // Breaks long words
                                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                              }}>
                                                              {formData?.label || 'None'}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                                              <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                None
                                                              </Dropdown.Item>
                                                              {item.material.map((item2, index2) => {
                                                                const childList = item2.subMaterials;
                                                                const hasChild = childList && childList.length > 0;

                                                                return (
                                                                  <div
                                                                    key={index2}
                                                                    style={{ position: "relative" }}
                                                                    onMouseEnter={() => setHoveredItem(item2.label)}
                                                                    onMouseLeave={() => setHoveredItem(null)}
                                                                  >
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        if (!hasChild) {
                                                                          handleKitchenOptionChange(
                                                                            {
                                                                              target: {
                                                                                value:
                                                                                  data.priceType === "oldvalue"
                                                                                    ? item2.oldvalue
                                                                                    : item2.value,
                                                                                label: item2.label,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }
                                                                      }}
                                                                      style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                      }}
                                                                    >
                                                                      {item2.label}
                                                                      {hasChild && <span>▶</span>}
                                                                    </Dropdown.Item>

                                                                    {/* ✅ Child Dropdown */}
                                                                    {hasChild && hoveredItem === item2.label && (
                                                                      <div
                                                                        style={{
                                                                          position: "absolute",
                                                                          top: 0,
                                                                          left: "100%",
                                                                          background: "white",
                                                                          border: "1px solid #ddd",
                                                                          minWidth: "180px",
                                                                          zIndex: 1050,
                                                                        }}
                                                                      >
                                                                        {item2.subMaterials.map((child, childIndex) => (
                                                                          <Dropdown.Item
                                                                            onClick={() => {
                                                                              handleKitchenOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                    // value: child.subValue,
                                                                                    label: `${item2.label} (${child.subLabel})`,
                                                                                  },
                                                                                },
                                                                                index
                                                                              );
                                                                            }}
                                                                          >
                                                                            {child.subLabel}
                                                                          </Dropdown.Item>
                                                                        ))}
                                                                      </div>
                                                                    )}
                                                                  </div>
                                                                );
                                                              })}

                                                              <Dropdown.Divider />

                                                              <div className="px-3 py-2">
                                                                <Button
                                                                  variant="outline-success"
                                                                  size="sm"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation(); // prevent dropdown from closing
                                                                    handleAddNewItem(item, 'kitchen', index);
                                                                  }}
                                                                >
                                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                </Button>
                                                              </div>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                        </Col>
                                                        <Col sm={2}>

                                                        </Col>

                                                        <Col sm={1}>

                                                        </Col>

                                                        <Col sm={2}>

                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={formData.remark}
                                                              onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        {renderRowActions(item, index)}
                                                      </Row> : null}
                                        </div>
                                      )}
                                    </Draggable>)
                                  })}
                                {provided.placeholder}
                              </div>
                            )}






                          </Droppable>
                        </DragDropContext >
                        <Row>
                          <Col>

                            <Row className="mx-1 my-3">
                              <Col sm={2}>
                                <Form.Group >
                                  <Form.Control
                                    value={extraItemName}
                                    onChange={(e) => setExtraItemName(e.target.value)}
                                    type="text"
                                    placeholder="Item Name"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={2}>
                                <Form.Group >
                                  <Form.Control
                                    value={extraItemMaterialName}
                                    onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                    type="text"
                                    placeholder="Material Name"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={2}>
                                <Form.Group >
                                  <Form.Control
                                    value={extraItemMaterialValue}
                                    onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                    type="number"
                                    placeholder="Material Value"
                                  />
                                </Form.Group>
                              </Col>

                              <Col sm={3}>
                                <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                  <option>Select Measurement Type</option>
                                  <option value="area">Area</option>
                                  <option value="width">Width &  Height</option>
                                  <option value="rft">RFT</option>
                                  <option value="qty">Quantity</option>
                                  <option value="length">Width & Length</option>
                                  <option value="selection">Selection</option>
                                </Form.Select>
                              </Col>
                              <Col sm={1}>
                                <Form.Check
                                  inline
                                  label="Wood"
                                  name="Wood"
                                  type="checkbox"
                                  id="inline-checkbox-1"
                                  checked={isChecked}
                                  onChange={handleCheckboxChange}
                                />
                              </Col>
                              <Col sm={2}>
                                <Button onClick={addNewKitchenItem}>Add Item</Button>
                              </Col>
                            </Row>





                          </Col>

                        </Row>
                      </Form.Group>


                    </Form>
                  </Col>
                </Row>


                {/* <Row className="mt-2">
                  <Col className="col-sm-5">
                    <Button className="w-50 rounded-1" style={{ fontSize: 16, fontWeight: 600 }} onClick={() => saveKitchenData()} >Save</Button>
                  </Col>
                  <Col className="col-sm-3">
                    <h4>Total Price</h4>
                  </Col>
                  <Col className="col-sm-2"></Col>
                  <Col className="col-sm-2">
                    <h4>
                      Rs:- {calculateKitchenTotal()}

                    </h4>
                  </Col>
                </Row> */}


                <Row style={{
                  // marginBottom: '50px',
                  marginLeft: '1px',
                  padding: '20px',
                  borderRadius: '15px',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                  backgroundColor: '#ffffff', // Light background color


                }} >
                  <Col >
                    <Button className="buttonDesign" style={{ fontSize: 13, width: '20vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveKitchenData()} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                  </Col>
                  <Col className="col-sm-3">

                  </Col>
                  <Col className="col-sm-2"><h4>Total Price</h4></Col>
                  <Col className="col-sm-2">
                    {/* <h4>
                                        Rs:- {roomTypePrice}
                
                                      </h4> */}
                    <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{calculateKitchenTotal()}</h4></span>
                  </Col>
                </Row>

              </Row> : roomTypeModal == 'Bedroom' ?
                <Row
                  style={{
                    // marginBottom: '50px',
                    // height:'auto',

                    padding: '20px',
                    // marginLeft: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffff', // Light background color

                  }}  >
                  <div style={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: '15px',
                    padding: '0.5rem'
                  }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Bedroom -- </h5><h6 style={{ color: '#e85d13' }}>{data.priceType === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                    <Form>
                      <InputGroup>
                        <Form.Control
                          style={{
                            borderRadius: "15px",
                            padding: "12px 15px",
                            border: "1px solid #d1d5db",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                            transition: "all 0.3s ease",
                            width: "20vw",
                          }}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search Labels"
                        />
                      </InputGroup>
                    </Form>
                  </div>
                  <Row style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>
                    <Col style={{ minHeight: 380, maxHeight: 480 }}>

                      <Form>

                        <Form.Group>
                          <DragDropContext onDragEnd={handleDragBedroomEnd} >
                            <Droppable droppableId="droppable-bedroom">
                              {(provided) => (
                                <div ref={provided.innerRef}{...provided.droppableProps}>
                                  {filteredDataField
                                    .map((item, index) => ({ item, formData: (bedroomFormData && bedroomFormData[index]) || {}, index }))
                                    .filter(({ item }) => {
                                      const searchQuery = search.toLowerCase();
                                      return searchQuery === '' || item.name?.toLowerCase().includes(searchQuery);
                                    })
                                    .map(({ item, formData, index }) => (
                                      <Draggable key={item.id || `temp-${index}`}
                                        draggableId={getDraggableId(item, index)}
                                        index={index}>
                                        {(provided) => (

                                          <div className={isItemFilled(formData) ? "selected-row-container" : ""} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                            {
                                              item.measurement == "area" ?
                                                <Row className="hover-row">
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              // value={bedroomFormData[index].value}
                              onChange={(e) => handleBedroomOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData?.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => {
                                                          const childList = item2.subMaterials;
                                                          const hasChild = childList && childList.length > 0;

                                                          return (
                                                            <div
                                                              key={index2}
                                                              style={{ position: "relative" }}
                                                              onMouseEnter={() => setHoveredItem(item2.label)}
                                                              onMouseLeave={() => setHoveredItem(null)}
                                                            >
                                                              <Dropdown.Item
                                                                onClick={() => {
                                                                  if (!hasChild) {
                                                                    handleBedroomOptionChange(
                                                                      {
                                                                        target: {
                                                                          value:
                                                                            data.priceType === "oldvalue"
                                                                              ? item2.oldvalue
                                                                              : item2.value,
                                                                          label: item2.label,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }
                                                                }}
                                                                style={{
                                                                  display: "flex",
                                                                  justifyContent: "space-between",
                                                                }}
                                                              >
                                                                {item2.label}
                                                                {hasChild && <span>▶</span>}
                                                              </Dropdown.Item>

                                                              {/* ✅ Child Dropdown */}
                                                              {hasChild && hoveredItem === item2.label && (
                                                                <div
                                                                  style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: "100%",
                                                                    background: "white",
                                                                    border: "1px solid #ddd",
                                                                    minWidth: "180px",
                                                                    zIndex: 1050,
                                                                  }}
                                                                >
                                                                  {item2.subMaterials.map((child, childIndex) => (
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        handleBedroomOptionChange(
                                                                          {
                                                                            target: {
                                                                              value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                              // value: child.subValue,
                                                                              label: `${item2.label} (${child.subLabel})`,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }}
                                                                    >
                                                                      {child.subLabel}
                                                                    </Dropdown.Item>
                                                                  ))}
                                                                </div>
                                                              )}
                                                            </div>
                                                          );
                                                        })}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item, 'kitchen', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={formData.area === 0 ? "" : formData.area}
                                                        onChange={(e) => handleBedroomChange(e, index, "area")}
                                                        placeholder="Area"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={formData.price}
                                                        // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={bedroomFormData[index].value ? false : true}
                                                    readOnly
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={formData.remark}
                                                        onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  {renderRowActions(item, index)}
                                                </Row>
                                                : item.measurement == "width" ?
                                                  <Row className="hover-row">
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={bedroomFormData[index].value}
                              onChange={(e) => handleBedroomOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData?.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => {
                                                            const childList = item2.subMaterials;
                                                            const hasChild = childList && childList.length > 0;

                                                            return (
                                                              <div
                                                                key={index2}
                                                                style={{ position: "relative" }}
                                                                onMouseEnter={() => setHoveredItem(item2.label)}
                                                                onMouseLeave={() => setHoveredItem(null)}
                                                              >
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    if (!hasChild) {
                                                                      handleBedroomOptionChange(
                                                                        {
                                                                          target: {
                                                                            value:
                                                                              data.priceType === "oldvalue"
                                                                                ? item2.oldvalue
                                                                                : item2.value,
                                                                            label: item2.label,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }
                                                                  }}
                                                                  style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                  }}
                                                                >
                                                                  {item2.label}
                                                                  {hasChild && <span>▶</span>}
                                                                </Dropdown.Item>

                                                                {/* ✅ Child Dropdown */}
                                                                {hasChild && hoveredItem === item2.label && (
                                                                  <div
                                                                    style={{
                                                                      position: "absolute",
                                                                      top: 0,
                                                                      left: "100%",
                                                                      background: "white",
                                                                      border: "1px solid #ddd",
                                                                      minWidth: "180px",
                                                                      zIndex: 1050,
                                                                    }}
                                                                  >
                                                                    {item2.subMaterials.map((child, childIndex) => (
                                                                      <Dropdown.Item
                                                                        onClick={() => {
                                                                          handleBedroomOptionChange(
                                                                            {
                                                                              target: {
                                                                                value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                // value: child.subValue,
                                                                                label: `${item2.label} (${child.subLabel})`,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }}
                                                                      >
                                                                        {child.subLabel}
                                                                      </Dropdown.Item>
                                                                    ))}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            );
                                                          })}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item, 'kitchen', index);
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={formData.width === 0 ? "" : formData.width}
                                                          onChange={(e) => handleBedroomChange(e, index, "width")}
                                                          placeholder="Width"
                                                        />
                                                      </Form.Group>
                                                    </Col>

                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={formData.height === 0 ? "" : formData.height}
                                                          onChange={(e) => handleBedroomChange(e, index, "height")}
                                                          placeholder="Height"
                                                        />
                                                      </Form.Group>
                                                    </Col>

                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={formData.qnty === 0 ? "" : formData.qnty}
                                                          onChange={(e) => handleBedroomChange(e, index, "qnty")}
                                                          placeholder="Qty"
                                                        />
                                                      </Form.Group>
                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={formData.price}
                                                          // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={formData.value ? false : true}
                                                    readOnly
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={formData.remark}
                                                          onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    {renderRowActions(item, index)}
                                                  </Row>
                                                  : item.measurement == "qty" ?
                                                    <Row className="hover-row">
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={bedroomFormData[index].value}
                              onChange={(e) => handleBedroomOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData?.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => {
                                                              const childList = item2.subMaterials;
                                                              const hasChild = childList && childList.length > 0;

                                                              return (
                                                                <div
                                                                  key={index2}
                                                                  style={{ position: "relative" }}
                                                                  onMouseEnter={() => setHoveredItem(item2.label)}
                                                                  onMouseLeave={() => setHoveredItem(null)}
                                                                >
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!hasChild) {
                                                                        handleBedroomOptionChange(
                                                                          {
                                                                            target: {
                                                                              value:
                                                                                data.priceType === "oldvalue"
                                                                                  ? item2.oldvalue
                                                                                  : item2.value,
                                                                              label: item2.label,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }
                                                                    }}
                                                                    style={{
                                                                      display: "flex",
                                                                      justifyContent: "space-between",
                                                                    }}
                                                                  >
                                                                    {item2.label}
                                                                    {hasChild && <span>▶</span>}
                                                                  </Dropdown.Item>

                                                                  {/* ✅ Child Dropdown */}
                                                                  {hasChild && hoveredItem === item2.label && (
                                                                    <div
                                                                      style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: "100%",
                                                                        background: "white",
                                                                        border: "1px solid #ddd",
                                                                        minWidth: "180px",
                                                                        zIndex: 1050,
                                                                      }}
                                                                    >
                                                                      {item2.subMaterials.map((child, childIndex) => (
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            handleBedroomOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                  // value: child.subValue,
                                                                                  label: `${item2.label} (${child.subLabel})`,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }}
                                                                        >
                                                                          {child.subLabel}
                                                                        </Dropdown.Item>
                                                                      ))}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              );
                                                            })}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item, 'kitchen', index);
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.qnty === 0 ? "" : formData.qnty}
                                                            onChange={(e) => handleBedroomChange(e, index, "qnty")}
                                                            placeholder="Qty"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.price}
                                                            // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={formData.value ? false : true}
                                                    readOnly
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={formData.remark}
                                                            onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      {renderRowActions(item, index)}
                                                    </Row>
                                                    : item.measurement == "length" ?
                                                      <Row className="hover-row">
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={bedroomFormData[index].value}
                              onChange={(e) => handleBedroomOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                        <Col sm={2} style={{ display: 'flex' }}>
                                                          <Dropdown>
                                                            <Dropdown.Toggle
                                                              variant="outline-secondary"
                                                              style={{
                                                                width: '12vw',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                whiteSpace: 'normal',        // Allows text to wrap
                                                                wordBreak: 'break-word',     // Breaks long words
                                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                              }}>
                                                              {formData?.label || 'None'}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                                              <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                None
                                                              </Dropdown.Item>
                                                              {item.material.map((item2, index2) => {
                                                                const childList = item2.subMaterials;
                                                                const hasChild = childList && childList.length > 0;

                                                                return (
                                                                  <div
                                                                    key={index2}
                                                                    style={{ position: "relative" }}
                                                                    onMouseEnter={() => setHoveredItem(item2.label)}
                                                                    onMouseLeave={() => setHoveredItem(null)}
                                                                  >
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        if (!hasChild) {
                                                                          handleBedroomOptionChange(
                                                                            {
                                                                              target: {
                                                                                value:
                                                                                  data.priceType === "oldvalue"
                                                                                    ? item2.oldvalue
                                                                                    : item2.value,
                                                                                label: item2.label,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }
                                                                      }}
                                                                      style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                      }}
                                                                    >
                                                                      {item2.label}
                                                                      {hasChild && <span>▶</span>}
                                                                    </Dropdown.Item>

                                                                    {/* ✅ Child Dropdown */}
                                                                    {hasChild && hoveredItem === item2.label && (
                                                                      <div
                                                                        style={{
                                                                          position: "absolute",
                                                                          top: 0,
                                                                          left: "100%",
                                                                          background: "white",
                                                                          border: "1px solid #ddd",
                                                                          minWidth: "180px",
                                                                          zIndex: 1050,
                                                                        }}
                                                                      >
                                                                        {item2.subMaterials.map((child, childIndex) => (
                                                                          <Dropdown.Item
                                                                            onClick={() => {
                                                                              handleBedroomOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                    // value: child.subValue,
                                                                                    label: `${item2.label} (${child.subLabel})`,
                                                                                  },
                                                                                },
                                                                                index
                                                                              );
                                                                            }}
                                                                          >
                                                                            {child.subLabel}
                                                                          </Dropdown.Item>
                                                                        ))}
                                                                      </div>
                                                                    )}
                                                                  </div>
                                                                );
                                                              })}

                                                              <Dropdown.Divider />

                                                              <div className="px-3 py-2">
                                                                <Button
                                                                  variant="outline-success"
                                                                  size="sm"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation(); // prevent dropdown from closing
                                                                    handleAddNewItem(item, 'kitchen', index);
                                                                  }}
                                                                >
                                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                </Button>
                                                              </div>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                        </Col>
                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.height === 0 ? "" : formData.height}
                                                              onChange={(e) => handleBedroomChange(e, index, "height")}
                                                              placeholder="Length"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.width === 0 ? "" : formData.width}
                                                              onChange={(e) => handleBedroomChange(e, index, "width")}
                                                              placeholder="Width"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>

                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.price}
                                                              // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={formData.value ? false : true}
                                                    readOnly
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={formData.remark}
                                                              onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        {renderRowActions(item, index)}
                                                      </Row> : item.measurement == "rft" ?
                                                        <Row className="hover-row">
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Label
                                                                style={{
                                                                  fontSize: 16,
                                                                  fontWeight: "500",
                                                                }}
                                                              ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                              </Form.Label>
                                                            </Form.Group>
                                                          </Col>
                                                          {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={bedroomFormData[index].value}
                              onChange={(e) => handleBedroomOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                          <Col sm={2} style={{ display: 'flex' }}>
                                                            <Dropdown>
                                                              <Dropdown.Toggle
                                                                variant="outline-secondary"
                                                                style={{
                                                                  width: '12vw',
                                                                  backgroundColor: 'white',
                                                                  color: 'black',
                                                                  display: 'flex',
                                                                  justifyContent: 'space-between',
                                                                  alignItems: 'center',
                                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                                  wordBreak: 'break-word',     // Breaks long words
                                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                }}>
                                                                {formData?.label || 'None'}
                                                              </Dropdown.Toggle>
                                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                                <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                  None
                                                                </Dropdown.Item>
                                                                {item.material.map((item2, index2) => {
                                                                  const childList = item2.subMaterials;
                                                                  const hasChild = childList && childList.length > 0;

                                                                  return (
                                                                    <div
                                                                      key={index2}
                                                                      style={{ position: "relative" }}
                                                                      onMouseEnter={() => setHoveredItem(item2.label)}
                                                                      onMouseLeave={() => setHoveredItem(null)}
                                                                    >
                                                                      <Dropdown.Item
                                                                        onClick={() => {
                                                                          if (!hasChild) {
                                                                            handleBedroomOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value:
                                                                                    data.priceType === "oldvalue"
                                                                                      ? item2.oldvalue
                                                                                      : item2.value,
                                                                                  label: item2.label,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }
                                                                        }}
                                                                        style={{
                                                                          display: "flex",
                                                                          justifyContent: "space-between",
                                                                        }}
                                                                      >
                                                                        {item2.label}
                                                                        {hasChild && <span>▶</span>}
                                                                      </Dropdown.Item>

                                                                      {/* ✅ Child Dropdown */}
                                                                      {hasChild && hoveredItem === item2.label && (
                                                                        <div
                                                                          style={{
                                                                            position: "absolute",
                                                                            top: 0,
                                                                            left: "100%",
                                                                            background: "white",
                                                                            border: "1px solid #ddd",
                                                                            minWidth: "180px",
                                                                            zIndex: 1050,
                                                                          }}
                                                                        >
                                                                          {item2.subMaterials.map((child, childIndex) => (
                                                                            <Dropdown.Item
                                                                              onClick={() => {
                                                                                handleBedroomOptionChange(
                                                                                  {
                                                                                    target: {
                                                                                      value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                      // value: child.subValue,
                                                                                      label: `${item2.label} (${child.subLabel})`,
                                                                                    },
                                                                                  },
                                                                                  index
                                                                                );
                                                                              }}
                                                                            >
                                                                              {child.subLabel}
                                                                            </Dropdown.Item>
                                                                          ))}
                                                                        </div>
                                                                      )}
                                                                    </div>
                                                                  );
                                                                })}

                                                                <Dropdown.Divider />

                                                                <div className="px-3 py-2">
                                                                  <Button
                                                                    variant="outline-success"
                                                                    size="sm"
                                                                    onClick={(e) => {
                                                                      e.stopPropagation(); // prevent dropdown from closing
                                                                      handleAddNewItem(item, 'kitchen', index);
                                                                    }}
                                                                  >
                                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                  </Button>
                                                                </div>
                                                              </Dropdown.Menu>
                                                            </Dropdown>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.rft === 0 ? "" : formData.rft}
                                                                onChange={(e) => handleBedroomChange(e, index, "rft")}
                                                                placeholder="RFT"
                                                              />
                                                            </Form.Group>
                                                          </Col>

                                                          <Col sm={1}>

                                                          </Col>

                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.price}
                                                                // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                                placeholder="Price"
                                                                disabled={formData.value ? false : true}
                                                    readOnly
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                value={formData.remark}
                                                                onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                                as="textarea" rows={1}
                                                                placeholder="Remark"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          {renderRowActions(item, index)}
                                                        </Row> : item.measurement == "door" ?
                                                          <Row className="hover-row">
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Label
                                                                  style={{
                                                                    fontSize: 16,
                                                                    fontWeight: "500",
                                                                  }}
                                                                ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                </Form.Label>
                                                              </Form.Group>
                                                            </Col>
                                                            {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={bedroomFormData[index].value}
                              onChange={(e) => handleBedroomOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                            <Col sm={2} style={{ display: 'flex' }}>
                                                              <Dropdown>
                                                                <Dropdown.Toggle
                                                                  variant="outline-secondary"
                                                                  style={{
                                                                    width: '12vw',
                                                                    backgroundColor: 'white',
                                                                    color: 'black',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                                    wordBreak: 'break-word',     // Breaks long words
                                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                  }}>
                                                                  {formData?.label || 'None'}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                                  <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                    None
                                                                  </Dropdown.Item>
                                                                  {item.material.map((item2, index2) => {
                                                                    const childList = item2.subMaterials;
                                                                    const hasChild = childList && childList.length > 0;

                                                                    return (
                                                                      <div
                                                                        key={index2}
                                                                        style={{ position: "relative" }}
                                                                        onMouseEnter={() => setHoveredItem(item2.label)}
                                                                        onMouseLeave={() => setHoveredItem(null)}
                                                                      >
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            if (!hasChild) {
                                                                              handleBedroomOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value:
                                                                                      data.priceType === "oldvalue"
                                                                                        ? item2.oldvalue
                                                                                        : item2.value,
                                                                                    label: item2.label,
                                                                                  },
                                                                                },
                                                                                index
                                                                              );
                                                                            }
                                                                          }}
                                                                          style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                          }}
                                                                        >
                                                                          {item2.label}
                                                                          {hasChild && <span>▶</span>}
                                                                        </Dropdown.Item>

                                                                        {/* ✅ Child Dropdown */}
                                                                        {hasChild && hoveredItem === item2.label && (
                                                                          <div
                                                                            style={{
                                                                              position: "absolute",
                                                                              top: 0,
                                                                              left: "100%",
                                                                              background: "white",
                                                                              border: "1px solid #ddd",
                                                                              minWidth: "180px",
                                                                              zIndex: 1050,
                                                                            }}
                                                                          >
                                                                            {item2.subMaterials.map((child, childIndex) => (
                                                                              <Dropdown.Item
                                                                                onClick={() => {
                                                                                  handleBedroomOptionChange(
                                                                                    {
                                                                                      target: {
                                                                                        value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                        // value: child.subValue,
                                                                                        label: `${item2.label} (${child.subLabel})`,
                                                                                      },
                                                                                    },
                                                                                    index
                                                                                  );
                                                                                }}
                                                                              >
                                                                                {child.subLabel}
                                                                              </Dropdown.Item>
                                                                            ))}
                                                                          </div>
                                                                        )}
                                                                      </div>
                                                                    );
                                                                  })}

                                                                  <Dropdown.Divider />

                                                                  <div className="px-3 py-2">
                                                                    <Button
                                                                      variant="outline-success"
                                                                      size="sm"
                                                                      onClick={(e) => {
                                                                        e.stopPropagation(); // prevent dropdown from closing
                                                                        handleAddNewItem(item, 'kitchen', index);
                                                                      }}
                                                                    >
                                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                    </Button>
                                                                  </div>
                                                                </Dropdown.Menu>
                                                              </Dropdown>
                                                            </Col>
                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Select
                                                                  value={formData.value2}
                                                                  onChange={(e) => handleBedroomOption2Change(e, index)}

                                                                  disabled={bedroomFormData[index].price == 0 ? true : false}


                                                                >
                                                                  <option value="0">None</option>
                                                                  {item.door.map((item2, index2) => (
                                                                    <option
                                                                      key={index2}
                                                                      value={item2.value}
                                                                    >
                                                                      {item2.label}
                                                                    </option>
                                                                  ))}

                                                                </Form.Select>
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.width === 0 ? "" : formData.width}
                                                                  onChange={(e) => handleBedroomChange(e, index, "width")}
                                                                  placeholder="Width"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.height === 0 ? "" : formData.height}
                                                                  onChange={(e) => handleBedroomChange(e, index, "height")}
                                                                  placeholder="Height"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.qnty === 0 ? "" : formData.qnty}
                                                                  onChange={(e) => handleBedroomChange(e, index, "qnty")}
                                                                  placeholder="Qty"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.price}
                                                                  // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                                  placeholder="Price"
                                                                  disabled={formData.value ? false : true}
                                                    readOnly
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  value={formData.remark}
                                                                  onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                                  as="textarea" rows={1}
                                                                  placeholder="Remark"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            {renderRowActions(item, index)}
                                                          </Row> : item.measurement == "selection" ?
                                                            <Row className="hover-row">
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Label
                                                                    style={{
                                                                      fontSize: 16,
                                                                      fontWeight: "500",
                                                                    }}
                                                                  ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                  </Form.Label>
                                                                </Form.Group>
                                                              </Col>
                                                              {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                              {/* add label option */}
                                                              <Col sm={2} style={{ display: 'flex' }}>
                                                                <Dropdown>
                                                                  <Dropdown.Toggle
                                                                    variant="outline-secondary"
                                                                    style={{
                                                                      width: '12vw',
                                                                      backgroundColor: 'white',
                                                                      color: 'black',
                                                                      display: 'flex',
                                                                      justifyContent: 'space-between',
                                                                      alignItems: 'center',
                                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                                      wordBreak: 'break-word',     // Breaks long words
                                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                    }}>
                                                                    {formData?.label || 'None'}
                                                                  </Dropdown.Toggle>
                                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                                    <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                      None
                                                                    </Dropdown.Item>
                                                                    {item.material.map((item2, index2) => {
                                                                      const childList = item2.subMaterials;
                                                                      const hasChild = childList && childList.length > 0;

                                                                      return (
                                                                        <div
                                                                          key={index2}
                                                                          style={{ position: "relative" }}
                                                                          onMouseEnter={() => setHoveredItem(item2.label)}
                                                                          onMouseLeave={() => setHoveredItem(null)}
                                                                        >
                                                                          <Dropdown.Item
                                                                            onClick={() => {
                                                                              if (!hasChild) {
                                                                                handleBedroomOptionChange(
                                                                                  {
                                                                                    target: {
                                                                                      value:
                                                                                        data.priceType === "oldvalue"
                                                                                          ? item2.oldvalue
                                                                                          : item2.value,
                                                                                      label: item2.label,
                                                                                    },
                                                                                  },
                                                                                  index
                                                                                );
                                                                              }
                                                                            }}
                                                                            style={{
                                                                              display: "flex",
                                                                              justifyContent: "space-between",
                                                                            }}
                                                                          >
                                                                            {item2.label}
                                                                            {hasChild && <span>▶</span>}
                                                                          </Dropdown.Item>

                                                                          {/* ✅ Child Dropdown */}
                                                                          {hasChild && hoveredItem === item2.label && (
                                                                            <div
                                                                              style={{
                                                                                position: "absolute",
                                                                                top: 0,
                                                                                left: "100%",
                                                                                background: "white",
                                                                                border: "1px solid #ddd",
                                                                                minWidth: "180px",
                                                                                zIndex: 1050,
                                                                              }}
                                                                            >
                                                                              {item2.subMaterials.map((child, childIndex) => (
                                                                                <Dropdown.Item
                                                                                  onClick={() => {
                                                                                    handleBedroomOptionChange(
                                                                                      {
                                                                                        target: {
                                                                                          value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                          // value: child.subValue,
                                                                                          label: `${item2.label} (${child.subLabel})`,
                                                                                        },
                                                                                      },
                                                                                      index
                                                                                    );
                                                                                  }}
                                                                                >
                                                                                  {child.subLabel}
                                                                                </Dropdown.Item>
                                                                              ))}
                                                                            </div>
                                                                          )}
                                                                        </div>
                                                                      );
                                                                    })}

                                                                    <Dropdown.Divider />

                                                                    <div className="px-3 py-2">
                                                                      <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation(); // prevent dropdown from closing
                                                                          handleAddNewItem(item, 'kitchen', index);
                                                                        }}
                                                                      >
                                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                      </Button>
                                                                    </div>
                                                                  </Dropdown.Menu>
                                                                </Dropdown>
                                                              </Col>
                                                              <Col sm={2}>

                                                              </Col>

                                                              <Col sm={1}>

                                                              </Col>

                                                              <Col sm={2}>

                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    value={formData.remark}
                                                                    onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                                    as="textarea" rows={1}
                                                                    placeholder="Remark"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              {renderRowActions(item, index)}
                                                            </Row> : item.measurement == "depth" ?
                                                              <Row className="hover-row">
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Label
                                                                      style={{
                                                                        fontSize: 16,
                                                                        fontWeight: "500",
                                                                      }}
                                                                    ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                    </Form.Label>
                                                                  </Form.Group>
                                                                </Col>

                                                                <Col sm={2} style={{ display: 'flex' }}>
                                                                  <Dropdown>
                                                                    <Dropdown.Toggle
                                                                      variant="outline-secondary"
                                                                      style={{
                                                                        width: '12vw',
                                                                        backgroundColor: 'white',
                                                                        color: 'black',
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center',
                                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                                        wordBreak: 'break-word',     // Breaks long words
                                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                      }}>
                                                                      {formData?.label || 'None'}
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                                      <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                        None
                                                                      </Dropdown.Item>
                                                                      {item.material.map((item2, index2) => {
                                                                        const childList = item2.subMaterials;
                                                                        const hasChild = childList && childList.length > 0;

                                                                        return (
                                                                          <div
                                                                            key={index2}
                                                                            style={{ position: "relative" }}
                                                                            onMouseEnter={() => setHoveredItem(item2.label)}
                                                                            onMouseLeave={() => setHoveredItem(null)}
                                                                          >
                                                                            <Dropdown.Item
                                                                              onClick={() => {
                                                                                if (!hasChild) {
                                                                                  handleBedroomOptionChange(
                                                                                    {
                                                                                      target: {
                                                                                        value:
                                                                                          data.priceType === "oldvalue"
                                                                                            ? item2.oldvalue
                                                                                            : item2.value,
                                                                                        label: item2.label,
                                                                                      },
                                                                                    },
                                                                                    index
                                                                                  );
                                                                                }
                                                                              }}
                                                                              style={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                              }}
                                                                            >
                                                                              {item2.label}
                                                                              {hasChild && <span>▶</span>}
                                                                            </Dropdown.Item>

                                                                            {/* ✅ Child Dropdown */}
                                                                            {hasChild && hoveredItem === item2.label && (
                                                                              <div
                                                                                style={{
                                                                                  position: "absolute",
                                                                                  top: 0,
                                                                                  left: "100%",
                                                                                  background: "white",
                                                                                  border: "1px solid #ddd",
                                                                                  minWidth: "180px",
                                                                                  zIndex: 1050,
                                                                                }}
                                                                              >
                                                                                {item2.subMaterials.map((child, childIndex) => (
                                                                                  <Dropdown.Item
                                                                                    onClick={() => {
                                                                                      handleBedroomOptionChange(
                                                                                        {
                                                                                          target: {
                                                                                            value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                            // value: child.subValue,
                                                                                            label: `${item2.label} (${child.subLabel})`,
                                                                                          },
                                                                                        },
                                                                                        index
                                                                                      );
                                                                                    }}
                                                                                  >
                                                                                    {child.subLabel}
                                                                                  </Dropdown.Item>
                                                                                ))}
                                                                              </div>
                                                                            )}
                                                                          </div>
                                                                        );
                                                                      })}

                                                                      <Dropdown.Divider />

                                                                      <div className="px-3 py-2">
                                                                        <Button
                                                                          variant="outline-success"
                                                                          size="sm"
                                                                          onClick={(e) => {
                                                                            e.stopPropagation(); // prevent dropdown from closing
                                                                            handleAddNewItem(item, 'kitchen', index);
                                                                          }}
                                                                        >
                                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                        </Button>
                                                                      </div>
                                                                    </Dropdown.Menu>
                                                                  </Dropdown>
                                                                </Col>
                                                                <Col sm={1}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.width === 0 ? "" : formData.width}
                                                                      onChange={(e) => handleBedroomChange(e, index, "width")}
                                                                      placeholder="Length"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                <Col sm={1}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.height === 0 ? "" : formData.height}
                                                                      onChange={(e) => handleBedroomChange(e, index, "height")}
                                                                      placeholder="Height"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>

                                                                <Col sm={1}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.depth === 0 ? "" : formData.depth}
                                                                      onChange={(e) => handleBedroomChange(e, index, "depth")}
                                                                      placeholder="Depth"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>

                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.price}
                                                                      // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                                      placeholder="Price"
                                                                      disabled={formData.value ? false : true}
                                                    readOnly
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      value={formData.remark}
                                                                      onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                                      as="textarea" rows={1}
                                                                      placeholder="Remark"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                {renderRowActions(item, index)}
                                                              </Row> : null
                                            }
                                          </div>
                                        )}

                                      </Draggable>

                                    ))}
                                  {provided.placeholder}
                                </div>
                              )}


                            </Droppable>

                          </DragDropContext>
                          <Row>
                            <Col>

                              <Row className="mx-1 my-3">
                                <Col sm={2}>
                                  <Form.Group >
                                    <Form.Control
                                      value={extraItemName}
                                      onChange={(e) => setExtraItemName(e.target.value)}
                                      type="text"
                                      placeholder="Item Name"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={2}>
                                  <Form.Group >
                                    <Form.Control
                                      value={extraItemMaterialName}
                                      onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                      type="text"
                                      placeholder="Material Name"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={2}>
                                  <Form.Group >
                                    <Form.Control
                                      value={extraItemMaterialValue}
                                      onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                      type="number"
                                      placeholder="Material Value"
                                    />
                                  </Form.Group>
                                </Col>

                                <Col sm={3}>
                                  <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                    <option>Select Measurement Type</option>
                                    <option value="area">Area</option>
                                    <option value="width">Width &  Height</option>
                                    <option value="rft">RFT</option>
                                    <option value="qty">Quantity</option>
                                    <option value="length">Width & Length</option>
                                    <option value="selection">Selection</option>
                                  </Form.Select>
                                </Col>
                                <Col sm={1}>
                                  <Form.Check
                                    inline
                                    label="Wood"
                                    name="Wood"
                                    type="checkbox"
                                    id="inline-checkbox-1"
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                  />
                                </Col>

                                <Col sm={2}>
                                  <Button onClick={addNewBedroomItem}>Add Item</Button>
                                </Col>
                              </Row>





                            </Col>

                          </Row>
                        </Form.Group>


                      </Form>
                    </Col>
                  </Row>


                  <Row style={{
                    // marginBottom: '50px',
                    marginLeft: '1px',
                    padding: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffffff', // Light background color


                  }} >
                    <Col >
                      <Button className="buttonDesign" style={{ fontSize: 13, width: '20vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveBedroomData()} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                    </Col>
                    <Col className="col-sm-3">

                    </Col>
                    <Col className="col-sm-2"><h4>Total Price</h4></Col>
                    <Col className="col-sm-2">
                      {/* <h4>
                                        Rs:- {roomTypePrice}
                
                                      </h4> */}
                      <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{calculateBedroomTotal()}</h4></span>
                    </Col>
                  </Row>

                </Row> : roomTypeModal == 'Foyer' ?
                  <Row
                    style={{
                      // marginBottom: '50px',
                      // height:'auto',

                      padding: '20px',
                      // marginLeft: '20px',
                      borderRadius: '15px',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                      backgroundColor: '#ffff', // Light background color

                    }} >
                    <div style={{
                      display: "flex",
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderRadius: '15px',
                      padding: '0.5rem'
                    }}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Foyer -- </h5><h6 style={{ color: '#e85d13' }}>{data.priceType === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                      <Form>
                        <InputGroup>
                          <Form.Control
                            style={{
                              borderRadius: "15px",
                              padding: "12px 15px",
                              border: "1px solid #d1d5db",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                              background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                              transition: "all 0.3s ease",
                              width: "20vw",
                            }}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search Projects"
                          />
                        </InputGroup>
                      </Form>
                    </div>
                    <Row style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>
                      <Col style={{ minHeight: 380, maxHeight: 480 }}>

                        <Form>

                          <Form.Group>
                            <DragDropContext onDragEnd={handleDragFoyerEnd}>
                              <Droppable droppableId="droppable-Foyer">
                                {(provided) => (
                                  <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {filteredDataField
                                      .map((item, index) => ({ item, formData: (foyerFormData && foyerFormData[index]) || {}, index }))
                                      .filter(({ item }) => {
                                        const searchQuery = search.toLowerCase();
                                        return searchQuery === '' || item.name?.toLowerCase().includes(searchQuery);
                                      })
                                      .map(({ item, formData, index }) => {
                                        console.log("ssss item:", item);
                                        console.log("ssss foyerFormData:", foyerFormData);
                                        console.log("ssss foyerFormData:", filteredDataField);
                                        console.log("ssss formData:", formData);
                                        console.log("ssss index:", index);
                                        return (
                                          <Draggable
                                            key={item.id || `temp-${index}`}
                                            draggableId={getDraggableId(item, index)}
                                            index={index}>
                                            {(provided) => (
                                              <div className={isItemFilled(formData) ? "selected-row-container" : ""} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                {
                                                  item.measurement == "area" ?
                                                    <Row className="hover-row">
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={foyerFormData[index].value}
                              onChange={(e) => handleFoyerOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData?.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => {
                                                              const childList = item2.subMaterials;
                                                              const hasChild = childList && childList.length > 0;

                                                              return (
                                                                <div
                                                                  key={index2}
                                                                  style={{ position: "relative" }}
                                                                  onMouseEnter={() => setHoveredItem(item2.label)}
                                                                  onMouseLeave={() => setHoveredItem(null)}
                                                                >
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!hasChild) {
                                                                        handleFoyerOptionChange(
                                                                          {
                                                                            target: {
                                                                              value:
                                                                                data.priceType === "oldvalue"
                                                                                  ? item2.oldvalue
                                                                                  : item2.value,
                                                                              label: item2.label,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }
                                                                    }}
                                                                    style={{
                                                                      display: "flex",
                                                                      justifyContent: "space-between",
                                                                    }}
                                                                  >
                                                                    {item2.label}
                                                                    {hasChild && <span>▶</span>}
                                                                  </Dropdown.Item>

                                                                  {/* ✅ Child Dropdown */}
                                                                  {hasChild && hoveredItem === item2.label && (
                                                                    <div
                                                                      style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: "100%",
                                                                        background: "white",
                                                                        border: "1px solid #ddd",
                                                                        minWidth: "180px",
                                                                        zIndex: 1050,
                                                                      }}
                                                                    >
                                                                      {item2.subMaterials.map((child, childIndex) => (
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            handleFoyerOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                  // value: child.subValue,
                                                                                  label: `${item2.label} (${child.subLabel})`,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }}
                                                                        >
                                                                          {child.subLabel}
                                                                        </Dropdown.Item>
                                                                      ))}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              );
                                                            })}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item, 'kitchen', index);
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.area === 0 ? "" : formData.area}
                                                            onChange={(e) => handleFoyerChange(e, index, "area")}
                                                            placeholder="Area"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.price}
                                                            // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={formData.value ? false : true}
                                                    readOnly
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={formData.remark}
                                                            onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      {renderRowActions(item, index)}
                                                    </Row>
                                                    : item.measurement == "width" ?
                                                      <Row className="hover-row">
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={foyerFormData[index].value}
                              onChange={(e) => handleFoyerOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                        <Col sm={2} style={{ display: 'flex' }}>
                                                          <Dropdown>
                                                            <Dropdown.Toggle
                                                              variant="outline-secondary"
                                                              style={{
                                                                width: '12vw',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                whiteSpace: 'normal',        // Allows text to wrap
                                                                wordBreak: 'break-word',     // Breaks long words
                                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                              }}>
                                                              {formData?.label || 'None'}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                                              <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                None
                                                              </Dropdown.Item>
                                                              {item.material.map((item2, index2) => {
                                                                const childList = item2.subMaterials;
                                                                const hasChild = childList && childList.length > 0;

                                                                return (
                                                                  <div
                                                                    key={index2}
                                                                    style={{ position: "relative" }}
                                                                    onMouseEnter={() => setHoveredItem(item2.label)}
                                                                    onMouseLeave={() => setHoveredItem(null)}
                                                                  >
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        if (!hasChild) {
                                                                          handleFoyerOptionChange(
                                                                            {
                                                                              target: {
                                                                                value:
                                                                                  data.priceType === "oldvalue"
                                                                                    ? item2.oldvalue
                                                                                    : item2.value,
                                                                                label: item2.label,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }
                                                                      }}
                                                                      style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                      }}
                                                                    >
                                                                      {item2.label}
                                                                      {hasChild && <span>▶</span>}
                                                                    </Dropdown.Item>

                                                                    {/* ✅ Child Dropdown */}
                                                                    {hasChild && hoveredItem === item2.label && (
                                                                      <div
                                                                        style={{
                                                                          position: "absolute",
                                                                          top: 0,
                                                                          left: "100%",
                                                                          background: "white",
                                                                          border: "1px solid #ddd",
                                                                          minWidth: "180px",
                                                                          zIndex: 1050,
                                                                        }}
                                                                      >
                                                                        {item2.subMaterials.map((child, childIndex) => (
                                                                          <Dropdown.Item
                                                                            onClick={() => {
                                                                              handleFoyerOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                    // value: child.subValue,
                                                                                    label: `${item2.label} (${child.subLabel})`,
                                                                                  },
                                                                                },
                                                                                index
                                                                              );
                                                                            }}
                                                                          >
                                                                            {child.subLabel}
                                                                          </Dropdown.Item>
                                                                        ))}
                                                                      </div>
                                                                    )}
                                                                  </div>
                                                                );
                                                              })}

                                                              <Dropdown.Divider />

                                                              <div className="px-3 py-2">
                                                                <Button
                                                                  variant="outline-success"
                                                                  size="sm"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation(); // prevent dropdown from closing
                                                                    handleAddNewItem(item, 'kitchen', index);
                                                                  }}
                                                                >
                                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                </Button>
                                                              </div>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                        </Col>
                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.width === 0 ? "" : formData.width}
                                                              onChange={(e) => handleFoyerChange(e, index, "width")}
                                                              placeholder="Width"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.height === 0 ? "" : formData.height}
                                                              onChange={(e) => handleFoyerChange(e, index, "height")}
                                                              placeholder="Height"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.qnty === 0 ? "" : formData.qnty}
                                                              onChange={(e) => handleFoyerChange(e, index, "qnty")}
                                                              placeholder="Qty"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.price}
                                                              // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={formData.value ? false : true}
                                                    readOnly
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={formData.remark}
                                                              onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        {renderRowActions(item, index)}
                                                      </Row>
                                                      : item.measurement == "qty" ?
                                                        <Row className="hover-row">
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Label
                                                                style={{
                                                                  fontSize: 16,
                                                                  fontWeight: "500",
                                                                }}
                                                              ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                              </Form.Label>
                                                            </Form.Group>
                                                          </Col>
                                                          {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={foyerFormData[index].value}
                              onChange={(e) => handleFoyerOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                          <Col sm={2} style={{ display: 'flex' }}>
                                                            <Dropdown>
                                                              <Dropdown.Toggle
                                                                variant="outline-secondary"
                                                                style={{
                                                                  width: '12vw',
                                                                  backgroundColor: 'white',
                                                                  color: 'black',
                                                                  display: 'flex',
                                                                  justifyContent: 'space-between',
                                                                  alignItems: 'center',
                                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                                  wordBreak: 'break-word',     // Breaks long words
                                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                }}>
                                                                {formData?.label || 'None'}
                                                              </Dropdown.Toggle>
                                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                                <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                  None
                                                                </Dropdown.Item>
                                                                {item.material.map((item2, index2) => {
                                                                  const childList = item2.subMaterials;
                                                                  const hasChild = childList && childList.length > 0;

                                                                  return (
                                                                    <div
                                                                      key={index2}
                                                                      style={{ position: "relative" }}
                                                                      onMouseEnter={() => setHoveredItem(item2.label)}
                                                                      onMouseLeave={() => setHoveredItem(null)}
                                                                    >
                                                                      <Dropdown.Item
                                                                        onClick={() => {
                                                                          if (!hasChild) {
                                                                            handleFoyerOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value:
                                                                                    data.priceType === "oldvalue"
                                                                                      ? item2.oldvalue
                                                                                      : item2.value,
                                                                                  label: item2.label,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }
                                                                        }}
                                                                        style={{
                                                                          display: "flex",
                                                                          justifyContent: "space-between",
                                                                        }}
                                                                      >
                                                                        {item2.label}
                                                                        {hasChild && <span>▶</span>}
                                                                      </Dropdown.Item>

                                                                      {/* ✅ Child Dropdown */}
                                                                      {hasChild && hoveredItem === item2.label && (
                                                                        <div
                                                                          style={{
                                                                            position: "absolute",
                                                                            top: 0,
                                                                            left: "100%",
                                                                            background: "white",
                                                                            border: "1px solid #ddd",
                                                                            minWidth: "180px",
                                                                            zIndex: 1050,
                                                                          }}
                                                                        >
                                                                          {item2.subMaterials.map((child, childIndex) => (
                                                                            <Dropdown.Item
                                                                              onClick={() => {
                                                                                handleFoyerOptionChange(
                                                                                  {
                                                                                    target: {
                                                                                      value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                      // value: child.subValue,
                                                                                      label: `${item2.label} (${child.subLabel})`,
                                                                                    },
                                                                                  },
                                                                                  index
                                                                                );
                                                                              }}
                                                                            >
                                                                              {child.subLabel}
                                                                            </Dropdown.Item>
                                                                          ))}
                                                                        </div>
                                                                      )}
                                                                    </div>
                                                                  );
                                                                })}

                                                                <Dropdown.Divider />

                                                                <div className="px-3 py-2">
                                                                  <Button
                                                                    variant="outline-success"
                                                                    size="sm"
                                                                    onClick={(e) => {
                                                                      e.stopPropagation(); // prevent dropdown from closing
                                                                      handleAddNewItem(item, 'kitchen', index);
                                                                    }}
                                                                  >
                                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                  </Button>
                                                                </div>
                                                              </Dropdown.Menu>
                                                            </Dropdown>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.qnty === 0 ? "" : formData.qnty}
                                                                onChange={(e) => handleFoyerChange(e, index, "qnty")}
                                                                placeholder="Qty"
                                                              />
                                                            </Form.Group>
                                                          </Col>

                                                          <Col sm={1}>

                                                          </Col>

                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.price}
                                                                // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                                placeholder="Price"
                                                                disabled={formData.value ? false : true}
                                                    readOnly
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                value={formData.remark}
                                                                onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                                as="textarea" rows={1}
                                                                placeholder="Remark"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          {renderRowActions(item, index)}
                                                        </Row>
                                                        : item.measurement == "length" ?
                                                          <Row className="hover-row">
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Label
                                                                  style={{
                                                                    fontSize: 16,
                                                                    fontWeight: "500",
                                                                  }}
                                                                ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                </Form.Label>
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={2} style={{ display: 'flex' }}>
                                                              <Dropdown>
                                                                <Dropdown.Toggle
                                                                  variant="outline-secondary"
                                                                  style={{
                                                                    width: '12vw',
                                                                    backgroundColor: 'white',
                                                                    color: 'black',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                                    wordBreak: 'break-word',     // Breaks long words
                                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                  }}>
                                                                  {formData?.label || 'None'}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                                  <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                    None
                                                                  </Dropdown.Item>
                                                                  {item.material.map((item2, index2) => {
                                                                    const childList = item2.subMaterials;
                                                                    const hasChild = childList && childList.length > 0;

                                                                    return (
                                                                      <div
                                                                        key={index2}
                                                                        style={{ position: "relative" }}
                                                                        onMouseEnter={() => setHoveredItem(item2.label)}
                                                                        onMouseLeave={() => setHoveredItem(null)}
                                                                      >
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            if (!hasChild) {
                                                                              handleFoyerOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value:
                                                                                      data.priceType === "oldvalue"
                                                                                        ? item2.oldvalue
                                                                                        : item2.value,
                                                                                    label: item2.label,
                                                                                  },
                                                                                },
                                                                                index
                                                                              );
                                                                            }
                                                                          }}
                                                                          style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                          }}
                                                                        >
                                                                          {item2.label}
                                                                          {hasChild && <span>▶</span>}
                                                                        </Dropdown.Item>

                                                                        {/* ✅ Child Dropdown */}
                                                                        {hasChild && hoveredItem === item2.label && (
                                                                          <div
                                                                            style={{
                                                                              position: "absolute",
                                                                              top: 0,
                                                                              left: "100%",
                                                                              background: "white",
                                                                              border: "1px solid #ddd",
                                                                              minWidth: "180px",
                                                                              zIndex: 1050,
                                                                            }}
                                                                          >
                                                                            {item2.subMaterials.map((child, childIndex) => (
                                                                              <Dropdown.Item
                                                                                onClick={() => {
                                                                                  handleFoyerOptionChange(
                                                                                    {
                                                                                      target: {
                                                                                        value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                        // value: child.subValue,
                                                                                        label: `${item2.label} (${child.subLabel})`,
                                                                                      },
                                                                                    },
                                                                                    index
                                                                                  );
                                                                                }}
                                                                              >
                                                                                {child.subLabel}
                                                                              </Dropdown.Item>
                                                                            ))}
                                                                          </div>
                                                                        )}
                                                                      </div>
                                                                    );
                                                                  })}

                                                                  <Dropdown.Divider />

                                                                  <div className="px-3 py-2">
                                                                    <Button
                                                                      variant="outline-success"
                                                                      size="sm"
                                                                      onClick={(e) => {
                                                                        e.stopPropagation(); // prevent dropdown from closing
                                                                        handleAddNewItem(item, 'kitchen', index);
                                                                      }}
                                                                    >
                                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                    </Button>
                                                                  </div>
                                                                </Dropdown.Menu>
                                                              </Dropdown>
                                                            </Col>
                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.height === 0 ? "" : formData.height}
                                                                  onChange={(e) => handleFoyerChange(e, index, "height")}
                                                                  placeholder="Length"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.width === 0 ? "" : formData.width}
                                                                  onChange={(e) => handleFoyerChange(e, index, "width")}
                                                                  placeholder="Width"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={1}>

                                                            </Col>

                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.price}
                                                                  // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                                  placeholder="Price"
                                                                  disabled={formData.value ? false : true}
                                                    readOnly
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  value={formData.remark}
                                                                  onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                                  as="textarea" rows={1}
                                                                  placeholder="Remark"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            {renderRowActions(item, index)}
                                                          </Row> : item.measurement == "rft" ?
                                                            <Row className="hover-row">
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Label
                                                                    style={{
                                                                      fontSize: 16,
                                                                      fontWeight: "500",
                                                                    }}
                                                                  ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                  </Form.Label>
                                                                </Form.Group>
                                                              </Col>
                                                              {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={foyerFormData[index].value}
                              onChange={(e) => handleFoyerOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                              <Col sm={2} style={{ display: 'flex' }}>
                                                                <Dropdown>
                                                                  <Dropdown.Toggle
                                                                    variant="outline-secondary"
                                                                    style={{
                                                                      width: '12vw',
                                                                      backgroundColor: 'white',
                                                                      color: 'black',
                                                                      display: 'flex',
                                                                      justifyContent: 'space-between',
                                                                      alignItems: 'center',
                                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                                      wordBreak: 'break-word',     // Breaks long words
                                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                    }}>
                                                                    {formData?.label || 'None'}
                                                                  </Dropdown.Toggle>
                                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                                    <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                      None
                                                                    </Dropdown.Item>
                                                                    {item.material.map((item2, index2) => {
                                                                      const childList = item2.subMaterials;
                                                                      const hasChild = childList && childList.length > 0;

                                                                      return (
                                                                        <div
                                                                          key={index2}
                                                                          style={{ position: "relative" }}
                                                                          onMouseEnter={() => setHoveredItem(item2.label)}
                                                                          onMouseLeave={() => setHoveredItem(null)}
                                                                        >
                                                                          <Dropdown.Item
                                                                            onClick={() => {
                                                                              if (!hasChild) {
                                                                                handleFoyerOptionChange(
                                                                                  {
                                                                                    target: {
                                                                                      value:
                                                                                        data.priceType === "oldvalue"
                                                                                          ? item2.oldvalue
                                                                                          : item2.value,
                                                                                      label: item2.label,
                                                                                    },
                                                                                  },
                                                                                  index
                                                                                );
                                                                              }
                                                                            }}
                                                                            style={{
                                                                              display: "flex",
                                                                              justifyContent: "space-between",
                                                                            }}
                                                                          >
                                                                            {item2.label}
                                                                            {hasChild && <span>▶</span>}
                                                                          </Dropdown.Item>

                                                                          {/* ✅ Child Dropdown */}
                                                                          {hasChild && hoveredItem === item2.label && (
                                                                            <div
                                                                              style={{
                                                                                position: "absolute",
                                                                                top: 0,
                                                                                left: "100%",
                                                                                background: "white",
                                                                                border: "1px solid #ddd",
                                                                                minWidth: "180px",
                                                                                zIndex: 1050,
                                                                              }}
                                                                            >
                                                                              {item2.subMaterials.map((child, childIndex) => (
                                                                                <Dropdown.Item
                                                                                  onClick={() => {
                                                                                    handleFoyerOptionChange(
                                                                                      {
                                                                                        target: {
                                                                                          value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                          // value: child.subValue,
                                                                                          label: `${item2.label} (${child.subLabel})`,
                                                                                        },
                                                                                      },
                                                                                      index
                                                                                    );
                                                                                  }}
                                                                                >
                                                                                  {child.subLabel}
                                                                                </Dropdown.Item>
                                                                              ))}
                                                                            </div>
                                                                          )}
                                                                        </div>
                                                                      );
                                                                    })}

                                                                    <Dropdown.Divider />

                                                                    <div className="px-3 py-2">
                                                                      <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation(); // prevent dropdown from closing
                                                                          handleAddNewItem(item, 'kitchen', index);
                                                                        }}
                                                                      >
                                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                      </Button>
                                                                    </div>
                                                                  </Dropdown.Menu>
                                                                </Dropdown>
                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={formData.rft === 0 ? "" : formData.rft}
                                                                    onChange={(e) => handleFoyerChange(e, index, "rft")}
                                                                    placeholder="RFT"
                                                                  />
                                                                </Form.Group>
                                                              </Col>

                                                              <Col sm={1}>

                                                              </Col>

                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={formData.price}
                                                                    // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                                    placeholder="Price"
                                                                    disabled={formData.value ? false : true}
                                                    readOnly
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    value={formData.remark}
                                                                    onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                                    as="textarea" rows={1}
                                                                    placeholder="Remark"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              {renderRowActions(item, index)}
                                                            </Row> : item.measurement == "selection" ?
                                                              <Row className="hover-row">
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Label
                                                                      style={{
                                                                        fontSize: 16,
                                                                        fontWeight: "500",
                                                                      }}
                                                                    ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                    </Form.Label>
                                                                  </Form.Group>
                                                                </Col>
                                                                {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                                {/* add label option */}
                                                                <Col sm={2} style={{ display: 'flex' }}>
                                                                  <Dropdown>
                                                                    <Dropdown.Toggle
                                                                      variant="outline-secondary"
                                                                      style={{
                                                                        width: '12vw',
                                                                        backgroundColor: 'white',
                                                                        color: 'black',
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center',
                                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                                        wordBreak: 'break-word',     // Breaks long words
                                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                      }}>
                                                                      {formData?.label || 'None'}
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                                      <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                        None
                                                                      </Dropdown.Item>
                                                                      {item.material.map((item2, index2) => {
                                                                        const childList = item2.subMaterials;
                                                                        const hasChild = childList && childList.length > 0;

                                                                        return (
                                                                          <div
                                                                            key={index2}
                                                                            style={{ position: "relative" }}
                                                                            onMouseEnter={() => setHoveredItem(item2.label)}
                                                                            onMouseLeave={() => setHoveredItem(null)}
                                                                          >
                                                                            <Dropdown.Item
                                                                              onClick={() => {
                                                                                if (!hasChild) {
                                                                                  handleFoyerOptionChange(
                                                                                    {
                                                                                      target: {
                                                                                        value:
                                                                                          data.priceType === "oldvalue"
                                                                                            ? item2.oldvalue
                                                                                            : item2.value,
                                                                                        label: item2.label,
                                                                                      },
                                                                                    },
                                                                                    index
                                                                                  );
                                                                                }
                                                                              }}
                                                                              style={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                              }}
                                                                            >
                                                                              {item2.label}
                                                                              {hasChild && <span>▶</span>}
                                                                            </Dropdown.Item>

                                                                            {/* ✅ Child Dropdown */}
                                                                            {hasChild && hoveredItem === item2.label && (
                                                                              <div
                                                                                style={{
                                                                                  position: "absolute",
                                                                                  top: 0,
                                                                                  left: "100%",
                                                                                  background: "white",
                                                                                  border: "1px solid #ddd",
                                                                                  minWidth: "180px",
                                                                                  zIndex: 1050,
                                                                                }}
                                                                              >
                                                                                {item2.subMaterials.map((child, childIndex) => (
                                                                                  <Dropdown.Item
                                                                                    onClick={() => {
                                                                                      handleFoyerOptionChange(
                                                                                        {
                                                                                          target: {
                                                                                            value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                            // value: child.subValue,
                                                                                            label: `${item2.label} (${child.subLabel})`,
                                                                                          },
                                                                                        },
                                                                                        index
                                                                                      );
                                                                                    }}
                                                                                  >
                                                                                    {child.subLabel}
                                                                                  </Dropdown.Item>
                                                                                ))}
                                                                              </div>
                                                                            )}
                                                                          </div>
                                                                        );
                                                                      })}

                                                                      <Dropdown.Divider />

                                                                      <div className="px-3 py-2">
                                                                        <Button
                                                                          variant="outline-success"
                                                                          size="sm"
                                                                          onClick={(e) => {
                                                                            e.stopPropagation(); // prevent dropdown from closing
                                                                            handleAddNewItem(item, 'kitchen', index);
                                                                          }}
                                                                        >
                                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                        </Button>
                                                                      </div>
                                                                    </Dropdown.Menu>
                                                                  </Dropdown>
                                                                </Col>
                                                                <Col sm={2}>

                                                                </Col>

                                                                <Col sm={1}>

                                                                </Col>

                                                                <Col sm={2}>

                                                                </Col>
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      value={formData.remark}
                                                                      onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                                      as="textarea" rows={1}
                                                                      placeholder="Remark"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                {renderRowActions(item, index)}
                                                              </Row> : item.measurement == "depth" ?
                                                                <Row className="hover-row">
                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Label
                                                                        style={{
                                                                          fontSize: 16,
                                                                          fontWeight: "500",
                                                                        }}
                                                                      ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                      </Form.Label>
                                                                    </Form.Group>
                                                                  </Col>

                                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                                    <Dropdown>
                                                                      <Dropdown.Toggle
                                                                        variant="outline-secondary"
                                                                        style={{
                                                                          width: '12vw',
                                                                          backgroundColor: 'white',
                                                                          color: 'black',
                                                                          display: 'flex',
                                                                          justifyContent: 'space-between',
                                                                          alignItems: 'center',
                                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                                          wordBreak: 'break-word',     // Breaks long words
                                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                        }}>
                                                                        {formData?.label || 'None'}
                                                                      </Dropdown.Toggle>
                                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                                        <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                          None
                                                                        </Dropdown.Item>
                                                                        {item.material.map((item2, index2) => {
                                                                          const childList = item2.subMaterials;
                                                                          const hasChild = childList && childList.length > 0;

                                                                          return (
                                                                            <div
                                                                              key={index2}
                                                                              style={{ position: "relative" }}
                                                                              onMouseEnter={() => setHoveredItem(item2.label)}
                                                                              onMouseLeave={() => setHoveredItem(null)}
                                                                            >
                                                                              <Dropdown.Item
                                                                                onClick={() => {
                                                                                  if (!hasChild) {
                                                                                    handleFoyerOptionChange(
                                                                                      {
                                                                                        target: {
                                                                                          value:
                                                                                            data.priceType === "oldvalue"
                                                                                              ? item2.oldvalue
                                                                                              : item2.value,
                                                                                          label: item2.label,
                                                                                        },
                                                                                      },
                                                                                      index
                                                                                    );
                                                                                  }
                                                                                }}
                                                                                style={{
                                                                                  display: "flex",
                                                                                  justifyContent: "space-between",
                                                                                }}
                                                                              >
                                                                                {item2.label}
                                                                                {hasChild && <span>▶</span>}
                                                                              </Dropdown.Item>

                                                                              {/* ✅ Child Dropdown */}
                                                                              {hasChild && hoveredItem === item2.label && (
                                                                                <div
                                                                                  style={{
                                                                                    position: "absolute",
                                                                                    top: 0,
                                                                                    left: "100%",
                                                                                    background: "white",
                                                                                    border: "1px solid #ddd",
                                                                                    minWidth: "180px",
                                                                                    zIndex: 1050,
                                                                                  }}
                                                                                >
                                                                                  {item2.subMaterials.map((child, childIndex) => (
                                                                                    <Dropdown.Item
                                                                                      onClick={() => {
                                                                                        handleFoyerOptionChange(
                                                                                          {
                                                                                            target: {
                                                                                              value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                              // value: child.subValue,
                                                                                              label: `${item2.label} (${child.subLabel})`,
                                                                                            },
                                                                                          },
                                                                                          index
                                                                                        );
                                                                                      }}
                                                                                    >
                                                                                      {child.subLabel}
                                                                                    </Dropdown.Item>
                                                                                  ))}
                                                                                </div>
                                                                              )}
                                                                            </div>
                                                                          );
                                                                        })}

                                                                        <Dropdown.Divider />

                                                                        <div className="px-3 py-2">
                                                                          <Button
                                                                            variant="outline-success"
                                                                            size="sm"
                                                                            onClick={(e) => {
                                                                              e.stopPropagation(); // prevent dropdown from closing
                                                                              handleAddNewItem(item, 'kitchen', index);
                                                                            }}
                                                                          >
                                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                          </Button>
                                                                        </div>
                                                                      </Dropdown.Menu>
                                                                    </Dropdown>
                                                                  </Col>
                                                                  <Col sm={1}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.width === 0 ? "" : formData.width}
                                                                        onChange={(e) => handleFoyerChange(e, index, "width")}
                                                                        placeholder="Length"
                                                                      />
                                                                    </Form.Group>

                                                                  </Col>
                                                                  <Col sm={1}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.height === 0 ? "" : formData.height}
                                                                        onChange={(e) => handleFoyerChange(e, index, "height")}
                                                                        placeholder="Height"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>

                                                                  <Col sm={1}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.depth === 0 ? "" : formData.depth}
                                                                        onChange={(e) => handleFoyerChange(e, index, "depth")}
                                                                        placeholder="Depth"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>

                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.price}
                                                                        // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                                        placeholder="Price"
                                                                        disabled={formData.value ? false : true}
                                                    readOnly
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>
                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        value={formData.remark}
                                                                        onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                                        as="textarea" rows={1}
                                                                        placeholder="Remark"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>
                                                                  {renderRowActions(item, index)}
                                                                </Row> : null
                                                }

                                              </div>
                                            )}
                                          </Draggable>

                                        )
                                      })}
                                    {provided.placeholder}

                                  </div>
                                )}
                              </Droppable>
                            </DragDropContext>

                            <Row>
                              <Col>

                                <Row className="mx-1 my-3">
                                  <Col sm={2}>
                                    <Form.Group >
                                      <Form.Control
                                        value={extraItemName}
                                        onChange={(e) => setExtraItemName(e.target.value)}
                                        type="text"
                                        placeholder="Item Name"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col sm={2}>
                                    <Form.Group >
                                      <Form.Control
                                        value={extraItemMaterialName}
                                        onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                        type="text"
                                        placeholder="Material Name"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col sm={2}>
                                    <Form.Group >
                                      <Form.Control
                                        value={extraItemMaterialValue}
                                        onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                        type="number"
                                        placeholder="Material Value"
                                      />
                                    </Form.Group>
                                  </Col>

                                  <Col sm={3}>
                                    <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                      <option>Select Measurement Type</option>
                                      <option value="area">Area</option>
                                      <option value="width">Width &  Height</option>
                                      <option value="rft">RFT</option>
                                      <option value="qty">Quantity</option>
                                      <option value="length">Width & Length</option>
                                      <option value="selection">Selection</option>
                                    </Form.Select>
                                  </Col>
                                  <Col sm={1}>
                                    <Form.Check
                                      inline
                                      label="Wood"
                                      name="Wood"
                                      type="checkbox"
                                      id="inline-checkbox-1"
                                      checked={isChecked}
                                      onChange={handleCheckboxChange}
                                    />
                                  </Col>

                                  <Col sm={2}>
                                    <Button onClick={addNewFoyerItem}>Add Item</Button>
                                  </Col>
                                </Row>





                              </Col>

                            </Row>
                          </Form.Group>


                        </Form>
                      </Col>
                    </Row>



                    <Row style={{
                      // marginBottom: '50px',
                      marginLeft: '1px',
                      padding: '20px',
                      borderRadius: '15px',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                      backgroundColor: '#ffffff', // Light background color


                    }} >
                      <Col >
                        <Button className="buttonDesign" style={{ fontSize: 13, width: '20vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveFoyerData()} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                      </Col>
                      <Col className="col-sm-3">

                      </Col>
                      <Col className="col-sm-2"><h4>Total Price</h4></Col>
                      <Col className="col-sm-2">
                        {/* <h4>
                                        Rs:- {roomTypePrice}
                
                                      </h4> */}
                        <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{calculateFoyerTotal()}</h4></span>
                      </Col>
                    </Row>

                  </Row> : roomTypeModal == 'Living Room' ?
                    <Row
                      style={{
                        // marginBottom: '50px',
                        // height:'auto',

                        padding: '20px',
                        // marginLeft: '20px',
                        borderRadius: '15px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                        backgroundColor: '#ffff', // Light background color

                      }} >
                      <div style={{
                        display: "flex",
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderRadius: '15px',
                        padding: '0.5rem'
                      }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>living -- </h5><h6 style={{ color: '#e85d13' }}>{data.priceType === 'value' ? 'New Value' : 'Old Value'}</h6></span>
                        <Form>
                          <InputGroup>
                            <Form.Control
                              style={{
                                borderRadius: "15px",
                                padding: "12px 15px",
                                border: "1px solid #d1d5db",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                transition: "all 0.3s ease",
                                width: "20vw",
                              }}
                              onChange={(e) => setSearch(e.target.value)}
                              placeholder="Search Projects"
                            />
                          </InputGroup>
                        </Form>
                      </div>


                      <Row style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>
                        <Col style={{ minHeight: 380, maxHeight: 480 }}>

                          <Form>

                            <Form.Group>
                              <DragDropContext onDragEnd={handleDragLivingEnd}>
                                <Droppable droppableId="droppable-living">
                                  {(provided) => (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                      {filteredDataField
                                        .map((item, index) => ({ item, formData: (livingFormData && livingFormData[index]) || {}, index }))
                                        .filter(({ item }) => {
                                          const searchQuery = search.toLowerCase();
                                          return searchQuery === '' || item.name?.toLowerCase().includes(searchQuery);
                                        })
                                        .map(({ item, formData, index }) => (
                                          <Draggable key={item.id || `temp-${index}`}
                                            draggableId={getDraggableId(item, index)}
                                            index={index}>
                                            {(provided) => (
                                              <div className={isItemFilled(formData) ? "selected-row-container" : ""} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                {
                                                  item.measurement == "area" ?
                                                    <Row className="hover-row">
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData?.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => {
                                                              const childList = item2.subMaterials;
                                                              const hasChild = childList && childList.length > 0;

                                                              return (
                                                                <div
                                                                  key={index2}
                                                                  style={{ position: "relative" }}
                                                                  onMouseEnter={() => setHoveredItem(item2.label)}
                                                                  onMouseLeave={() => setHoveredItem(null)}
                                                                >
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!hasChild) {
                                                                        handleLivingOptionChange(
                                                                          {
                                                                            target: {
                                                                              value:
                                                                                data.priceType === "oldvalue"
                                                                                  ? item2.oldvalue
                                                                                  : item2.value,
                                                                              label: item2.label,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }
                                                                    }}
                                                                    style={{
                                                                      display: "flex",
                                                                      justifyContent: "space-between",
                                                                    }}
                                                                  >
                                                                    {item2.label}
                                                                    {hasChild && <span>▶</span>}
                                                                  </Dropdown.Item>

                                                                  {/* ✅ Child Dropdown */}
                                                                  {hasChild && hoveredItem === item2.label && (
                                                                    <div
                                                                      style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: "100%",
                                                                        background: "white",
                                                                        border: "1px solid #ddd",
                                                                        minWidth: "180px",
                                                                        zIndex: 1050,
                                                                      }}
                                                                    >
                                                                      {item2.subMaterials.map((child, childIndex) => (
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            handleLivingOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                  // value: child.subValue,
                                                                                  label: `${item2.label} (${child.subLabel})`,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }}
                                                                        >
                                                                          {child.subLabel}
                                                                        </Dropdown.Item>
                                                                      ))}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              );
                                                            })}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item, 'kitchen', index);
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.area === 0 ? "" : formData.area}
                                                            onChange={(e) => handleLivingChange(e, index, "area")}
                                                            placeholder="Area"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.price}
                                                            // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={livingFormData[index].value ? false : true}
                                                    readOnly
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={formData.remark}
                                                            onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      {renderRowActions(item, index)}
                                                    </Row>
                                                    : item.measurement == "width" ?
                                                      <Row className="hover-row">
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={livingFormData[index].value}
                              onChange={(e) => handleLivingOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                        <Col sm={2} style={{ display: 'flex' }}>
                                                          <Dropdown>
                                                            <Dropdown.Toggle
                                                              variant="outline-secondary"
                                                              style={{
                                                                width: '12vw',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                whiteSpace: 'normal',        // Allows text to wrap
                                                                wordBreak: 'break-word',     // Breaks long words
                                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                              }}>
                                                              {formData?.label || 'None'}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                                              <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                None
                                                              </Dropdown.Item>
                                                              {item.material.map((item2, index2) => {
                                                                const childList = item2.subMaterials;
                                                                const hasChild = childList && childList.length > 0;

                                                                return (
                                                                  <div
                                                                    key={index2}
                                                                    style={{ position: "relative" }}
                                                                    onMouseEnter={() => setHoveredItem(item2.label)}
                                                                    onMouseLeave={() => setHoveredItem(null)}
                                                                  >
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        if (!hasChild) {
                                                                          handleLivingOptionChange(
                                                                            {
                                                                              target: {
                                                                                value:
                                                                                  data.priceType === "oldvalue"
                                                                                    ? item2.oldvalue
                                                                                    : item2.value,
                                                                                label: item2.label,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }
                                                                      }}
                                                                      style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                      }}
                                                                    >
                                                                      {item2.label}
                                                                      {hasChild && <span>▶</span>}
                                                                    </Dropdown.Item>

                                                                    {/* ✅ Child Dropdown */}
                                                                    {hasChild && hoveredItem === item2.label && (
                                                                      <div
                                                                        style={{
                                                                          position: "absolute",
                                                                          top: 0,
                                                                          left: "100%",
                                                                          background: "white",
                                                                          border: "1px solid #ddd",
                                                                          minWidth: "180px",
                                                                          zIndex: 1050,
                                                                        }}
                                                                      >
                                                                        {item2.subMaterials.map((child, childIndex) => (
                                                                          <Dropdown.Item
                                                                            onClick={() => {
                                                                              handleLivingOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                    // value: child.subValue,
                                                                                    label: `${item2.label} (${child.subLabel})`,
                                                                                  },
                                                                                },
                                                                                index
                                                                              );
                                                                            }}
                                                                          >
                                                                            {child.subLabel}
                                                                          </Dropdown.Item>
                                                                        ))}
                                                                      </div>
                                                                    )}
                                                                  </div>
                                                                );
                                                              })}

                                                              <Dropdown.Divider />

                                                              <div className="px-3 py-2">
                                                                <Button
                                                                  variant="outline-success"
                                                                  size="sm"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation(); // prevent dropdown from closing
                                                                    handleAddNewItem(item, 'kitchen', index);
                                                                  }}
                                                                >
                                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                </Button>
                                                              </div>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                        </Col>
                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.width === 0 ? "" : formData.width}
                                                              onChange={(e) => handleLivingChange(e, index, "width")}
                                                              placeholder="Width"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.height === 0 ? "" : formData.height}
                                                              onChange={(e) => handleLivingChange(e, index, "height")}
                                                              placeholder="Height"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.qnty === 0 ? "" : formData.qnty}
                                                              onChange={(e) => handleLivingChange(e, index, "qnty")}
                                                              placeholder="Qty"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.price}
                                                              // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={livingFormData[index].value ? false : true}
                                                    readOnly
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={formData.remark}
                                                              onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        {renderRowActions(item, index)}
                                                      </Row>
                                                      : item.measurement == "qty" ?
                                                        <Row className="hover-row">
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Label
                                                                style={{
                                                                  fontSize: 16,
                                                                  fontWeight: "500",
                                                                }}
                                                              ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                              </Form.Label>
                                                            </Form.Group>
                                                          </Col>
                                                          {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={livingFormData[index].value}
                              onChange={(e) => handleLivingOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                          <Col sm={2} style={{ display: 'flex' }}>
                                                            <Dropdown>
                                                              <Dropdown.Toggle
                                                                variant="outline-secondary"
                                                                style={{
                                                                  width: '12vw',
                                                                  backgroundColor: 'white',
                                                                  color: 'black',
                                                                  display: 'flex',
                                                                  justifyContent: 'space-between',
                                                                  alignItems: 'center',
                                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                                  wordBreak: 'break-word',     // Breaks long words
                                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                }}>
                                                                {formData?.label || 'None'}
                                                              </Dropdown.Toggle>
                                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                                <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                  None
                                                                </Dropdown.Item>
                                                                {item.material.map((item2, index2) => {
                                                                  const childList = item2.subMaterials;
                                                                  const hasChild = childList && childList.length > 0;

                                                                  return (
                                                                    <div
                                                                      key={index2}
                                                                      style={{ position: "relative" }}
                                                                      onMouseEnter={() => setHoveredItem(item2.label)}
                                                                      onMouseLeave={() => setHoveredItem(null)}
                                                                    >
                                                                      <Dropdown.Item
                                                                        onClick={() => {
                                                                          if (!hasChild) {
                                                                            handleLivingOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value:
                                                                                    data.priceType === "oldvalue"
                                                                                      ? item2.oldvalue
                                                                                      : item2.value,
                                                                                  label: item2.label,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }
                                                                        }}
                                                                        style={{
                                                                          display: "flex",
                                                                          justifyContent: "space-between",
                                                                        }}
                                                                      >
                                                                        {item2.label}
                                                                        {hasChild && <span>▶</span>}
                                                                      </Dropdown.Item>

                                                                      {/* ✅ Child Dropdown */}
                                                                      {hasChild && hoveredItem === item2.label && (
                                                                        <div
                                                                          style={{
                                                                            position: "absolute",
                                                                            top: 0,
                                                                            left: "100%",
                                                                            background: "white",
                                                                            border: "1px solid #ddd",
                                                                            minWidth: "180px",
                                                                            zIndex: 1050,
                                                                          }}
                                                                        >
                                                                          {item2.subMaterials.map((child, childIndex) => (
                                                                            <Dropdown.Item
                                                                              onClick={() => {
                                                                                handleLivingOptionChange(
                                                                                  {
                                                                                    target: {
                                                                                      value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                      // value: child.subValue,
                                                                                      label: `${item2.label} (${child.subLabel})`,
                                                                                    },
                                                                                  },
                                                                                  index
                                                                                );
                                                                              }}
                                                                            >
                                                                              {child.subLabel}
                                                                            </Dropdown.Item>
                                                                          ))}
                                                                        </div>
                                                                      )}
                                                                    </div>
                                                                  );
                                                                })}

                                                                <Dropdown.Divider />

                                                                <div className="px-3 py-2">
                                                                  <Button
                                                                    variant="outline-success"
                                                                    size="sm"
                                                                    onClick={(e) => {
                                                                      e.stopPropagation(); // prevent dropdown from closing
                                                                      handleAddNewItem(item, 'kitchen', index);
                                                                    }}
                                                                  >
                                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                  </Button>
                                                                </div>
                                                              </Dropdown.Menu>
                                                            </Dropdown>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.qnty === 0 ? "" : formData.qnty}
                                                                onChange={(e) => handleLivingChange(e, index, "qnty")}
                                                                placeholder="Qty"
                                                              />
                                                            </Form.Group>
                                                          </Col>

                                                          <Col sm={1}>

                                                          </Col>

                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.price}
                                                                // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                                placeholder="Price"
                                                                disabled={livingFormData[index].value ? false : true}
                                                    readOnly
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                value={formData.remark}
                                                                onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                                as="textarea" rows={1}
                                                                placeholder="Remark"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          {renderRowActions(item, index)}
                                                        </Row>
                                                        : item.measurement == "length" ?
                                                          <Row className="hover-row">
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Label
                                                                  style={{
                                                                    fontSize: 16,
                                                                    fontWeight: "500",
                                                                  }}
                                                                ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                </Form.Label>
                                                              </Form.Group>
                                                            </Col>
                                                            {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={livingFormData[index].value}
                              onChange={(e) => handleLivingOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                            <Col sm={2} style={{ display: 'flex' }}>
                                                              <Dropdown>
                                                                <Dropdown.Toggle
                                                                  variant="outline-secondary"
                                                                  style={{
                                                                    width: '12vw',
                                                                    backgroundColor: 'white',
                                                                    color: 'black',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                                    wordBreak: 'break-word',     // Breaks long words
                                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                  }}>
                                                                  {formData?.label || 'None'}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                                  <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                    None
                                                                  </Dropdown.Item>
                                                                  {item.material.map((item2, index2) => {
                                                                    const childList = item2.subMaterials;
                                                                    const hasChild = childList && childList.length > 0;

                                                                    return (
                                                                      <div
                                                                        key={index2}
                                                                        style={{ position: "relative" }}
                                                                        onMouseEnter={() => setHoveredItem(item2.label)}
                                                                        onMouseLeave={() => setHoveredItem(null)}
                                                                      >
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            if (!hasChild) {
                                                                              handleLivingOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value:
                                                                                      data.priceType === "oldvalue"
                                                                                        ? item2.oldvalue
                                                                                        : item2.value,
                                                                                    label: item2.label,
                                                                                  },
                                                                                },
                                                                                index
                                                                              );
                                                                            }
                                                                          }}
                                                                          style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                          }}
                                                                        >
                                                                          {item2.label}
                                                                          {hasChild && <span>▶</span>}
                                                                        </Dropdown.Item>

                                                                        {/* ✅ Child Dropdown */}
                                                                        {hasChild && hoveredItem === item2.label && (
                                                                          <div
                                                                            style={{
                                                                              position: "absolute",
                                                                              top: 0,
                                                                              left: "100%",
                                                                              background: "white",
                                                                              border: "1px solid #ddd",
                                                                              minWidth: "180px",
                                                                              zIndex: 1050,
                                                                            }}
                                                                          >
                                                                            {item2.subMaterials.map((child, childIndex) => (
                                                                              <Dropdown.Item
                                                                                onClick={() => {
                                                                                  handleLivingOptionChange(
                                                                                    {
                                                                                      target: {
                                                                                        value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                        // value: child.subValue,
                                                                                        label: `${item2.label} (${child.subLabel})`,
                                                                                      },
                                                                                    },
                                                                                    index
                                                                                  );
                                                                                }}
                                                                              >
                                                                                {child.subLabel}
                                                                              </Dropdown.Item>
                                                                            ))}
                                                                          </div>
                                                                        )}
                                                                      </div>
                                                                    );
                                                                  })}

                                                                  <Dropdown.Divider />

                                                                  <div className="px-3 py-2">
                                                                    <Button
                                                                      variant="outline-success"
                                                                      size="sm"
                                                                      onClick={(e) => {
                                                                        e.stopPropagation(); // prevent dropdown from closing
                                                                        handleAddNewItem(item, 'kitchen', index);
                                                                      }}
                                                                    >
                                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                    </Button>
                                                                  </div>
                                                                </Dropdown.Menu>
                                                              </Dropdown>
                                                            </Col>
                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.height === 0 ? "" : formData.height}
                                                                  onChange={(e) => handleLivingChange(e, index, "height")}
                                                                  placeholder="Length"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.width === 0 ? "" : formData.width}
                                                                  onChange={(e) => handleLivingChange(e, index, "width")}
                                                                  placeholder="Width"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={1}>

                                                            </Col>

                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.price}
                                                                  // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                                  placeholder="Price"
                                                                  disabled={livingFormData[index].value ? false : true}
                                                    readOnly
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  value={formData.remark}
                                                                  onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                                  as="textarea" rows={1}
                                                                  placeholder="Remark"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            {renderRowActions(item, index)}
                                                          </Row> : item.measurement == "depth" ?
                                                            <Row className="hover-row">
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Label
                                                                    style={{
                                                                      fontSize: 16,
                                                                      fontWeight: "500",
                                                                    }}
                                                                  ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                  </Form.Label>
                                                                </Form.Group>
                                                              </Col>

                                                              <Col sm={2} style={{ display: 'flex' }}>
                                                                <Dropdown>
                                                                  <Dropdown.Toggle
                                                                    variant="outline-secondary"
                                                                    style={{
                                                                      width: '12vw',
                                                                      backgroundColor: 'white',
                                                                      color: 'black',
                                                                      display: 'flex',
                                                                      justifyContent: 'space-between',
                                                                      alignItems: 'center',
                                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                                      wordBreak: 'break-word',     // Breaks long words
                                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                    }}>
                                                                    {formData?.label || 'None'}
                                                                  </Dropdown.Toggle>
                                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                                    <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                      None
                                                                    </Dropdown.Item>
                                                                    {item.material.map((item2, index2) => {
                                                                      const childList = item2.subMaterials;
                                                                      const hasChild = childList && childList.length > 0;

                                                                      return (
                                                                        <div
                                                                          key={index2}
                                                                          style={{ position: "relative" }}
                                                                          onMouseEnter={() => setHoveredItem(item2.label)}
                                                                          onMouseLeave={() => setHoveredItem(null)}
                                                                        >
                                                                          <Dropdown.Item
                                                                            onClick={() => {
                                                                              if (!hasChild) {
                                                                                handleLivingOptionChange(
                                                                                  {
                                                                                    target: {
                                                                                      value:
                                                                                        data.priceType === "oldvalue"
                                                                                          ? item2.oldvalue
                                                                                          : item2.value,
                                                                                      label: item2.label,
                                                                                    },
                                                                                  },
                                                                                  index
                                                                                );
                                                                              }
                                                                            }}
                                                                            style={{
                                                                              display: "flex",
                                                                              justifyContent: "space-between",
                                                                            }}
                                                                          >
                                                                            {item2.label}
                                                                            {hasChild && <span>▶</span>}
                                                                          </Dropdown.Item>

                                                                          {/* ✅ Child Dropdown */}
                                                                          {hasChild && hoveredItem === item2.label && (
                                                                            <div
                                                                              style={{
                                                                                position: "absolute",
                                                                                top: 0,
                                                                                left: "100%",
                                                                                background: "white",
                                                                                border: "1px solid #ddd",
                                                                                minWidth: "180px",
                                                                                zIndex: 1050,
                                                                              }}
                                                                            >
                                                                              {item2.subMaterials.map((child, childIndex) => (
                                                                                <Dropdown.Item
                                                                                  onClick={() => {
                                                                                    handleLivingOptionChange(
                                                                                      {
                                                                                        target: {
                                                                                          value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                          // value: child.subValue,
                                                                                          label: `${item2.label} (${child.subLabel})`,
                                                                                        },
                                                                                      },
                                                                                      index
                                                                                    );
                                                                                  }}
                                                                                >
                                                                                  {child.subLabel}
                                                                                </Dropdown.Item>
                                                                              ))}
                                                                            </div>
                                                                          )}
                                                                        </div>
                                                                      );
                                                                    })}

                                                                    <Dropdown.Divider />

                                                                    <div className="px-3 py-2">
                                                                      <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation(); // prevent dropdown from closing
                                                                          handleAddNewItem(item, 'kitchen', index);
                                                                        }}
                                                                      >
                                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                      </Button>
                                                                    </div>
                                                                  </Dropdown.Menu>
                                                                </Dropdown>
                                                              </Col>
                                                              <Col sm={1}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={formData.width === 0 ? "" : formData.width}
                                                                    onChange={(e) => handleLivingChange(e, index, "width")}
                                                                    placeholder="Length"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={1}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={formData.height === 0 ? "" : formData.height}
                                                                    onChange={(e) => handleLivingChange(e, index, "height")}
                                                                    placeholder="Height"
                                                                  />
                                                                </Form.Group>
                                                              </Col>

                                                              <Col sm={1}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={formData.depth === 0 ? "" : formData.depth}
                                                                    onChange={(e) => handleLivingChange(e, index, "depth")}
                                                                    placeholder="Depth"
                                                                  />
                                                                </Form.Group>
                                                              </Col>

                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={formData.price}
                                                                    // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                                    placeholder="Price"
                                                                    disabled={livingFormData[index].value ? false : true}
                                                    readOnly
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    value={formData.remark}
                                                                    onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                                    as="textarea" rows={1}
                                                                    placeholder="Remark"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              {renderRowActions(item, index)}
                                                            </Row> : item.measurement == "rft" ?
                                                              <Row className="hover-row">
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Label
                                                                      style={{
                                                                        fontSize: 16,
                                                                        fontWeight: "500",
                                                                      }}
                                                                    ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                    </Form.Label>
                                                                  </Form.Group>
                                                                </Col>
                                                                {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={livingFormData[index].value}
                              onChange={(e) => handleLivingOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                                <Col sm={2} style={{ display: 'flex' }}>
                                                                  <Dropdown>
                                                                    <Dropdown.Toggle
                                                                      variant="outline-secondary"
                                                                      style={{
                                                                        width: '12vw',
                                                                        backgroundColor: 'white',
                                                                        color: 'black',
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center',
                                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                                        wordBreak: 'break-word',     // Breaks long words
                                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                      }}>
                                                                      {formData?.label || 'None'}
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                                      <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                        None
                                                                      </Dropdown.Item>
                                                                      {item.material.map((item2, index2) => {
                                                                        const childList = item2.subMaterials;
                                                                        const hasChild = childList && childList.length > 0;

                                                                        return (
                                                                          <div
                                                                            key={index2}
                                                                            style={{ position: "relative" }}
                                                                            onMouseEnter={() => setHoveredItem(item2.label)}
                                                                            onMouseLeave={() => setHoveredItem(null)}
                                                                          >
                                                                            <Dropdown.Item
                                                                              onClick={() => {
                                                                                if (!hasChild) {
                                                                                  handleLivingOptionChange(
                                                                                    {
                                                                                      target: {
                                                                                        value:
                                                                                          data.priceType === "oldvalue"
                                                                                            ? item2.oldvalue
                                                                                            : item2.value,
                                                                                        label: item2.label,
                                                                                      },
                                                                                    },
                                                                                    index
                                                                                  );
                                                                                }
                                                                              }}
                                                                              style={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                              }}
                                                                            >
                                                                              {item2.label}
                                                                              {hasChild && <span>▶</span>}
                                                                            </Dropdown.Item>

                                                                            {/* ✅ Child Dropdown */}
                                                                            {hasChild && hoveredItem === item2.label && (
                                                                              <div
                                                                                style={{
                                                                                  position: "absolute",
                                                                                  top: 0,
                                                                                  left: "100%",
                                                                                  background: "white",
                                                                                  border: "1px solid #ddd",
                                                                                  minWidth: "180px",
                                                                                  zIndex: 1050,
                                                                                }}
                                                                              >
                                                                                {item2.subMaterials.map((child, childIndex) => (
                                                                                  <Dropdown.Item
                                                                                    onClick={() => {
                                                                                      handleLivingOptionChange(
                                                                                        {
                                                                                          target: {
                                                                                            value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                            // value: child.subValue,
                                                                                            label: `${item2.label} (${child.subLabel})`,
                                                                                          },
                                                                                        },
                                                                                        index
                                                                                      );
                                                                                    }}
                                                                                  >
                                                                                    {child.subLabel}
                                                                                  </Dropdown.Item>
                                                                                ))}
                                                                              </div>
                                                                            )}
                                                                          </div>
                                                                        );
                                                                      })}

                                                                      <Dropdown.Divider />

                                                                      <div className="px-3 py-2">
                                                                        <Button
                                                                          variant="outline-success"
                                                                          size="sm"
                                                                          onClick={(e) => {
                                                                            e.stopPropagation(); // prevent dropdown from closing
                                                                            handleAddNewItem(item, 'kitchen', index);
                                                                          }}
                                                                        >
                                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                        </Button>
                                                                      </div>
                                                                    </Dropdown.Menu>
                                                                  </Dropdown>
                                                                </Col>
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.rft === 0 ? "" : formData.rft}
                                                                      onChange={(e) => handleLivingChange(e, index, "rft")}
                                                                      placeholder="RFT"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>

                                                                <Col sm={1}>

                                                                </Col>

                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.price}
                                                                      // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                                      placeholder="Price"
                                                                      disabled={livingFormData[index].value ? false : true}
                                                    readOnly
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      value={formData.remark}
                                                                      onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                                      as="textarea" rows={1}
                                                                      placeholder="Remark"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                {renderRowActions(item, index)}
                                                              </Row> : item.measurement == "selection" ?
                                                                <Row className="hover-row">
                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Label
                                                                        style={{
                                                                          fontSize: 16,
                                                                          fontWeight: "500",
                                                                        }}
                                                                      ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                      </Form.Label>
                                                                    </Form.Group>
                                                                  </Col>
                                                                  {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                                  {/* add label option */}
                                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                                    <Dropdown>
                                                                      <Dropdown.Toggle
                                                                        variant="outline-secondary"
                                                                        style={{
                                                                          width: '12vw',
                                                                          backgroundColor: 'white',
                                                                          color: 'black',
                                                                          display: 'flex',
                                                                          justifyContent: 'space-between',
                                                                          alignItems: 'center',
                                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                                          wordBreak: 'break-word',     // Breaks long words
                                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                        }}>
                                                                        {formData?.label || 'None'}
                                                                      </Dropdown.Toggle>
                                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                                        <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                          None
                                                                        </Dropdown.Item>
                                                                        {item.material.map((item2, index2) => {
                                                                          const childList = item2.subMaterials;
                                                                          const hasChild = childList && childList.length > 0;

                                                                          return (
                                                                            <div
                                                                              key={index2}
                                                                              style={{ position: "relative" }}
                                                                              onMouseEnter={() => setHoveredItem(item2.label)}
                                                                              onMouseLeave={() => setHoveredItem(null)}
                                                                            >
                                                                              <Dropdown.Item
                                                                                onClick={() => {
                                                                                  if (!hasChild) {
                                                                                    handleLivingOptionChange(
                                                                                      {
                                                                                        target: {
                                                                                          value:
                                                                                            data.priceType === "oldvalue"
                                                                                              ? item2.oldvalue
                                                                                              : item2.value,
                                                                                          label: item2.label,
                                                                                        },
                                                                                      },
                                                                                      index
                                                                                    );
                                                                                  }
                                                                                }}
                                                                                style={{
                                                                                  display: "flex",
                                                                                  justifyContent: "space-between",
                                                                                }}
                                                                              >
                                                                                {item2.label}
                                                                                {hasChild && <span>▶</span>}
                                                                              </Dropdown.Item>

                                                                              {/* ✅ Child Dropdown */}
                                                                              {hasChild && hoveredItem === item2.label && (
                                                                                <div
                                                                                  style={{
                                                                                    position: "absolute",
                                                                                    top: 0,
                                                                                    left: "100%",
                                                                                    background: "white",
                                                                                    border: "1px solid #ddd",
                                                                                    minWidth: "180px",
                                                                                    zIndex: 1050,
                                                                                  }}
                                                                                >
                                                                                  {item2.subMaterials.map((child, childIndex) => (
                                                                                    <Dropdown.Item
                                                                                      onClick={() => {
                                                                                        handleLivingOptionChange(
                                                                                          {
                                                                                            target: {
                                                                                              value: data.priceType === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                              // value: child.subValue,
                                                                                              label: `${item2.label} (${child.subLabel})`,
                                                                                            },
                                                                                          },
                                                                                          index
                                                                                        );
                                                                                      }}
                                                                                    >
                                                                                      {child.subLabel}
                                                                                    </Dropdown.Item>
                                                                                  ))}
                                                                                </div>
                                                                              )}
                                                                            </div>
                                                                          );
                                                                        })}

                                                                        <Dropdown.Divider />

                                                                        <div className="px-3 py-2">
                                                                          <Button
                                                                            variant="outline-success"
                                                                            size="sm"
                                                                            onClick={(e) => {
                                                                              e.stopPropagation(); // prevent dropdown from closing
                                                                              handleAddNewItem(item, 'kitchen', index);
                                                                            }}
                                                                          >
                                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                          </Button>
                                                                        </div>
                                                                      </Dropdown.Menu>
                                                                    </Dropdown>
                                                                  </Col>
                                                                  <Col sm={2}>

                                                                  </Col>

                                                                  <Col sm={1}>

                                                                  </Col>

                                                                  <Col sm={2}>

                                                                  </Col>
                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        value={formData.remark}
                                                                        onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                                        as="textarea" rows={1}
                                                                        placeholder="Remark"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>
                                                                  {renderRowActions(item, index)}
                                                                </Row> : null
                                                }
                                              </div>
                                            )}
                                          </Draggable>

                                        ))}
                                      {provided.placeholder}
                                    </div>
                                  )}
                                </Droppable>

                              </DragDropContext>

                              <Row>
                                <Col>

                                  <Row className="mx-1 my-3">
                                    <Col sm={2}>
                                      <Form.Group >
                                        <Form.Control
                                          value={extraItemName}
                                          onChange={(e) => setExtraItemName(e.target.value)}
                                          type="text"
                                          placeholder="Item Name"
                                        />
                                      </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                      <Form.Group >
                                        <Form.Control
                                          value={extraItemMaterialName}
                                          onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                          type="text"
                                          placeholder="Material Name"
                                        />
                                      </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                      <Form.Group >
                                        <Form.Control
                                          value={extraItemMaterialValue}
                                          onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                          type="number"
                                          placeholder="Material Value"
                                        />
                                      </Form.Group>
                                    </Col>

                                    <Col sm={3}>
                                      <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                        <option>Select Measurement Type</option>
                                        <option value="area">Area</option>
                                        <option value="width">Width &  Height</option>
                                        <option value="rft">RFT</option>
                                        <option value="qty">Quantity</option>
                                        <option value="length">Width & Length</option>
                                        <option value="selection">Selection</option>
                                      </Form.Select>
                                    </Col>
                                    <Col sm={1}>
                                      <Form.Check
                                        inline
                                        label="Wood"
                                        name="Wood"
                                        type="checkbox"
                                        id="inline-checkbox-1"
                                        checked={isChecked}
                                        onChange={handleCheckboxChange}
                                      />
                                    </Col>
                                    <Col sm={2}>
                                      <Button onClick={addNewLivingItem}>Add Item</Button>
                                    </Col>
                                  </Row>





                                </Col>

                              </Row>
                            </Form.Group>


                          </Form>
                        </Col>
                      </Row>



                      <Row style={{
                        // marginBottom: '50px',
                        marginLeft: '1px',
                        padding: '20px',
                        borderRadius: '15px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                        backgroundColor: '#ffffff', // Light background color


                      }} >
                        <Col >
                          <Button className="buttonDesign" style={{ fontSize: 13, width: '20vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveLivingData()} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                        </Col>
                        <Col className="col-sm-3">

                        </Col>
                        <Col className="col-sm-2"><h4>Total Price</h4></Col>
                        <Col className="col-sm-2">
                          {/* <h4>
                                        Rs:- {roomTypePrice}
                
                                      </h4> */}
                          <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{calculateLivingTotal()}</h4></span>
                        </Col>
                      </Row>

                    </Row> : roomTypeModal == 'Other Works' ?
                      <Row
                        style={{
                          // marginBottom: '50px',
                          // height:'auto',

                          padding: '20px',
                          // marginLeft: '20px',
                          borderRadius: '15px',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                          backgroundColor: '#ffff', // Light background color

                        }}  >
                        <div style={{
                          display: "flex",
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          borderRadius: '15px',
                          padding: '0.5rem'
                        }}>
                          <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Other Works -- </h5><h6 style={{ color: '#e85d13' }}>{data.priceType === 'value' ? 'New Value' : 'Old Value'}</h6></span>
                          <Form>
                            <InputGroup>
                              <Form.Control
                                style={{
                                  borderRadius: "15px",
                                  padding: "12px 15px",
                                  border: "1px solid #d1d5db",
                                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                  background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                  transition: "all 0.3s ease",
                                  width: "20vw",
                                }}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Search Projects"
                              />
                            </InputGroup>
                          </Form>
                        </div>

                        <Row style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>
                          <Col style={{ minHeight: 380, maxHeight: 480 }}>

                            <Form>

                              <Form.Group>
                                <DragDropContext onDragEnd={handleDragOtherEnd}>
                                  <Droppable droppableId="droppable-other">
                                    {(provided) => (
                                      <div ref={provided.innerRef} {...provided.droppableProps}>
                                        {filteredDataField
                                          .map((item, index) => ({ item, formData: (otherFormData && otherFormData[index]) || {}, index }))
                                          .filter(({ item }) => {
                                            const searchQuery = search.toLowerCase();
                                            return searchQuery === '' || item.name?.toLowerCase().includes(searchQuery);
                                          })
                                          .map(({ item, formData, index }) => (
                                            <Draggable key={item.id || `temp-${index}`}
                                              draggableId={getDraggableId(item, index)}
                                              index={index}>
                                              {(provided) => (
                                                <div className={isItemFilled(formData) ? "selected-row-container" : ""} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                  {item.measurement == "area" ?
                                                    <Row className="hover-row">
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={otherFormData[index].value}
                              onChange={(e) => handleOtherOptionChange(e, index)} >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData?.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => (
                                                              <Dropdown.Item
                                                                key={index2}
                                                                onClick={() =>
                                                                  handleOtherOptionChange(
                                                                    {
                                                                      target: {
                                                                        value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                        label: item2.label
                                                                      }
                                                                    },
                                                                    index
                                                                  )
                                                                }
                                                              >
                                                                {item2.label}
                                                              </Dropdown.Item>
                                                            ))}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item, "OtherWorks", index); // define this function
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.area === 0 ? "" : formData.area}
                                                            onChange={(e) => handleOtherChange(e, index, "area")}
                                                            placeholder="Area"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={formData.price}
                                                            // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={formData.value ? false : true}
                                                    readOnly
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={formData.remark}
                                                            onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      {renderRowActions(item, index)}
                                                    </Row>
                                                    : item.measurement == "width" ?
                                                      <Row className="hover-row">
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={otherFormData[index].value}
                              onChange={(e) => handleOtherOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                        <Col sm={2} style={{ display: 'flex' }}>
                                                          <Dropdown>
                                                            <Dropdown.Toggle
                                                              variant="outline-secondary"
                                                              style={{
                                                                width: '12vw',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                whiteSpace: 'normal',        // Allows text to wrap
                                                                wordBreak: 'break-word',     // Breaks long words
                                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                              }}>
                                                              {formData?.label || 'None'}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                                              <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                None
                                                              </Dropdown.Item>
                                                              {item.material.map((item2, index2) => (
                                                                <Dropdown.Item
                                                                  key={index2}
                                                                  onClick={() =>
                                                                    handleOtherOptionChange(
                                                                      {
                                                                        target: {
                                                                          value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                          label: item2.label
                                                                        }
                                                                      },
                                                                      index
                                                                    )
                                                                  }
                                                                >
                                                                  {item2.label}
                                                                </Dropdown.Item>
                                                              ))}

                                                              <Dropdown.Divider />

                                                              <div className="px-3 py-2">
                                                                <Button
                                                                  variant="outline-success"
                                                                  size="sm"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation(); // prevent dropdown from closing
                                                                    handleAddNewItem(item, "OtherWorks", index); // define this function
                                                                  }}
                                                                >
                                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                </Button>
                                                              </div>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                        </Col>
                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.width === 0 ? "" : formData.width}
                                                              onChange={(e) => handleOtherChange(e, index, "width")}
                                                              placeholder="Width"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.height === 0 ? "" : formData.height}
                                                              onChange={(e) => handleOtherChange(e, index, "height")}
                                                              placeholder="Height"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.qnty === 0 ? "" : formData.qnty}
                                                              onChange={(e) => handleOtherChange(e, index, "qnty")}
                                                              placeholder="Qty"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={formData.price}
                                                              // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={formData.value ? false : true}
                                                    readOnly
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={formData.remark}
                                                              onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        {renderRowActions(item, index)}
                                                      </Row>
                                                      : item.measurement == "qty" ?
                                                        <Row className="hover-row">
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Label
                                                                style={{
                                                                  fontSize: 16,
                                                                  fontWeight: "500",
                                                                }}
                                                              ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                              </Form.Label>
                                                            </Form.Group>
                                                          </Col>
                                                          {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={otherFormData[index].value}
                              onChange={(e) => handleOtherOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                          <Col sm={2} style={{ display: 'flex' }}>
                                                            <Dropdown>
                                                              <Dropdown.Toggle
                                                                variant="outline-secondary"
                                                                style={{
                                                                  width: '12vw',
                                                                  backgroundColor: 'white',
                                                                  color: 'black',
                                                                  display: 'flex',
                                                                  justifyContent: 'space-between',
                                                                  alignItems: 'center',
                                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                                  wordBreak: 'break-word',     // Breaks long words
                                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                }}>
                                                                {formData?.label || 'None'}
                                                              </Dropdown.Toggle>
                                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                                <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                  None
                                                                </Dropdown.Item>
                                                                {item.material.map((item2, index2) => (
                                                                  <Dropdown.Item
                                                                    key={index2}
                                                                    onClick={() =>
                                                                      handleOtherOptionChange(
                                                                        {
                                                                          target: {
                                                                            value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                            label: item2.label
                                                                          }
                                                                        },
                                                                        index
                                                                      )
                                                                    }
                                                                  >
                                                                    {item2.label}
                                                                  </Dropdown.Item>
                                                                ))}

                                                                <Dropdown.Divider />

                                                                <div className="px-3 py-2">
                                                                  <Button
                                                                    variant="outline-success"
                                                                    size="sm"
                                                                    onClick={(e) => {
                                                                      e.stopPropagation(); // prevent dropdown from closing
                                                                      handleAddNewItem(item, "OtherWorks", index); // define this function
                                                                    }}
                                                                  >
                                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                  </Button>
                                                                </div>
                                                              </Dropdown.Menu>
                                                            </Dropdown>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.qnty === 0 ? "" : formData.qnty}
                                                                onChange={(e) => handleOtherChange(e, index, "qnty")}
                                                                placeholder="Qty"
                                                              />
                                                            </Form.Group>
                                                          </Col>

                                                          <Col sm={1}>

                                                          </Col>

                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.price}
                                                                // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                                placeholder="Price"
                                                                disabled={formData.value ? false : true}
                                                    readOnly
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                value={formData.remark}
                                                                onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                                as="textarea" rows={1}
                                                                placeholder="Remark"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          {renderRowActions(item, index)}
                                                        </Row>
                                                        : item.measurement == "length" ?
                                                          <Row className="hover-row">
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Label
                                                                  style={{
                                                                    fontSize: 16,
                                                                    fontWeight: "500",
                                                                  }}
                                                                ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                </Form.Label>
                                                              </Form.Group>
                                                            </Col>
                                                            {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={otherFormData[index].value}
                              onChange={(e) => handleOtherOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                            <Col sm={2} style={{ display: 'flex' }}>
                                                              <Dropdown>
                                                                <Dropdown.Toggle
                                                                  variant="outline-secondary"
                                                                  style={{
                                                                    width: '12vw',
                                                                    backgroundColor: 'white',
                                                                    color: 'black',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                                    wordBreak: 'break-word',     // Breaks long words
                                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                  }}>
                                                                  {formData?.label || 'None'}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                                  <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                    None
                                                                  </Dropdown.Item>
                                                                  {item.material.map((item2, index2) => (
                                                                    <Dropdown.Item
                                                                      key={index2}
                                                                      onClick={() =>
                                                                        handleOtherOptionChange(
                                                                          {
                                                                            target: {
                                                                              value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                              label: item2.label
                                                                            }
                                                                          },
                                                                          index
                                                                        )
                                                                      }
                                                                    >
                                                                      {item2.label}
                                                                    </Dropdown.Item>
                                                                  ))}

                                                                  <Dropdown.Divider />

                                                                  <div className="px-3 py-2">
                                                                    <Button
                                                                      variant="outline-success"
                                                                      size="sm"
                                                                      onClick={(e) => {
                                                                        e.stopPropagation(); // prevent dropdown from closing
                                                                        handleAddNewItem(item, "OtherWorks", index); // define this function
                                                                      }}
                                                                    >
                                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                    </Button>
                                                                  </div>
                                                                </Dropdown.Menu>
                                                              </Dropdown>
                                                            </Col>
                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.height === 0 ? "" : formData.height}
                                                                  onChange={(e) => handleOtherChange(e, index, "height")}
                                                                  placeholder="Length"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.width === 0 ? "" : formData.width}
                                                                  onChange={(e) => handleOtherChange(e, index, "width")}
                                                                  placeholder="Width"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={1}>

                                                            </Col>

                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.price}
                                                                  // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                                  placeholder="Price"
                                                                  disabled={formData.value ? false : true}
                                                    readOnly
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  value={formData.remark}
                                                                  onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                                  as="textarea" rows={1}
                                                                  placeholder="Remark"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            {renderRowActions(item, index)}
                                                          </Row>
                                                          : item.measurement == "selection" ?
                                                            <Row className="hover-row">
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Label
                                                                    style={{
                                                                      fontSize: 16,
                                                                      fontWeight: "500",
                                                                    }}
                                                                  ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                  </Form.Label>
                                                                </Form.Group>
                                                              </Col>
                                                              {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                              {/* add label option */}
                                                              <Col sm={2} style={{ display: 'flex' }}>
                                                                <Dropdown>
                                                                  <Dropdown.Toggle
                                                                    variant="outline-secondary"
                                                                    style={{
                                                                      width: '12vw',
                                                                      backgroundColor: 'white',
                                                                      color: 'black',
                                                                      display: 'flex',
                                                                      justifyContent: 'space-between',
                                                                      alignItems: 'center',
                                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                                      wordBreak: 'break-word',     // Breaks long words
                                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                    }}>
                                                                    {formData?.label || 'None'}
                                                                  </Dropdown.Toggle>
                                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                                    <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                      None
                                                                    </Dropdown.Item>
                                                                    {item.material.map((item2, index2) => (
                                                                      <Dropdown.Item
                                                                        key={index2}
                                                                        onClick={() =>
                                                                          handleOtherOptionChange(
                                                                            {
                                                                              target: {
                                                                                value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                                label: item2.label
                                                                              }
                                                                            },
                                                                            index
                                                                          )
                                                                        }
                                                                      >
                                                                        {item2.label}
                                                                      </Dropdown.Item>
                                                                    ))}

                                                                    <Dropdown.Divider />

                                                                    <div className="px-3 py-2">
                                                                      <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation(); // prevent dropdown from closing
                                                                          handleAddNewItem(item, "OtherWorks", index); // define this function
                                                                        }}
                                                                      >
                                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                      </Button>
                                                                    </div>
                                                                  </Dropdown.Menu>
                                                                </Dropdown>
                                                              </Col>
                                                              <Col sm={2}>

                                                              </Col>

                                                              <Col sm={1}>

                                                              </Col>

                                                              <Col sm={2}>

                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    value={formData.remark}
                                                                    onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                                    as="textarea" rows={1}
                                                                    placeholder="Remark"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              {renderRowActions(item, index)}
                                                            </Row> : item.measurement == "rft" ?
                                                              <Row className="hover-row">
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Label
                                                                      style={{
                                                                        fontSize: 16,
                                                                        fontWeight: "500",
                                                                      }}
                                                                    ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                    </Form.Label>
                                                                  </Form.Group>
                                                                </Col>
                                                                {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={otherFormData[index].value}
                              onChange={(e) => handleOtherOptionChange(e, index)}
                     

                              >
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                                <Col sm={2} style={{ display: 'flex' }}>
                                                                  <Dropdown>
                                                                    <Dropdown.Toggle
                                                                      variant="outline-secondary"
                                                                      style={{
                                                                        width: '12vw',
                                                                        backgroundColor: 'white',
                                                                        color: 'black',
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center',
                                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                                        wordBreak: 'break-word',     // Breaks long words
                                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                      }}>
                                                                      {formData?.label || 'None'}
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                                      <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                        None
                                                                      </Dropdown.Item>
                                                                      {item.material.map((item2, index2) => (
                                                                        <Dropdown.Item
                                                                          key={index2}
                                                                          onClick={() =>
                                                                            handleOtherOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                                  label: item2.label
                                                                                }
                                                                              },
                                                                              index
                                                                            )
                                                                          }
                                                                        >
                                                                          {item2.label}
                                                                        </Dropdown.Item>
                                                                      ))}

                                                                      <Dropdown.Divider />

                                                                      <div className="px-3 py-2">
                                                                        <Button
                                                                          variant="outline-success"
                                                                          size="sm"
                                                                          onClick={(e) => {
                                                                            e.stopPropagation(); // prevent dropdown from closing
                                                                            handleAddNewItem(item, "OtherWorks", index); // define this function
                                                                          }}
                                                                        >
                                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                        </Button>
                                                                      </div>
                                                                    </Dropdown.Menu>
                                                                  </Dropdown>
                                                                </Col>
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.rft === 0 ? "" : formData.rft}
                                                                      onChange={(e) => handleOtherChange(e, index, "rft")}
                                                                      placeholder="RFT"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>

                                                                <Col sm={1}>

                                                                </Col>

                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.price}
                                                                      // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                                      placeholder="Price"
                                                                      disabled={formData.value ? false : true}
                                                    readOnly
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      value={formData.remark}
                                                                      onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                                      as="textarea" rows={1}
                                                                      placeholder="Remark"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                {renderRowActions(item, index)}
                                                              </Row> : item.measurement == "painting" ?
                                                                <Row className="hover-row">
                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Label
                                                                        style={{
                                                                          fontSize: 16,
                                                                          fontWeight: "500",
                                                                        }}
                                                                      ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                      </Form.Label>
                                                                    </Form.Group>
                                                                  </Col>
                                                                  {/* <Col sm={2}>
                            <Form.Group>
                              <Form.Select
                              value={otherFormData[index].value}
                              onChange={(e) => handleOtherOptionChange(e, index)}>
                                <option value="0">None</option>
                                {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                
                              </Form.Select>
                            </Form.Group>
                          </Col> */}
                                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                                    <Dropdown>
                                                                      <Dropdown.Toggle
                                                                        variant="outline-secondary"
                                                                        style={{
                                                                          width: '12vw',
                                                                          backgroundColor: 'white',
                                                                          color: 'black',
                                                                          display: 'flex',
                                                                          justifyContent: 'space-between',
                                                                          alignItems: 'center',
                                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                                          wordBreak: 'break-word',     // Breaks long words
                                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                        }}>
                                                                        {formData?.label || 'None'}
                                                                      </Dropdown.Toggle>
                                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                                        <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                          None
                                                                        </Dropdown.Item>
                                                                        {item.material.map((item2, index2) => (
                                                                          <Dropdown.Item
                                                                            key={index2}
                                                                            onClick={() =>
                                                                              handleOtherOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                                    label: item2.label
                                                                                  }
                                                                                },
                                                                                index
                                                                              )
                                                                            }
                                                                          >
                                                                            {item2.label}
                                                                          </Dropdown.Item>
                                                                        ))}

                                                                        <Dropdown.Divider />

                                                                        <div className="px-3 py-2">
                                                                          <Button
                                                                            variant="outline-success"
                                                                            size="sm"
                                                                            onClick={(e) => {
                                                                              e.stopPropagation(); // prevent dropdown from closing
                                                                              handleAddNewItem(item, "OtherWorks", index); // define this function
                                                                            }}
                                                                          >
                                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                          </Button>
                                                                        </div>
                                                                      </Dropdown.Menu>
                                                                    </Dropdown>
                                                                  </Col>
                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.painting === 0 ? "" : formData.painting}
                                                                        onChange={(e) => handleOtherChange(e, index, "painting")}
                                                                        placeholder="Area"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>

                                                                  <Col sm={1}>

                                                                  </Col>

                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.price}
                                                                        // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                                        placeholder="Price"
                                                                        disabled={formData.value ? false : true}
                                                    readOnly
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>
                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        value={formData.remark}
                                                                        onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                                        as="textarea" rows={1}
                                                                        placeholder="Remark"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>
                                                                  {renderRowActions(item, index)}
                                                                </Row> : null}
                                                </div>
                                              )}
                                            </Draggable>

                                          ))}
                                        {provided.placeholder}
                                      </div>
                                    )}

                                  </Droppable>
                                </DragDropContext>


                              </Form.Group>


                            </Form>
                          </Col>
                        </Row>

                        <Row>
                          <Col>

                            <Row className="mx-1 my-3">
                              <Col sm={2}>
                                <Form.Group >
                                  <Form.Control
                                    value={extraItemName}
                                    onChange={(e) => setExtraItemName(e.target.value)}
                                    type="text"
                                    placeholder="Item Name"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={2}>
                                <Form.Group >
                                  <Form.Control
                                    value={extraItemMaterialName}
                                    onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                    type="text"
                                    placeholder="Material Name"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={2}>
                                <Form.Group >
                                  <Form.Control
                                    value={extraItemMaterialValue}
                                    onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                    type="number"
                                    placeholder="Material Value"
                                  />
                                </Form.Group>
                              </Col>

                              <Col sm={3}>
                                <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                  <option>Select Measurement Type</option>
                                  <option value="area">Area</option>
                                  <option value="width">Width &  Height</option>
                                  <option value="rft">RFT</option>
                                  <option value="qty">Quantity</option>
                                  <option value="length">Width & Length</option>
                                  <option value="selection">Selection</option>
                                </Form.Select>
                              </Col>
                              <Col sm={1}>
                                {/* <Form.Check
                                                                  inline
                                                                  label="Wood"
                                                                  name="Wood"
                                                                  type="checkbox"
                                                                  id="inline-checkbox-1"
                                                                  checked={isChecked}
                                                                  onChange={handleCheckboxChange}
                                                                /> */}
                              </Col>
                              <Col sm={2}>
                                <Button onClick={addNewOtherWorkItem}>Add Item</Button>
                              </Col>
                            </Row>





                          </Col>

                        </Row>



                        <Row style={{
                          // marginBottom: '50px',
                          marginLeft: '1px',
                          padding: '20px',
                          borderRadius: '15px',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                          backgroundColor: '#ffffff', // Light background color


                        }} >
                          <Col >
                            <Button className="buttonDesign" style={{ fontSize: 13, width: '20vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveOtherData()} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                          </Col>
                          <Col className="col-sm-3">

                          </Col>
                          <Col className="col-sm-2"><h4>Total Price</h4></Col>
                          <Col className="col-sm-2">
                            {/* <h4>
                                        Rs:- {roomTypePrice}
                
                                      </h4> */}
                            <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{calculateOtherTotal()}</h4></span>
                          </Col>
                        </Row>


                      </Row> : roomTypeModal == 'Loose Furniture' ?
                        <Row className="p-2" >
                          <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>loose Furniture -- </h5><h6 style={{ color: '#e85d13' }}>{data.priceType === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                          <Row style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>
                            <Col style={{ minHeight: 380, maxHeight: 480 }}>

                              <Form>

                                <Form.Group>
                                  <DragDropContext onDragEnd={handleDragLooseEnd}>
                                    <Droppable droppableId="droppable-kitchen">
                                      {(provided) => (
                                        <div ref={provided.innerRef} {...provided.droppableProps}>
                                          {filteredDataField.map((item, index) => (
                                            <Draggable key={item.id || `temp-${index}`}
                                              draggableId={getDraggableId(item, index)}
                                              index={index}>
                                              {(provided) => (
                                                <div className={isItemFilled(looseFormData && looseFormData[index]) ? "selected-row-container" : ""} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                  {
                                                    item.measurement == "area" ?
                                                      <Row className="hover-row">
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Select
                                                              value={looseFormData[index].value}
                                                              onChange={(e) => handleLooseOptionChange(e, index)}


                                                            >
                                                              <option value="0">None</option>
                                                              {item.material.map((item2, index2) => (
                                                                <option
                                                                  key={index2}
                                                                  value={data.priceType === 'oldvalue' ? item2.oldvalue : item2.value}
                                                                >
                                                                  {item2.label}
                                                                </option>
                                                              ))}

                                                            </Form.Select>
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={looseFormData[index].area}
                                                              onChange={(e) => handleLooseChange(e, index, "area")}
                                                              placeholder="Area"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>

                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={looseFormData[index].price}
                                                              // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={looseFormData[index].value ? false : true}
                                                    readOnly
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={3}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={looseFormData[index].remark}
                                                              onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                      </Row>
                                                      : item.measurement == "width" ?
                                                        <Row className="hover-row">
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Label
                                                                style={{
                                                                  fontSize: 16,
                                                                  fontWeight: "500",
                                                                }}
                                                              ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                              </Form.Label>
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Select
                                                                value={looseFormData[index].value}
                                                                onChange={(e) => handleLooseOptionChange(e, index)}


                                                              >
                                                                <option value="0">None</option>
                                                                {item.material.map((item2, index2) => (
                                                                  <option
                                                                    key={index2}
                                                                    value={data.priceType === 'oldvalue' ? item2.oldvalue : item2.value}
                                                                  >
                                                                    {item2.label}
                                                                  </option>
                                                                ))}

                                                              </Form.Select>
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={1}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={looseFormData[index].width}
                                                                onChange={(e) => handleLooseChange(e, index, "width")}
                                                                placeholder="Width"
                                                              />
                                                            </Form.Group>
                                                          </Col>

                                                          <Col sm={1}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={looseFormData[index].height}
                                                                onChange={(e) => handleLooseChange(e, index, "height")}
                                                                placeholder="Height"
                                                              />
                                                            </Form.Group>
                                                          </Col>

                                                          <Col sm={1}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={looseFormData[index].qnty}
                                                                onChange={(e) => handleLooseChange(e, index, "qnty")}
                                                                placeholder="Qty"
                                                              />
                                                            </Form.Group>
                                                          </Col>

                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={looseFormData[index].price}
                                                                // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                                placeholder="Price"
                                                                disabled={looseFormData[index].value ? false : true}
                                                    readOnly
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={3}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                value={looseFormData[index].remark}
                                                                onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                                as="textarea" rows={1}
                                                                placeholder="Remark"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                        </Row>
                                                        : item.measurement == "qty" ?
                                                          <Row className="hover-row">
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Label
                                                                  style={{
                                                                    fontSize: 16,
                                                                    fontWeight: "500",
                                                                  }}
                                                                ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                </Form.Label>
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Select
                                                                  value={looseFormData[index].value}
                                                                  onChange={(e) => handleLooseOptionChange(e, index)}


                                                                >
                                                                  <option value="0">None</option>
                                                                  {item.material.map((item2, index2) => (
                                                                    <option
                                                                      key={index2}
                                                                      value={data.priceType === 'oldvalue' ? item2.oldvalue : item2.value}
                                                                    >
                                                                      {item2.label}
                                                                    </option>
                                                                  ))}

                                                                </Form.Select>
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={looseFormData[index].qnty}
                                                                  onChange={(e) => handleLooseChange(e, index, "qnty")}
                                                                  placeholder="Qty"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={1}>

                                                            </Col>

                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={looseFormData[index].price}
                                                                  // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                                  placeholder="Price"
                                                                  disabled={looseFormData[index].value ? false : true}
                                                    readOnly
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={3}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  value={looseFormData[index].remark}
                                                                  onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                                  as="textarea" rows={1}
                                                                  placeholder="Remark"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                          </Row>
                                                          : item.measurement == "length" ?
                                                            <Row className="hover-row">
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Label
                                                                    style={{
                                                                      fontSize: 16,
                                                                      fontWeight: "500",
                                                                    }}
                                                                  ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                  </Form.Label>
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Select
                                                                    value={looseFormData[index].value}
                                                                    onChange={(e) => handleLooseOptionChange(e, index)}


                                                                  >
                                                                    <option value="0">None</option>
                                                                    {item.material.map((item2, index2) => (
                                                                      <option
                                                                        key={index2}
                                                                        value={data.priceType === 'oldvalue' ? item2.oldvalue : item2.value}
                                                                      >
                                                                        {item2.label}
                                                                      </option>
                                                                    ))}

                                                                  </Form.Select>
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={1}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={looseFormData[index].height}
                                                                    onChange={(e) => handleLooseChange(e, index, "height")}
                                                                    placeholder="Length"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={1}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={looseFormData[index].width}
                                                                    onChange={(e) => handleLooseChange(e, index, "width")}
                                                                    placeholder="Width"
                                                                  />
                                                                </Form.Group>
                                                              </Col>

                                                              <Col sm={1}>

                                                              </Col>

                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={looseFormData[index].price}
                                                                    // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                                    placeholder="Price"
                                                                    disabled={looseFormData[index].value ? false : true}
                                                    readOnly
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={3}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    value={looseFormData[index].remark}
                                                                    onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                                    as="textarea" rows={1}
                                                                    placeholder="Remark"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                            </Row> : item.measurement == "rft" ?
                                                              <Row className="mx-1 my-3">
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Label
                                                                      style={{
                                                                        fontSize: 16,
                                                                        fontWeight: "500",
                                                                      }}
                                                                    ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                    </Form.Label>
                                                                  </Form.Group>
                                                                </Col>
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Select
                                                                      value={looseFormData[index].value}
                                                                      onChange={(e) => handleLooseOptionChange(e, index)}


                                                                    >
                                                                      <option value="0">None</option>
                                                                      {item.material.map((item2, index2) => (
                                                                        <option
                                                                          key={index2}
                                                                          value={data.priceType === 'oldvalue' ? item2.oldvalue : item2.value}
                                                                        >
                                                                          {item2.label}
                                                                        </option>
                                                                      ))}

                                                                    </Form.Select>
                                                                  </Form.Group>
                                                                </Col>
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={looseFormData[index].rft}
                                                                      onChange={(e) => handleLooseChange(e, index, "rft")}
                                                                      placeholder="RFT"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>

                                                                <Col sm={1}>

                                                                </Col>

                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={looseFormData[index].price}
                                                                      // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                                      placeholder="Price"
                                                                      disabled={looseFormData[index].value ? false : true}
                                                    readOnly
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                <Col sm={3}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      value={looseFormData[index].remark}
                                                                      onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                                      as="textarea" rows={1}
                                                                      placeholder="Remark"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                              </Row> : null
                                                  }
                                                </div>
                                              )}

                                            </Draggable>

                                          ))}
                                          {provided.placeholder}
                                        </div>
                                      )}
                                    </Droppable>

                                  </DragDropContext>

                                </Form.Group>


                              </Form>
                            </Col>
                          </Row>

                          <Row style={{
                            // marginBottom: '50px',
                            marginLeft: '1px',
                            padding: '20px',
                            borderRadius: '15px',
                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                            backgroundColor: '#ffffff', // Light background color


                          }} >
                            <Col >
                              <Button className="buttonDesign" style={{ fontSize: 13, width: '20vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveLooseData()} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                            </Col>
                            <Col className="col-sm-3">

                            </Col>
                            <Col className="col-sm-2"><h4>Total Price</h4></Col>
                            <Col className="col-sm-2">
                              {/* <h4>
                                        Rs:- {roomTypePrice}
                
                                      </h4> */}
                              <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{calculateLooseTotal()}</h4></span>
                            </Col>
                          </Row>



                        </Row> : roomTypeModal == 'Accessories' ?
                          <Row
                            style={{
                              // marginBottom: '50px',
                              // height:'auto',

                              padding: '20px',
                              // marginLeft: '20px',
                              borderRadius: '15px',
                              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                              backgroundColor: '#ffff', // Light background color

                            }} >
                            {/* <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Accessories -- </h5><h6 style={{ color: '#e85d13' }}>{data.priceType === 'value' ? 'New Value' : 'Old Value'}</h6></span> */}
                            <div style={{
                              display: "flex",
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              borderRadius: '15px',
                              padding: '0.5rem'
                            }}>
                              <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Accessories -- </h5><h6 style={{ color: '#e85d13' }}>{data.priceType === 'value' ? 'New Value' : 'Old Value'}</h6></span>
                              <Form>
                                <InputGroup>
                                  <Form.Control
                                    style={{
                                      borderRadius: "15px",
                                      padding: "12px 15px",
                                      border: "1px solid #d1d5db",
                                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                      background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                      transition: "all 0.3s ease",
                                      width: "20vw",
                                    }}
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search Projects"
                                  />
                                </InputGroup>
                              </Form>
                            </div>

                            <Row style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>
                              <Col style={{ minHeight: 380, maxHeight: 480 }}>

                                <Form>

                                  <Form.Group>
                                    <DragDropContext onDragEnd={handleDragAccessoriesEnd} >

                                      <Droppable droppableId="droppable-kitchen">

                                        {(provided) => (
                                          <div ref={provided.innerRef} {...provided.droppableProps}>
                                            {filteredDataField
                                              .map((item, index) => ({ item, formData: (accessoriesFormData && accessoriesFormData[index]) || {}, index })) // Pair with index
                                              .filter(({ item }) => {
                                                const searchQuery = search.toLowerCase();
                                                return searchQuery === '' || item.name.toLowerCase().includes(searchQuery);
                                              })
                                              .map(({ item, formData, index }) => (
                                                <Draggable key={item.id || `temp-${index}`}
                                                  draggableId={getDraggableId(item, index)}
                                                  index={index}>
                                                  {(provided) => (
                                                    <div className={isItemFilled(formData) ? "selected-row-container" : ""} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >

                                                      {item.measurement == "area" ?
                                                        <Row className="hover-row">
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Label
                                                                style={{
                                                                  fontSize: 16,
                                                                  fontWeight: "500",
                                                                }}
                                                              > <h6 style={{ color: '#e85d13' }}><h6 style={{ color: '#e85d13' }}>{item.name}</h6></h6>
                                                              </Form.Label>
                                                            </Form.Group>
                                                          </Col>
                                                          {/* add label option */}
                                                          <Col sm={2} style={{ display: 'flex' }}>
                                                            <Dropdown>
                                                              <Dropdown.Toggle
                                                                variant="outline-secondary"
                                                                style={{
                                                                  width: '12vw',
                                                                  backgroundColor: 'white',
                                                                  color: 'black',
                                                                  display: 'flex',
                                                                  justifyContent: 'space-between',
                                                                  alignItems: 'center',
                                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                                  wordBreak: 'break-word',     // Breaks long words
                                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                }}>
                                                                {formData?.label || 'None'}
                                                              </Dropdown.Toggle>
                                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                                <Dropdown.Item onClick={() => handleAccessoriesOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                  None
                                                                </Dropdown.Item>
                                                                {item.material.map((item2, index2) => (
                                                                  <Dropdown.Item
                                                                    key={index2}
                                                                    onClick={() =>
                                                                      handleAccessoriesOptionChange(
                                                                        {
                                                                          target: {
                                                                            value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                            label: item2.label
                                                                          }
                                                                        },
                                                                        index
                                                                      )
                                                                    }
                                                                  >
                                                                    {item2.label}
                                                                  </Dropdown.Item>
                                                                ))}
                                                                <Dropdown.Divider />
                                                                <div className="px-3 py-2">
                                                                  <Button
                                                                    variant="outline-success"
                                                                    size="sm"
                                                                    onClick={(e) => {
                                                                      e.stopPropagation(); // prevent dropdown from closing
                                                                      handleAddNewItem(item, "Accessories", index); // define this function
                                                                    }}
                                                                  >
                                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                  </Button>
                                                                </div>
                                                              </Dropdown.Menu>
                                                            </Dropdown>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.area === 0 ? "" : formData.area}
                                                                onChange={(e) => handleAccessoriesChange(e, index, "area")}
                                                                placeholder="Area"

                                                              />
                                                            </Form.Group>
                                                          </Col>

                                                          <Col sm={1}>

                                                          </Col>

                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={formData.price}
                                                                // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                                placeholder="Price"
                                                                disabled={formData.value ? false : true}
                                                    readOnly
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control

                                                                value={formData.remark}
                                                                onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                as="textarea" rows={1}
                                                                placeholder="Remark"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          {renderRowActions(item, index)}
                                                        </Row>
                                                        : item.measurement == "width" ?
                                                          <Row className="hover-row">
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Label
                                                                  style={{
                                                                    fontSize: 16,
                                                                    fontWeight: "500",
                                                                  }}
                                                                ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                </Form.Label>
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={2} style={{ display: 'flex' }}>
                                                              <Dropdown>
                                                                <Dropdown.Toggle
                                                                  variant="outline-secondary"
                                                                  style={{
                                                                    width: '12vw',
                                                                    backgroundColor: 'white',
                                                                    color: 'black',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                                    wordBreak: 'break-word',     // Breaks long words
                                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                  }}>
                                                                  {formData?.label || 'None'}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                                  <Dropdown.Item onClick={() => handleAccessoriesOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                    None
                                                                  </Dropdown.Item>
                                                                  {item.material.map((item2, index2) => (
                                                                    <Dropdown.Item
                                                                      key={index2}
                                                                      onClick={() =>
                                                                        handleAccessoriesOptionChange(
                                                                          {
                                                                            target: {
                                                                              value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                              label: item2.label
                                                                            }
                                                                          },
                                                                          index
                                                                        )
                                                                      }
                                                                    >
                                                                      {item2.label}
                                                                    </Dropdown.Item>
                                                                  ))}

                                                                  <Dropdown.Divider />

                                                                  <div className="px-3 py-2">
                                                                    <Button
                                                                      variant="outline-success"
                                                                      size="sm"
                                                                      onClick={(e) => {
                                                                        e.stopPropagation(); // prevent dropdown from closing
                                                                        handleAddNewItem(item, "Accessories", index); // define this function
                                                                      }}
                                                                    >
                                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                    </Button>
                                                                  </div>
                                                                </Dropdown.Menu>
                                                              </Dropdown>
                                                            </Col>
                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.width === 0 ? "" : formData.width}
                                                                  onChange={(e) => handleAccessoriesChange(e, index, "width")}
                                                                  placeholder="Width"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.height === 0 ? "" : formData.height}
                                                                  onChange={(e) => handleAccessoriesChange(e, index, "height")}
                                                                  placeholder="Height"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={1}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.qnty === 0 ? "" : formData.qnty}
                                                                  onChange={(e) => handleAccessoriesChange(e, index, "qnty")}
                                                                  placeholder="Qty"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={formData.price}
                                                                  // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                                  placeholder="Price"
                                                                  disabled={formData.value ? false : true}
                                                    readOnly
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  value={formData.remark}
                                                                  onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                  as="textarea" rows={1}
                                                                  placeholder="Remark"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            {renderRowActions(item, index)}
                                                          </Row>
                                                          : item.measurement == "qty" ?
                                                            <Row className="hover-row">
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Label
                                                                    style={{
                                                                      fontSize: 16,
                                                                      fontWeight: "500",
                                                                    }}
                                                                  ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                  </Form.Label>
                                                                </Form.Group>
                                                              </Col>

                                                              {/* add label option */}
                                                              <Col sm={2} style={{ display: 'flex' }}>
                                                                <Dropdown>
                                                                  <Dropdown.Toggle
                                                                    variant="outline-secondary"
                                                                    style={{
                                                                      width: '12vw',
                                                                      backgroundColor: 'white',
                                                                      color: 'black',
                                                                      display: 'flex',
                                                                      justifyContent: 'space-between',
                                                                      alignItems: 'center',
                                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                                      wordBreak: 'break-word',     // Breaks long words
                                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                    }}>
                                                                    {formData?.label || 'None'}
                                                                  </Dropdown.Toggle>
                                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                                    <Dropdown.Item onClick={() => handleAccessoriesOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                      None
                                                                    </Dropdown.Item>
                                                                    {item.material.map((item2, index2) => (
                                                                      <Dropdown.Item
                                                                        key={index2}
                                                                        onClick={() =>
                                                                          handleAccessoriesOptionChange(
                                                                            {
                                                                              target: {
                                                                                value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                                label: item2.label
                                                                              }
                                                                            },
                                                                            index
                                                                          )
                                                                        }
                                                                      >
                                                                        {item2.label}
                                                                      </Dropdown.Item>
                                                                    ))}

                                                                    <Dropdown.Divider />

                                                                    <div className="px-3 py-2">
                                                                      <Button
                                                                        variant="outline-success"
                                                                        size="sm"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation(); // prevent dropdown from closing
                                                                          handleAddNewItem(item, "Accessories", index); // define this function
                                                                        }}
                                                                      >
                                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                      </Button>
                                                                    </div>
                                                                  </Dropdown.Menu>
                                                                </Dropdown>
                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={formData.qnty === 0 ? "" : formData.qnty}
                                                                    onChange={(e) => handleAccessoriesChange(e, index, "qnty")}
                                                                    placeholder="Qty"
                                                                  />
                                                                </Form.Group>
                                                              </Col>

                                                              <Col sm={1}>

                                                              </Col>

                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={formData.price}
                                                                    // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                                    placeholder="Price"
                                                                    disabled={formData.value ? false : true}
                                                    readOnly
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    value={formData.remark}
                                                                    onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                    as="textarea" rows={1}
                                                                    placeholder="Remark"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              {renderRowActions(item, index)}
                                                            </Row>
                                                            : item.measurement == "length" ?
                                                              <Row className="hover-row">
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Label
                                                                      style={{
                                                                        fontSize: 16,
                                                                        fontWeight: "500",
                                                                      }}
                                                                    ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                    </Form.Label>
                                                                  </Form.Group>
                                                                </Col>

                                                                {/* add label option */}
                                                                <Col sm={2} style={{ display: 'flex' }}>
                                                                  <Dropdown>
                                                                    <Dropdown.Toggle
                                                                      variant="outline-secondary"
                                                                      style={{
                                                                        width: '12vw',
                                                                        backgroundColor: 'white',
                                                                        color: 'black',
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center',
                                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                                        wordBreak: 'break-word',     // Breaks long words
                                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                      }}>
                                                                      {formData?.label || 'None'}
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                                      <Dropdown.Item onClick={() => handleAccessoriesOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                        None
                                                                      </Dropdown.Item>
                                                                      {item.material.map((item2, index2) => (
                                                                        <Dropdown.Item
                                                                          key={index2}
                                                                          onClick={() =>
                                                                            handleAccessoriesOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                                  label: item2.label
                                                                                }
                                                                              },
                                                                              index
                                                                            )
                                                                          }
                                                                        >
                                                                          {item2.label}
                                                                        </Dropdown.Item>
                                                                      ))}

                                                                      <Dropdown.Divider />

                                                                      <div className="px-3 py-2">
                                                                        <Button
                                                                          variant="outline-success"
                                                                          size="sm"
                                                                          onClick={(e) => {
                                                                            e.stopPropagation(); // prevent dropdown from closing
                                                                            handleAddNewItem(item, "Accessories", index); // define this function
                                                                          }}
                                                                        >
                                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                        </Button>
                                                                      </div>
                                                                    </Dropdown.Menu>
                                                                  </Dropdown>
                                                                </Col>
                                                                <Col sm={1}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.height === 0 ? "" : formData.height}
                                                                      onChange={(e) => handleAccessoriesChange(e, index, "height")}
                                                                      placeholder="Length"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                <Col sm={1}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.width === 0 ? "" : formData.width}
                                                                      onChange={(e) => handleAccessoriesChange(e, index, "width")}
                                                                      placeholder="Width"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>

                                                                <Col sm={1}>

                                                                </Col>

                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      type="number"
                                                                      value={formData.price}
                                                                      // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                                      placeholder="Price"
                                                                      disabled={formData.value ? false : true}
                                                    readOnly
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                <Col sm={2}>
                                                                  <Form.Group>
                                                                    <Form.Control
                                                                      value={formData.remark}
                                                                      onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                      as="textarea" rows={1}
                                                                      placeholder="Remark"
                                                                    />
                                                                  </Form.Group>
                                                                </Col>
                                                                {renderRowActions(item, index)}
                                                              </Row> : item.measurement == "depth" ?
                                                                <Row className="hover-row">
                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Label
                                                                        style={{
                                                                          fontSize: 16,
                                                                          fontWeight: "500",
                                                                        }}
                                                                      ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                      </Form.Label>
                                                                    </Form.Group>
                                                                  </Col>

                                                                  {/* add label option */}
                                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                                    <Dropdown>
                                                                      <Dropdown.Toggle
                                                                        variant="outline-secondary"
                                                                        style={{
                                                                          width: '12vw',
                                                                          backgroundColor: 'white',
                                                                          color: 'black',
                                                                          display: 'flex',
                                                                          justifyContent: 'space-between',
                                                                          alignItems: 'center',
                                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                                          wordBreak: 'break-word',     // Breaks long words
                                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                        }}>
                                                                        {formData?.label || 'None'}
                                                                      </Dropdown.Toggle>
                                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                                        <Dropdown.Item onClick={() => handleAccessoriesOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                          None
                                                                        </Dropdown.Item>
                                                                        {item.material.map((item2, index2) => (
                                                                          <Dropdown.Item
                                                                            key={index2}
                                                                            onClick={() =>
                                                                              handleAccessoriesOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                                    label: item2.label
                                                                                  }
                                                                                },
                                                                                index
                                                                              )
                                                                            }
                                                                          >
                                                                            {item2.label}
                                                                          </Dropdown.Item>
                                                                        ))}

                                                                        <Dropdown.Divider />

                                                                        <div className="px-3 py-2">
                                                                          <Button
                                                                            variant="outline-success"
                                                                            size="sm"
                                                                            onClick={(e) => {
                                                                              e.stopPropagation(); // prevent dropdown from closing
                                                                              handleAddNewItem(item, "Accessories", index); // define this function
                                                                            }}
                                                                          >
                                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                          </Button>
                                                                        </div>
                                                                      </Dropdown.Menu>
                                                                    </Dropdown>
                                                                  </Col>
                                                                  <Col sm={1}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.width === 0 ? "" : formData.width}
                                                                        onChange={(e) => handleAccessoriesChange(e, index, "width")}
                                                                        placeholder="Length"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>
                                                                  <Col sm={1}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.height === 0 ? "" : formData.height}
                                                                        onChange={(e) => handleAccessoriesChange(e, index, "height")}
                                                                        placeholder="Height"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>

                                                                  <Col sm={1}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.depth === 0 ? "" : formData.depth}
                                                                        onChange={(e) => handleAccessoriesChange(e, index, "depth")}
                                                                        placeholder="Depth"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>

                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        type="number"
                                                                        value={formData.price}
                                                                        // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                                        placeholder="Price"
                                                                        disabled={formData.value ? false : true}
                                                    readOnly
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>
                                                                  <Col sm={2}>
                                                                    <Form.Group>
                                                                      <Form.Control
                                                                        value={formData.remark}
                                                                        onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                        as="textarea" rows={1}
                                                                        placeholder="Remark"
                                                                      />
                                                                    </Form.Group>
                                                                  </Col>
                                                                  {renderRowActions(item, index)}
                                                                </Row> : item.measurement == "rft" ?
                                                                  <Row className="hover-row">
                                                                    <Col sm={2}>
                                                                      <Form.Group>
                                                                        <Form.Label
                                                                          style={{
                                                                            fontSize: 16,
                                                                            fontWeight: "500",
                                                                          }}
                                                                        ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                        </Form.Label>
                                                                      </Form.Group>
                                                                    </Col>
                                                                    {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                                    {/* add label option */}
                                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                                      <Dropdown>
                                                                        <Dropdown.Toggle
                                                                          variant="outline-secondary"
                                                                          style={{
                                                                            width: '12vw',
                                                                            backgroundColor: 'white',
                                                                            color: 'black',
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            alignItems: 'center',
                                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                                            wordBreak: 'break-word',     // Breaks long words
                                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                          }}>
                                                                          {formData?.label || 'None'}
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                                          <Dropdown.Item onClick={() => handleAccessoriesOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                            None
                                                                          </Dropdown.Item>
                                                                          {item.material.map((item2, index2) => (
                                                                            <Dropdown.Item
                                                                              key={index2}
                                                                              onClick={() =>
                                                                                handleAccessoriesOptionChange(
                                                                                  {
                                                                                    target: {
                                                                                      value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                                      label: item2.label
                                                                                    }
                                                                                  },
                                                                                  index
                                                                                )
                                                                              }
                                                                            >
                                                                              {item2.label}
                                                                            </Dropdown.Item>
                                                                          ))}

                                                                          <Dropdown.Divider />

                                                                          <div className="px-3 py-2">
                                                                            <Button
                                                                              variant="outline-success"
                                                                              size="sm"
                                                                              onClick={(e) => {
                                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                                handleAddNewItem(item, "Accessories", index); // define this function
                                                                              }}
                                                                            >
                                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                            </Button>
                                                                          </div>
                                                                        </Dropdown.Menu>
                                                                      </Dropdown>
                                                                    </Col>
                                                                    <Col sm={2}>
                                                                      <Form.Group>
                                                                        <Form.Control
                                                                          type="number"
                                                                          value={formData.rft === 0 ? "" : formData.rft}
                                                                          onChange={(e) => handleAccessoriesChange(e, index, "rft")}
                                                                          placeholder="RFT"
                                                                        />
                                                                      </Form.Group>
                                                                    </Col>

                                                                    <Col sm={1}>

                                                                    </Col>

                                                                    <Col sm={2}>
                                                                      <Form.Group>
                                                                        <Form.Control
                                                                          type="number"
                                                                          value={formData.price}
                                                                          // onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                                          placeholder="Price"
                                                                          disabled={formData.value ? false : true}
                                                    readOnly
                                                                        />
                                                                      </Form.Group>
                                                                    </Col>
                                                                    <Col sm={2}>
                                                                      <Form.Group>
                                                                        <Form.Control
                                                                          value={formData.remark}
                                                                          onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                          as="textarea" rows={1}
                                                                          placeholder="Remark"
                                                                        />
                                                                      </Form.Group>
                                                                    </Col>
                                                                    {renderRowActions(item, index)}
                                                                  </Row> : item.measurement == "selection" ?
                                                                    <Row className="hover-row">
                                                                      <Col sm={2}>
                                                                        <Form.Group>
                                                                          <Form.Label
                                                                            style={{
                                                                              fontSize: 16,
                                                                              fontWeight: "500",
                                                                            }}
                                                                          ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                          </Form.Label>
                                                                        </Form.Group>
                                                                      </Col>
                                                                      {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                                      {/* add label option */}
                                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                                        <Dropdown>
                                                                          <Dropdown.Toggle
                                                                            variant="outline-secondary"
                                                                            style={{
                                                                              width: '12vw',
                                                                              backgroundColor: 'white',
                                                                              color: 'black',
                                                                              display: 'flex',
                                                                              justifyContent: 'space-between',
                                                                              alignItems: 'center',
                                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                                              wordBreak: 'break-word',     // Breaks long words
                                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                            }}>
                                                                            {formData?.label || 'None'}
                                                                          </Dropdown.Toggle>
                                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                                            <Dropdown.Item onClick={() => handleAccessoriesOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                              None
                                                                            </Dropdown.Item>
                                                                            {item.material.map((item2, index2) => (
                                                                              <Dropdown.Item
                                                                                key={index2}
                                                                                onClick={() =>
                                                                                  handleAccessoriesOptionChange(
                                                                                    {
                                                                                      target: {
                                                                                        value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                                        label: item2.label
                                                                                      }
                                                                                    },
                                                                                    index
                                                                                  )
                                                                                }
                                                                              >
                                                                                {item2.label}
                                                                              </Dropdown.Item>
                                                                            ))}

                                                                            <Dropdown.Divider />

                                                                            <div className="px-3 py-2">
                                                                              <Button
                                                                                variant="outline-success"
                                                                                size="sm"
                                                                                onClick={(e) => {
                                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                                  handleAddNewItem(item, "Accessories", index); // define this function
                                                                                }}
                                                                              >
                                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                              </Button>
                                                                            </div>
                                                                          </Dropdown.Menu>
                                                                        </Dropdown>
                                                                      </Col>
                                                                      <Col sm={2}>

                                                                      </Col>

                                                                      <Col sm={1}>

                                                                      </Col>

                                                                      <Col sm={2}>

                                                                      </Col>
                                                                      <Col sm={2}>
                                                                        <Form.Group>
                                                                          <Form.Control
                                                                            value={formData.remark}
                                                                            onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                            as="textarea" rows={1}
                                                                            placeholder="Remark"
                                                                          />
                                                                        </Form.Group>
                                                                      </Col>
                                                                      {renderRowActions(item, index)}
                                                                    </Row> : item.measurement == "selection" ?
                                                                      <Row className="hover-row">
                                                                        <Col sm={2}>
                                                                          <Form.Group>
                                                                            <Form.Label
                                                                              style={{
                                                                                fontSize: 16,
                                                                                fontWeight: "500",
                                                                              }}
                                                                            ><h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                            </Form.Label>
                                                                          </Form.Group>
                                                                        </Col>
                                                                        {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                        value={kitchenFormData[index].value}
                                        onChange={(e) => handleKitchenOptionChange(e, index)}
                               

                                        >
                                          <option value="0">None</option>
                                          {item.material.map((item2, index2) => (
                                         <option 
                                           key={index2} 
                                           value={data.priceType=== 'oldvalue' ? item2.oldvalue : item2.value}
                                         >
                                           {item2.label}
                                         </option>
                                       ))}
                                          
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}
                                                                        {/* add label option */}
                                                                        <Col sm={2} style={{ display: 'flex' }}>
                                                                          <Dropdown>
                                                                            <Dropdown.Toggle
                                                                              variant="outline-secondary"
                                                                              style={{
                                                                                width: '12vw',
                                                                                backgroundColor: 'white',
                                                                                color: 'black',
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center',
                                                                                whiteSpace: 'normal',        // Allows text to wrap
                                                                                wordBreak: 'break-word',     // Breaks long words
                                                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                                              }}>
                                                                              {formData?.label || 'None'}
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                                                              <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0', label: 'None' } }, index)}>
                                                                                None
                                                                              </Dropdown.Item>
                                                                              {item.material.map((item2, index2) => (
                                                                                <Dropdown.Item
                                                                                  key={index2}
                                                                                  onClick={() =>
                                                                                    handleOtherOptionChange(
                                                                                      {
                                                                                        target: {
                                                                                          value: data.priceType === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                                          label: item2.label
                                                                                        }
                                                                                      },
                                                                                      index
                                                                                    )
                                                                                  }
                                                                                >
                                                                                  {item2.label}
                                                                                </Dropdown.Item>
                                                                              ))}

                                                                              <Dropdown.Divider />

                                                                              <div className="px-3 py-2">
                                                                                <Button
                                                                                  variant="outline-success"
                                                                                  size="sm"
                                                                                  onClick={(e) => {
                                                                                    e.stopPropagation(); // prevent dropdown from closing
                                                                                    handleAddNewItem(item, "Accessories", index); // define this function
                                                                                  }}
                                                                                >
                                                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                                </Button>
                                                                              </div>
                                                                            </Dropdown.Menu>
                                                                          </Dropdown>
                                                                        </Col>
                                                                        <Col sm={2}>

                                                                        </Col>

                                                                        <Col sm={1}>

                                                                        </Col>

                                                                        <Col sm={2}>

                                                                        </Col>
                                                                        <Col sm={2}>
                                                                          <Form.Group>
                                                                            <Form.Control
                                                                              value={formData.remark}
                                                                              onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                              as="textarea" rows={1}
                                                                              placeholder="Remark"
                                                                            />
                                                                          </Form.Group>
                                                                        </Col>
                                                                        {renderRowActions(item, index)}
                                                                      </Row> : null}
                                                    </div>
                                                  )}
                                                </Draggable>
                                              ))}
                                            {provided.placeholder}
                                          </div>
                                        )}






                                      </Droppable>
                                    </DragDropContext >
                                    <Row>
                                      <Col>

                                        <Row className="mx-1 my-3">
                                          <Col sm={2}>
                                            <Form.Group >
                                              <Form.Control
                                                value={extraItemName}
                                                onChange={(e) => setExtraItemName(e.target.value)}
                                                type="text"
                                                placeholder="Item Name"
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group >
                                              <Form.Control
                                                value={extraItemMaterialName}
                                                onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                                type="text"
                                                placeholder="Material Name"
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group >
                                              <Form.Control
                                                value={extraItemMaterialValue}
                                                onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                                type="number"
                                                placeholder="Material Value"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={3}>
                                            <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                              <option>Select Measurement Type</option>
                                              <option value="area">Area</option>
                                              <option value="width">Width &  Height</option>
                                              <option value="rft">RFT</option>
                                              <option value="qty">Quantity</option>
                                              <option value="length">Width & Length</option>
                                              <option value="selection">Selection</option>
                                            </Form.Select>
                                          </Col>
                                          <Col sm={1}>
                                            {/* <Form.Check
                                                                   inline
                                                                   label="Wood"
                                                                   name="Wood"
                                                                   type="checkbox"
                                                                   id="inline-checkbox-1"
                                                                   checked={isChecked}
                                                                   onChange={handleCheckboxChange}
                                                                 /> */}
                                          </Col>
                                          <Col sm={2}>
                                            <Button onClick={addNewAccessoriesItem}>Add Item</Button>
                                          </Col>
                                        </Row>





                                      </Col>

                                    </Row>
                                  </Form.Group>


                                </Form>
                              </Col>
                            </Row>



                            <Row style={{
                              // marginBottom: '50px',
                              marginLeft: '1px',
                              padding: '20px',
                              borderRadius: '15px',
                              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                              backgroundColor: '#ffffff', // Light background color


                            }} >
                              <Col >
                                <Button className="buttonDesign" style={{ fontSize: 13, width: '20vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveAccessoriesData()} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                              </Col>
                              <Col className="col-sm-3">

                              </Col>
                              <Col className="col-sm-2"><h4>Total Price</h4></Col>
                              <Col className="col-sm-2">
                                {/* <h4>
                                        Rs:- {roomTypePrice}
                
                                      </h4> */}
                                <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{calculateAccessoriesTotal()}</h4></span>
                              </Col>
                            </Row>

                          </Row> : roomTypeModal == 'ExtraItems' ?
                            <Row
                              style={{
                                // marginBottom: '50px',
                                // height:'auto',

                                padding: '20px',
                                // marginLeft: '20px',
                                borderRadius: '15px',
                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                backgroundColor: '#ffff', // Light background color

                              }} >
                              <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Extra items -- </h5><h6 style={{ color: '#e85d13' }}>{data.priceType === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                              <Row style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>
                                <Col style={{ minHeight: 380, maxHeight: 480 }}>

                                  {materialFields.map((field, index) => (
                                    <Row key={index} className="mx-1 my-1">
                                      <Col sm={2}> <Form.Group
                                        className="mb-3"

                                      >

                                        <Form.Label style={{
                                          fontSize: 16,
                                          fontWeight: "500",
                                        }}>Extra items</Form.Label>
                                      </Form.Group></Col>
                                      <Col sm={3}> <Form.Group
                                        className="mb-3"

                                      >

                                        <Form.Control
                                          type="text"
                                          value={field.label}
                                          onChange={(e) => handleFieldChange(e.target.value, index, 'label')}
                                          placeholder="Item Name"
                                          required={false}
                                        />
                                      </Form.Group></Col>
                                      <Col sm={3}> <Form.Group
                                        className="mb-3"

                                      >

                                        <Form.Control
                                          type="number"
                                          value={field.value}
                                          onChange={(e) => handleFieldChange(e.target.value, index, 'value')}
                                          placeholder="Item Price"
                                          required={false}
                                        />
                                      </Form.Group>
                                      </Col>
                                      <Col sm={3}> <Form.Group
                                        className="mb-3"

                                      >

                                        <Form.Control
                                          as="textarea" rows={1}
                                          value={field.remark}
                                          onChange={(e) => handleFieldChange(e.target.value, index, 'remark')}
                                          placeholder="Remark"
                                          required={false}
                                        />

                                      </Form.Group>
                                      </Col>
                                      <Col sm={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', padding: '0 4px', height: '100%' }}>
                                        <Button
                                          variant="outline-danger"
                                          size="sm"
                                          style={{
                                            borderRadius: "50%",
                                            width: "34px",
                                            height: "34px",
                                            minWidth: "34px",
                                            minHeight: "34px",
                                            maxWidth: "34px",
                                            maxHeight: "34px",
                                            padding: 0,
                                            margin: 0,
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "2px solid #dc3545",
                                            color: "#dc3545",
                                            backgroundColor: "#fff",
                                            cursor: "pointer",
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                            flexShrink: 0,
                                            boxSizing: "border-box",
                                            lineHeight: 1
                                          }}
                                          title="Delete item"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleRemoveField(index);
                                          }}
                                        >
                                          <i className="bi bi-x-lg" style={{ fontSize: "15px", lineHeight: 1 }}></i>
                                        </Button>
                                      </Col>
                                      <Col>

                                      </Col>
                                    </Row>
                                  ))}
                                  <Col><Button variant="success" onClick={handleAddField} > Add options <i class="bi bi-plus-circle-fill"></i> </Button></Col>

                                </Col>
                              </Row>


                              <Row style={{
                                // marginBottom: '50px',
                                marginLeft: '1px',
                                padding: '20px',
                                borderRadius: '15px',
                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                backgroundColor: '#ffffff', // Light background color


                              }} >
                                <Col >
                                  <Button className="buttonDesign" style={{ fontSize: 13, width: '20vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveExtraItemsData()} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                                </Col>
                                <Col className="col-sm-3">

                                </Col>
                                <Col className="col-sm-2"><h4>Total Price</h4></Col>
                                <Col className="col-sm-2">
                                  {/* <h4>
                                        Rs:- {roomTypePrice}
                
                                      </h4> */}
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{totalValues()}</h4></span>
                                </Col>
                              </Row>

                            </Row> : null}

          </Row>

        </Col>
      </Row>

    </Container>
  );
}